import { Button, Form, Checkbox, message, Modal, Tabs, Collapse, theme, Divider, Tooltip, InputNumber, Spin, Input, Empty, Alert, Avatar, DatePicker, Upload, Image, Select } from 'antd';
import FedTooltip from '../../components/Tooltip';
import React, { useCallback, useDeferredValue, useEffect, useState } from 'react';
import { CollectionServer, deleteInProperties, errorCatch, GET, GetMetaProperties, getObjectDisplay, IfElse, JSXMap, Model, POST, QueryDetail, QueryOrder, QueryParam, SetMetaProperties, updateInArray, updateInPropertiesUUID, useAuth, useMetaContext, useTranslateContext, useUserContext, Overlay, POSTFormData, makeFormData, deleteInArray, ycStorage } from 'fennec-ui';
import { Action } from 'fennec-ui'
import YImage from '../../../common/YImage';
import dayjs from 'dayjs'
import locale from 'antd/es/date-picker/locale/ru_RU';
import 'dayjs/locale/ru'
import confirmKey from '../../components/ConfirmKeyModal';
import Icofont from 'react-icofont';
import { PlusOutlined, BgColorsOutlined, CalculatorOutlined, CaretRightOutlined, ClearOutlined, DiffOutlined, ExclamationCircleOutlined, FileDoneOutlined, IssuesCloseOutlined, LoadingOutlined, ReloadOutlined, MinusOutlined, FullscreenOutlined, FullscreenExitOutlined, RotateRightOutlined, RotateLeftOutlined } from '@ant-design/icons';
import IzmenitMeropriyatiya from '../../forms/IzmenitMeropriyatiya';
import AdministratorsMeropriyatiya from '../../forms/AdministratorsMeropriyatiya';
import ControllersMeropriyatiya from '../../forms/ControllersMeropriyatiya';
import MainJudgeMeropriyatiya from '../../forms/MainJudgeMeropriyatiya';
import JudgeMeropriyatiya from '../../forms/JudgeMeropriyatiya';
import PresenterMeropriyatiya from '../../forms/PresenterMeropriyatiya';
import DjMeropriyatiya from '../../forms/DjMeropriyatiya';
import KategoriiUchastnikovNaMeropriyatiyakhList from '../../forms/KategoriiUchastnikovNaMeropriyatiyakhList';
import SsilokNaFaili from '../../forms/SsilokNaFaili';
import SsilkiVSotsSetyakhMeropriyatie from '../../forms/SsilkiVSotsSetyakhMeropriyatie';
import TarifTemplate from '../../forms/TarifTemplate';
import UslugiNaMeropriyatii from '../../forms/UslugiNaMeropriyatii';
import DativozvratovNaMeropriyatii from '../../forms/DativozvratovNaMeropriyatii';
import User, { UserName, UserName2Line } from '../../../common/User';
import IzmenitMeropriyatiyaTexts from '../../forms/IzmenitMeropriyatiyaTexts';
import IzmenitMeropriyatiyaAd from '../../forms/IzmenitMeropriyatiyaAd';
import RezultatiPoMeropriyatiu from '../../forms/RezultatiPoMeropriyatiu';
import YacheikiUslugiBlock from '../../components/YacheikiUslugiBlock'
import FilterFieldLabel from '../../components/FilterFieldLabel';
import PromokodiBlock from '../../components/PromokodiBlock'
import ComissionBlock from '../_ComissionBlock'
import { goTo, isAnyFederationAdministrator, eventRoleControler, getIndexColorLighter, ycBucket } from '../../../common/Tool';
import IzmenitMeropriyatiyaGonorar from '../../forms/IzmenitMeropriyatiyaGonorar';
import GonorarBlock from '../GonorarBlock';
import ObjectOwnerDescription from '../../../fedance-ui/ObjectOwnerDescription';
import ObjectVtpDescription from '../../../fedance-ui/ObjectVtpDescription';
import CategoryName from '../CategoryName';
import { title } from '@uiw/react-md-editor';
import uuid from 'react-uuid';
import CopyToClipboard from 'react-copy-to-clipboard';
import EmojiTextArea from '../../../common/EmojiTextArea';
import SpecialguestMeropriyatiya from '../../forms/SpecialguestMeropriyatiya';
import OperatorOBSMeropriyatiya from '../../forms/OperatorOBSMeropriyatiya';
import ChlenKomitetaPoSudeistvuMeropriyatiya from '../../forms/ChlenKomitetaPoSudeistvuMeropriyatiya';
import StreamLogBlock from '../StreamLogBlock';

var _ = require('lodash');

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

function getCurrencyValue(value, color) {
    if (!value) {
        return (<span style={{ color: "grey" }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (color) {
        return (<span style={{ color: color }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (value >= 0) {
        return (<span style={{ color: "rgb(63, 134, 0)" }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (value < 0) {
        return (<span style={{ color: "red" }}>
            {(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
}
function getCurrencyAbsValue(value, color) {
    if (!value) {
        return (<span>
            {/* {Math.abs(Number(0)).toLocaleString('ru', { minimumFractionDigits: 2 })} руб. */}
        </span>)
    }
    if (color) {
        return (<span style={{ color: color }}>
            {Math.abs(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (value >= 0) {
        return (<span style={{ color: "rgb(63, 134, 0)" }}>
            {Math.abs(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
    if (value < 0) {
        return (<span style={{ color: "red" }}>
            {Math.abs(Number(value?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
        </span>)
    }
}
function _head(array) {
    let head = _.head(array);
    return (head) ? [head] : [];
}
function rhead(array, render) {
    if (!array || !array.length) {
        return render(undefined, 0)
    }
    return JSXMap(_head(array), (item, idx) => {
        return (render(item, idx))
    })
}
function OplataRow({ item, idx }) {
    const [collapsed, setCollapsed] = useState(true);

    let Postavka = _.reduce(item?.Postavki, (a, p) => a + ((p?.PostavkaKomissiyaSOrganizatoraNaPartnera?.length) ? p?.Postavka?.usluga?.summa : 0), 0);
    let summaDoPromokoda = _.reduce(item?.Postavki, (a, p) => a + p?.Postavka?.usluga?.summaDoPromokoda, 0);
    let Komissiya = _.reduce(item?.Postavki, (a, p) => a + _.reduce(p?.PostavkaKomissiyaSOrganizatoraNaPartnera, (ao, po) => ao + po?.Komissiya?.summa, 0), 0);
    let OstatokOrganizatoru = (item?.Oplata?.vozvratiOplata && item?.Oplata?.vozvratiOplata.length) ? _.head(item.Oplata.vozvratiOplata).summaOstatka : _.reduce(item?.Postavki, (a, p) => a + p?.OstatokOrganizatoru, 0);

    const summaSVozvratom = (item) => {
        if (item?.Oplata?.vozvratiOplata && item?.Oplata?.vozvratiOplata.length) {
            return (<div>
                <div style={{
                    fontStyle: "italic",
                    color: "rgba(0, 0, 0, 0.45)",
                    textDecoration: "line-through"
                }}>{getCurrencyAbsValue(item.Oplata.summa, "grey")}</div>
                <div>{getCurrencyAbsValue(_.head(item.Oplata.vozvratiOplata).summaOstatka)}</div>
            </div>)
        }
        return (<div>{getCurrencyAbsValue(item?.Oplata?.summa)}</div>)
    }
    const summaSPromokodom = (usluga) => {
        if (usluga?.summaDoPromokoda !== usluga?.summa) {
            return (<div>
                <div style={{
                    fontStyle: "italic",
                    color: "rgba(0, 0, 0, 0.45)",
                    textDecoration: "line-through"
                }}>{getCurrencyAbsValue(usluga?.summaDoPromokoda, "grey")}</div>
                <div>{getCurrencyAbsValue(usluga?.summa)}</div>
            </div>)
        }
        return (<div>{getCurrencyAbsValue(usluga?.summa)}</div>)
    }

    return (<React.Fragment key={idx}>
        <tr key={idx} className={(item?.Postavki?.length > 0) ? 'pointer hover-border' : ""} onClick={() => {
            if (item?.Postavki?.length > 0) {
                setCollapsed(o => !o);
            }
        }}>
            <td className={`fill`}><div className='bg bg-grey' style={{ minWidth: "25px", maxWidth: "25px" }}>
                {(collapsed && item?.Postavki?.length > 0) && <i className="fa fa-plus-square-o"></i>}
                {(!collapsed && item?.Postavki?.length > 0) && <i className="fa fa-minus-square-o"></i>}
            </div></td>
            <td className={`fill`}><div className="bg bg-grey"><User item={item?.Oplata?.zakaz?.polzovatel} /></div></td>
            <td className={`fill`}><div className="bg bg-grey">
                <div>{dayjs(item?.Oplata?.zakaz?.dataZakaza).format("DD.MM.YYYY HH:mm:ss")}</div>
                <div style={{
                    fontStyle: "italic",
                    color: "rgba(0, 0, 0, 0.45)",
                }}>№{item?.Oplata?.zakaz?.nomerZakaza}</div>
            </div></td>
            <td className={`fill`}>
                <div className="bg bg-grey">
                    {summaSVozvratom(item)}
                </div>
            </td>
            <td className={`fill`}><div className="bg bg-grey">{getCurrencyAbsValue(Postavka)}</div></td>
            <td className={`fill`}><div className="bg bg-grey">{getCurrencyAbsValue(Komissiya, "red")}</div></td>
            <td className={`fill`}><div className="bg bg-grey">{getCurrencyAbsValue(OstatokOrganizatoru)}</div></td>
        </tr>
        {(!collapsed && item?.Postavki?.length > 0) && <tr>
            <td colSpan={7} className={`fill`}>
                <div className="bg bg-orange" style={{ textAlign: "left", marginLeft: "25px" }}>
                    <div className='scrollable'>
                        {!Postavka && <table className="table" style={{ fontSize: "13px" }}>
                            <thead>
                                <tr>
                                    <th className={`wrap`} style={{ minWidth: "265px", maxWidth: "265px" }}><div className='bg bg-grey dark-1'>Активности</div></th>
                                    <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Сумма активности</div></th>
                                </tr>
                                <tr className="tr-rounded">
                                    <th className={`wrap`}><div className="bg bg-blue"></div></th>
                                    <th>
                                        <div className="bg bg-blue" style={{ color: "rgb(0 102 134)", textDecoration: (Postavka) ? "underline" : "inherit" }}>
                                            {summaSPromokodom({ summaDoPromokoda: summaDoPromokoda, summa: Postavka })}
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px" }}>
                                {JSXMap(item?.Postavki, (p, pidx) => {
                                    let rowSpan2 = (p?.PostavkaKomissiyaSOrganizatoraNaPartnera?.length) ? p?.PostavkaKomissiyaSOrganizatoraNaPartnera?.length : 1;
                                    return (<React.Fragment key={pidx}>
                                        <tr key={pidx}>
                                            <td className={`fill ellipsis`} rowSpan={rowSpan2}><div className="bg bg-grey">{p?.Postavka?.usluga?.uslugaKlientu?.yacheikaUsluga?.nazvanie}</div></td>
                                            <td className={`fill`} rowSpan={rowSpan2}><div className="bg bg-grey" style={{ color: "rgb(0 102 134)", textDecoration: (p?.PostavkaKomissiyaSOrganizatoraNaPartnera?.length) ? "underline" : "inherit" }}>
                                                {summaSPromokodom(p?.Postavka?.usluga)}
                                            </div></td>
                                        </tr>
                                    </React.Fragment>)
                                })}
                            </tbody>
                        </table>}
                        {!!Postavka && <table className="table" style={{ fontSize: "13px" }}>
                            <thead>
                                <tr>
                                    <th className={`wrap`} rowSpan={2} style={{ minWidth: "265px", maxWidth: "265px" }}><div className='bg bg-grey dark-1'>Активности</div></th>
                                    <th className={`wrap`} rowSpan={2} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Сумма активности</div></th>
                                    <th className={`wrap`} colSpan={3}><div className='bg bg-grey dark-1'>Комиссия партнеру</div></th>
                                    <th className={`wrap`} rowSpan={2} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Остаток организатору</div></th>
                                </tr>
                                <tr>
                                    <th className={`wrap`} style={{ minWidth: "225px", maxWidth: "225px" }}><div className='bg bg-grey dark-1'>Партнер</div></th>
                                    <th className={`wrap`} style={{ minWidth: "85px", maxWidth: "85px" }}><div className='bg bg-grey dark-1'>Процент</div></th>
                                    <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Сумма</div></th>
                                </tr>
                                <tr className="tr-rounded">
                                    <th className={`wrap`}><div className="bg bg-blue"></div></th>
                                    <th><div className="bg bg-blue" style={{ color: "rgb(0 102 134)", textDecoration: (Postavka) ? "underline" : "inherit" }}>{getCurrencyAbsValue(Postavka, (Postavka) ? "rgb(0 102 134)" : undefined)}</div></th>
                                    <th className={`wrap`}><div className="bg bg-blue"></div></th>
                                    <th><div className="bg bg-blue"></div></th>
                                    <th><div className="bg bg-blue">{getCurrencyAbsValue(Komissiya, "red")}</div></th>
                                    <th><div className="bg bg-blue">{getCurrencyAbsValue(OstatokOrganizatoru)}</div></th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px" }}>
                                {JSXMap(item?.Postavki, (p, pidx) => {
                                    let rowSpan2 = (p?.PostavkaKomissiyaSOrganizatoraNaPartnera?.length) ? p?.PostavkaKomissiyaSOrganizatoraNaPartnera?.length : 1;
                                    return (<React.Fragment key={pidx}>
                                        <tr key={pidx}>
                                            <td className={`fill ellipsis`} rowSpan={rowSpan2}><div className="bg bg-grey">{p?.Postavka?.usluga?.uslugaKlientu?.yacheikaUsluga?.nazvanie}</div></td>
                                            <td className={`fill`} rowSpan={rowSpan2}><div className="bg bg-grey" style={{ color: "rgb(0 102 134)", textDecoration: (p?.PostavkaKomissiyaSOrganizatoraNaPartnera?.length) ? "underline" : "inherit" }}>{getCurrencyAbsValue(p?.Postavka?.usluga?.summa, (p?.PostavkaKomissiyaSOrganizatoraNaPartnera?.length) ? "rgb(0 102 134)" : undefined)}</div></td>
                                            {rhead(p?.PostavkaKomissiyaSOrganizatoraNaPartnera, (po, poidx) => {
                                                return (<React.Fragment key={poidx}>
                                                    <td className={`fill ellipsis`}><div className="bg bg-grey">{po?.Komissiya?.partner}</div></td>
                                                    <td className={`fill`}><div className="bg bg-grey">{(po?.Komissiya?.protsent) ? `${po?.Komissiya?.protsent}%` : ""}</div></td>
                                                    <td className={`fill`}><div className="bg bg-grey">{getCurrencyAbsValue(po?.Komissiya?.summa, "red")}</div></td>
                                                </React.Fragment>)
                                            })}
                                            <td className={`fill`} rowSpan={rowSpan2}><div className="bg bg-grey">{getCurrencyAbsValue(p?.OstatokOrganizatoru)}</div></td>
                                        </tr>
                                        {JSXMap(_.tail(p?.PostavkaKomissiyaSOrganizatoraNaPartnera), (po, poidx) => {
                                            return (<React.Fragment key={poidx}>
                                                <tr key={poidx}>
                                                    <td className={`fill ellipsis`}><div className="bg bg-grey">{po?.Komissiya?.partner}</div></td>
                                                    <td className={`fill`}><div className="bg bg-grey">{(po?.Komissiya?.protsent) ? `${po?.Komissiya?.protsent}%` : ""}</div></td>
                                                    <td className={`fill`}><div className="bg bg-grey">{getCurrencyAbsValue(po?.Komissiya?.summa, "red")}</div></td>
                                                </tr>
                                            </React.Fragment>)
                                        })}
                                    </React.Fragment>)
                                })}

                            </tbody>
                        </table>}
                    </div>
                </div>
            </td>
        </tr>}
    </React.Fragment>)
}
function PostavkiRow({ item, idx }) {
    const [collapsed, setCollapsed] = useState(true);
    const summaSVozvratom = (item) => {
        if (item?.Oplata?.vozvratiOplata && item?.Oplata?.vozvratiOplata.length) {
            return (<div>
                <div style={{
                    fontStyle: "italic",
                    color: "rgba(0, 0, 0, 0.45)",
                    textDecoration: "line-through"
                }}>{getCurrencyAbsValue(item.Oplata.summa, "grey")}</div>
                <div>{getCurrencyAbsValue(_.head(item.Oplata.vozvratiOplata).summaOstatka)}</div>
            </div>)
        }
        return (<div>{getCurrencyAbsValue(item?.Oplata?.summa)}</div>)
    }
    return (<React.Fragment key={idx}>
        <tr key={idx} className={'pointer'} onClick={() => {
            setCollapsed(o => !o);
        }}>
            <td className={`fill`}><div className='bg bg-grey' style={{ minWidth: "25px", maxWidth: "25px" }}>
                {(collapsed) && <i className="fa fa-plus-square-o"></i>}
                {(!collapsed) && <i className="fa fa-minus-square-o"></i>}
            </div></td>
            <td className={`fill`}>
                <div className="bg bg-grey" style={{ textAlign: "left" }}>
                    <div>{item?.Account?.accountInfo?.vladelets}</div>
                    <div style={{
                        fontStyle: "italic",
                        color: "rgba(0, 0, 0, 0.45)",
                    }}>№{item?.Account?.nomerAkkaunta}</div>
                </div>
            </td>
            <td className={`fill`}><div className="bg bg-grey">{getCurrencyAbsValue(item?.Summa, "red")}</div></td>
        </tr>
        {(!collapsed) && <tr>
            <td colSpan={3} className={`fill`}>
                <div className="bg bg-orange" style={{ textAlign: "left", marginLeft: "25px" }}>
                    <div className='scrollable'>
                        <table className="table" style={{ fontSize: "13px" }}>
                            <thead>
                                <tr>
                                    <th className={`wrap`} rowSpan={2} style={{ minWidth: "265px", maxWidth: "265px" }}><div className='bg bg-grey dark-1'>Активность</div></th>
                                    <th className={`wrap`} rowSpan={2} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Сумма активности</div></th>
                                    <th className={`wrap`} rowSpan={2} style={{ minWidth: "265px", maxWidth: "265px" }}><div className='bg bg-grey dark-1'>ФИО участников</div></th>
                                    <th className={`wrap`} rowSpan={2} style={{ minWidth: "130px", maxWidth: "130px" }}><div className='bg bg-grey dark-1'>
                                        <div>Дата/время</div>
                                        <div style={{
                                            fontStyle: "italic",
                                            color: "rgba(0, 0, 0, 0.45)",
                                        }}>№ заказа</div>
                                    </div></th>
                                    <th className={`wrap`} rowSpan={2} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Сумма заказа</div></th>
                                    <th className={`wrap`} rowSpan={2} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Сумма с которой агентские</div></th>
                                    <th className={`wrap`} colSpan={3}><div className='bg bg-grey dark-1'>Комиссия партнеру</div></th>
                                </tr>
                                <tr>
                                    <th className={`wrap`} style={{ minWidth: "325px", maxWidth: "325px" }}><div className='bg bg-grey dark-1'>Комиссия</div></th>
                                    <th className={`wrap`} style={{ minWidth: "85px", maxWidth: "85px" }}><div className='bg bg-grey dark-1'>Процент</div></th>
                                    <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Сумма</div></th>
                                </tr>
                                <tr className="tr-rounded">
                                    <th className={`wrap`}><div className="bg bg-blue"></div></th>
                                    <th><div className="bg bg-blue">{getCurrencyAbsValue(item?.Summa, "red")}</div></th>

                                    <th className={`wrap`}><div className="bg bg-blue"></div></th>
                                    <th className={`wrap`}><div className="bg bg-blue"></div></th>
                                    <th className={`wrap`}><div className="bg bg-blue"></div></th>
                                    <th><div className="bg bg-blue"></div></th>

                                    <th className={`wrap`}><div className="bg bg-blue"></div></th>
                                    <th><div className="bg bg-blue"></div></th>
                                    <th><div className="bg bg-blue">{getCurrencyAbsValue(item?.Summa, "red")}</div></th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px" }}>
                                {JSXMap(item?.YacheikiUslugiData, (p, pidx) => {
                                    let rowSpan2 = (p?.PostavkaKomissiyaSOrganizatoraNaPartneraData?.length) ? p?.PostavkaKomissiyaSOrganizatoraNaPartneraData?.length : 1;
                                    return (<React.Fragment key={pidx}>
                                        <tr key={pidx}>
                                            <td className={`fill ellipsis`} rowSpan={rowSpan2}><div className="bg bg-grey">{p?.YacheikaUslugi?.nazvanie}</div></td>
                                            <td className={`fill`} rowSpan={rowSpan2}><div className="bg bg-grey">{getCurrencyAbsValue(p?.Summa, "red")}</div></td>

                                            {rhead(p?.PostavkaKomissiyaSOrganizatoraNaPartneraData, (po, poidx) => {
                                                return (<React.Fragment key={poidx}>
                                                    <td className={`fill ellipsis`}>
                                                        <div className="bg bg-grey">
                                                            {po?.Postavka?.usluga?.polzovatelID && <User item={po?.Postavka?.usluga?.polzovatel} />}
                                                            {!po?.Postavka?.usluga?.polzovatelID && po?.Postavka?.usluga?.polzovatelStrokoi}
                                                        </div>
                                                    </td>

                                                    <td className={`fill`}><div className="bg bg-grey">
                                                        <div>{dayjs(po?.Oplata?.zakaz?.dataZakaza).format("DD.MM.YYYY HH:mm:ss")}</div>
                                                        <div style={{
                                                            fontStyle: "italic",
                                                            color: "rgba(0, 0, 0, 0.45)",
                                                        }}>№{po?.Oplata?.zakaz?.nomerZakaza}</div>
                                                    </div></td>

                                                    <td className={`fill`}>
                                                        <div className="bg bg-grey">
                                                            {summaSVozvratom(po)}
                                                        </div>
                                                    </td>

                                                    <td className={`fill`}>
                                                        <div className="bg bg-grey">
                                                            {getCurrencyAbsValue(po?.Postavka?.usluga?.summa)}
                                                        </div>
                                                    </td>

                                                    <td className={`fill`} style={{ whiteSpace: "break-spaces" }}><div className="bg bg-grey" style={{ textAlign: "left" }}>{po?.PostavkaKomissiyaSOrganizatoraNaPartnera?.opisanie}</div></td>
                                                    <td className={`fill`}><div className="bg bg-grey">{(po?.PostavkaKomissiyaSOrganizatoraNaPartnera?.protsent) ? `${po?.PostavkaKomissiyaSOrganizatoraNaPartnera?.protsent}%` : ""}</div></td>
                                                    <td className={`fill`}><div className="bg bg-grey">{getCurrencyAbsValue(po?.PostavkaKomissiyaSOrganizatoraNaPartnera?.summa, "red")}</div></td>
                                                </React.Fragment>)
                                            })}
                                        </tr>
                                        {JSXMap(_.tail(p?.PostavkaKomissiyaSOrganizatoraNaPartneraData), (po, poidx) => {
                                            return (<React.Fragment key={poidx}>
                                                <tr key={poidx}>
                                                    <td className={`fill ellipsis`}>
                                                        <div className="bg bg-grey">
                                                            {po?.Postavka?.usluga?.polzovatelID && <User item={po?.Postavka?.usluga?.polzovatel} />}
                                                            {!po?.Postavka?.usluga?.polzovatelID && po?.Postavka?.usluga?.polzovatelStrokoi}
                                                        </div>
                                                    </td>

                                                    <td className={`fill`}><div className="bg bg-grey">
                                                        <div>{dayjs(po?.Oplata?.zakaz?.dataZakaza).format("DD.MM.YYYY HH:mm:ss")}</div>
                                                        <div style={{
                                                            fontStyle: "italic",
                                                            color: "rgba(0, 0, 0, 0.45)",
                                                        }}>№{po?.Oplata?.zakaz?.nomerZakaza}</div>
                                                    </div></td>

                                                    <td className={`fill`}>
                                                        <div className="bg bg-grey">
                                                            {summaSVozvratom(po)}
                                                        </div>
                                                    </td>

                                                    <td className={`fill`}>
                                                        <div className="bg bg-grey">
                                                            {getCurrencyAbsValue(po?.Postavka?.usluga?.summa)}
                                                        </div>
                                                    </td>

                                                    <td className={`fill`} style={{ whiteSpace: "break-spaces" }}><div className="bg bg-grey" style={{ textAlign: "left" }}>{po?.PostavkaKomissiyaSOrganizatoraNaPartnera?.opisanie}</div></td>
                                                    <td className={`fill`}><div className="bg bg-grey">{(po?.PostavkaKomissiyaSOrganizatoraNaPartnera?.protsent) ? `${po?.PostavkaKomissiyaSOrganizatoraNaPartnera?.protsent}%` : ""}</div></td>
                                                    <td className={`fill`}><div className="bg bg-grey">{getCurrencyAbsValue(po?.PostavkaKomissiyaSOrganizatoraNaPartnera?.summa, "red")}</div></td>
                                                </tr>
                                            </React.Fragment>)
                                        })}
                                    </React.Fragment>)
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </td>
        </tr>}
    </React.Fragment>)
}
function AkkauntRow({ item, idx, account }) {
    const [collapsed, setCollapsed] = useState(true);

    const isPlus = (item?.dvizhenieDeneg?.ukhodID != account.ID) && (!item?.dvizhenieDeneg?.ukhodID);
    const isMinus = (item?.dvizhenieDeneg?.prikhodID != account.ID) && (!item?.dvizhenieDeneg?.ukhodID);
    const rowColor = (isPlus) ? "bg-green" : (isMinus) ? "bg-red" : "bg-grey";

    return (<React.Fragment key={idx}>
        <tr key={idx} className={'pointer'} onClick={() => {
            setCollapsed(o => !o);
        }}>
            <td className={`fill`}><div className={`bg ${rowColor}`} style={{ minWidth: "25px", maxWidth: "25px" }}>
                {(collapsed) && <i className="fa fa-plus-square-o"></i>}
                {(!collapsed) && <i className="fa fa-minus-square-o"></i>}
            </div></td>
            <td className={`fill`}>
                <div className={`bg ${rowColor}`}>
                    <div>{dayjs(item?.dataVremya).format("DD.MM.YYYY HH:mm:ss")}</div>
                    {/* <div style={{
                        fontStyle: "italic",
                        color: "rgba(0, 0, 0, 0.45)",
                    }}>№{item?.Oplata?.zakaz?.nomerZakaza}</div> */}
                </div>
            </td>
            <td className={`fill`}><div className={`bg ${rowColor}`}>{getCurrencyValue(item?.summaDoOperatsii)}</div></td>
            <td className={`fill`}><div className={`bg ${rowColor}`}>{getCurrencyValue(item?.summaOperatsii)}</div></td>
            <td className={`fill`}><div className={`bg ${rowColor}`}>{getCurrencyValue(item?.summaPosleOperatsii)}</div></td>
        </tr>
        {(!collapsed) && <tr>
            <td colSpan={5} className={`fill`}>
                <div className="bg bg-orange" style={{ textAlign: "left", marginLeft: "25px" }}>

                    <div style={{ fontWeight: "300", fontSize: "12px", fontStyle: "italic" }}>
                        <span style={{ fontWeight: "400", fontSize: "12px" }}>
                            {(item?.dvizhenieDeneg?.ukhodID == account.ID) && <Icofont icon="user-alt-3" />}
                            {(item?.dvizhenieDeneg?.ukhodID != account.ID) && ((item?.dvizhenieDeneg?.ukhodID) ? <span>
                                {/* №{item?.dvizhenieDeneg?.ukhodNomer} */}
                                {item?.dvizhenieDeneg?.ukhodVladelets}
                            </span> : "Зачисление денежных средств")}
                        </span>
                        <Icofont icon="long-arrow-right" />
                        <span style={{ fontWeight: "400", fontSize: "12px" }}>
                            {(item?.dvizhenieDeneg?.prikhodID == account.ID) && <Icofont icon="user-alt-3" />}
                            {(item?.dvizhenieDeneg?.prikhodID != account.ID) && ((item?.dvizhenieDeneg?.ukhodID) ? <span>
                                {/* №{item?.dvizhenieDeneg?.prikhodNomer} */}
                                {item?.dvizhenieDeneg?.prikhodVladelets}
                            </span> : "Вывод денежных средств")}
                        </span>
                    </div>
                    <div style={{ fontWeight: "300" }}>
                        {item?.dvizhenieDeneg?.opisanie}
                    </div>
                    <div style={{ fontWeight: "300" }}>
                        {item?.dvizhenieDeneg?.comment}
                    </div>
                </div>
            </td>
        </tr>}
    </React.Fragment>)
}
function EventParameters(props) {
    const { auth, sourceKey, form, event, updateEvent } = props;
    const items = [
        {
            key: '1',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Начальные параметры мероприятия</div>,
            children: <div>
                {event?.ID && <Action
                    auth={auth}
                    okText="Сохранить"

                    action={updateEvent}

                    object={event}
                    disabledOkOnUncahngedForm={true}
                    form={IzmenitMeropriyatiya}
                    sourceKey={sourceKey}
                    mode={"inline"}
                />}
            </div>,
        },
        // {
        //     key: '2',
        //     label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Применяемые гонорары и агентские</div>,
        //     children: <div>
        //         {event?.ID && <Action
        //             auth={auth}
        //             okText="Сохранить"

        //             action={updateEvent}

        //             object={event}
        //             disabledOkOnUncahngedForm={true}
        //             form={IzmenitMeropriyatiyaGonorar}
        //             sourceKey={sourceKey}
        //             mode={"inline"}
        //         />}
        //     </div>,
        // },
        {
            key: '3',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Категории участников соревнований мероприятия</div>,
            children: <div>
                {(event?.ID) && <KategoriiUchastnikovNaMeropriyatiyakhList auth={auth} object={event} updateEvent={updateEvent} sourceKey={sourceKey} create={true} />}
            </div>,
        },
        {
            key: '4',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Файлы, отображаемые на странице мероприятия</div>,
            children: <div>{(event?.ID) && <SsilokNaFaili auth={auth} object={event} updateEvent={updateEvent} sourceKey={sourceKey} create={true} />}</div>,
        },
        {
            key: '5',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Ссылки, отображаемые на странице мероприятия</div>,
            children: <div>{(event?.ID) && <SsilkiVSotsSetyakhMeropriyatie auth={auth} object={event} updateEvent={updateEvent} sourceKey={sourceKey} create={true} />}</div>,
        },
    ];
    const { token } = theme.useToken();
    return <div>
        <Collapse
            bordered={false}
            defaultActiveKey={['1']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            style={{
                background: token.colorBgContainer,
            }}
            ghost items={items} />
    </div>
}
function EventTexts(props) {
    const { auth, sourceKey, form, event, updateEvent } = props;
    const { token } = theme.useToken();
    const items = [
        {
            key: '3',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Даты возвратов</div>,
            children: <DativozvratovNaMeropriyatii auth={auth} object={event} sourceKey={sourceKey} queryFilterContext={undefined} />,
        },
    ];
    return <div>
        <div>
            {event?.ID && <div>
                <Action
                    auth={auth}
                    okText="Сохранить"

                    action={updateEvent}

                    object={event}
                    disabledOkOnUncahngedForm={true}
                    form={IzmenitMeropriyatiyaTexts}
                    sourceKey={sourceKey}
                    mode={"inline"}
                />
                <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                    style={{
                        background: token.colorBgContainer,
                    }}
                    ghost items={items} />
            </div>}
        </div>
    </div>
}
function EventGonorar(props) {
    const { auth, sourceKey, form, event, updateEvent } = props;
    return <div>
        <div>
            {event?.ID && <Action
                auth={auth}
                okText="Сохранить"

                action={updateEvent}

                object={event}
                disabledOkOnUncahngedForm={true}
                form={IzmenitMeropriyatiyaGonorar}
                sourceKey={sourceKey}
                mode={"inline"}
            />}
        </div>
    </div>
}

function AdFiles(props) {
    const { auth, sourceKey, form, event, updateEvent } = props;

    const filters = () => [
        {
            name: "opisanie",
            sort: true,
            filter: true,
        },
        {
            label: "Дата создания",
            name: "createdAt",
            type: "date",
            sort: true,
            filter: true,
        }
    ];
    const render = (item, idx, { setCollection, setCollectionItem, update }) => {
        return (<div key={idx} style={{ padding: "10px 0px", width: "100%", borderTop: "1px solid #eee" }}>
            <div style={{ display: "flex", gap: "5px" }}>
                <div style={{ flex: "0 0" }}>
                    {item?.file?.fileType?.groupe == "image" && <YImage image={item?.file?.path} minimage={item?.file?.path} width={78} />}
                    {item?.file?.fileType?.groupe == "video" && <video src={ycStorage(auth) + ycBucket(auth) + "/" + item?.file?.path} style={{ width: "78px" }}></video>}
                </div>
                <div style={{ flex: "1 1 auto" }}>
                    <div>
                        {item.opisanie}
                    </div>
                </div>
            </div>
        </div>)
    }

    // POST "/api/reklama/new"
    // POST "/api/reklama/update"
    // "/api/reklama/delete/{id}"
    // "/api/reklama/bymeropriyatieid/{id}"
    // "/api/reklama/byid/{id}"
    // "/api/reklama/federation-list"


    // const ctx = { meropriyatieID: event?.ID }
    const _collectionActions = useCallback(() => ([
        {
            // isFormData: true,
            // modify: (values) => {
            //     return makeFormData({ ...values, ...((event) ? { meropriyatieID: event?.ID } : {}) })
            // },
            action: (values, unlock, close, { collection, setCollection }) => {
                POSTFormData(auth, `/api/reklama/new`, makeFormData({ ...values, ...((event) ? { meropriyatieID: event?.ID } : {}) }),
                    ({ data }) => {
                        setCollection(updateInArray(collection, data));
                        close();
                    },
                    (err) => errorCatch(err, unlock));
            },
            form: Model,
            meta: [
                {
                    label: "Описание",
                    name: "opisanie",
                    type: "text",
                },
                {
                    label: "Файл",
                    name: "file",
                    type: "file",
                }
            ],
            options: {
                initialValues: {},
            },
            title: "Добавить рекламу в OBS",
            modal: {
                width: "600px",
                title: "Новая реклама в OBS",
            }
        }
    ]), [event?.ID])
    const _modelActions = useCallback((item) => [
        {
            // isFormData: true,
            // modify: (values) => {
            //     return { ...values, ID: item.ID, ...((event) ? { meropriyatieID: event?.ID } : {}) }
            // },
            action: (values, unlock, close, { collection, setCollection }) => {
                POSTFormData(auth, `/api/reklama/update`, makeFormData({ ...values, ID: item.ID, ...((event) ? { meropriyatieID: event?.ID } : {}) }),
                    ({ data }) => {
                        setCollection(updateInArray(collection, data));
                        close();
                    },
                    (err) => errorCatch(err, unlock));
            },
            object: item,
            form: Model,
            meta: [
                {
                    label: "Описание",
                    name: "opisanie",
                    type: "text",
                },
                {
                    type: "func",
                    render: (auth, item, { data, object, contextObject, funcStat }) => {
                        if (!object || !object?.file) return (<React.Fragment></React.Fragment>);

                        return (<div style={{ display: "flex", alignContent: "center", alignItems: "center", justifyContent: "center" }}>
                            {object?.file?.fileType?.groupe == "image" && <YImage image={object?.file?.path} minimage={object?.file?.path} width={385} />}
                            {object?.file?.fileType?.groupe == "video" && <video controls src={ycStorage(auth) + ycBucket(auth) + "/" + object?.file?.path} style={{ width: "385px" }}></video>}
                        </div>)
                    }
                },
                {
                    label: "Файл",
                    name: "file",
                    type: "file",
                }
            ],
            options: {
                initialValues: {},
            },
            title: "Изменить",
            modal: {
                width: "450px",
                title: <div>
                    <div>Изменить рекламу</div>
                    {/* <div style={{ fontSize: "14px" }}>{object?.nazvanie} {(object?.sezon?.nazvanie) ? "(" + object?.sezon?.nazvanie + ")" : ""}</div> */}
                </div>
            }
        },
        {
            title: <span style={{ color: "red" }}>Удалить</span>,
            action: (values, unlock, close, { collection, setCollection }) => {
                Modal.confirm({
                    title: `Вы уверены что хотите удалить рекламу?`,
                    icon: <ExclamationCircleOutlined />,
                    content: <span>{item.opisanie}</span>,
                    okText: "Да",
                    okType: 'danger',
                    cancelText: "Нет",
                    onOk: () => {
                        GET(auth, `/api/reklama/delete/${item.ID}`,
                            () => {
                                setCollection(deleteInArray(collection, item))
                            }, errorCatch
                        );
                    },
                });
            },
        }
    ], [event?.ID])

    return (
        <div style={{ padding: "15px 10px", backgroundColor: "white" }}>
            <CollectionServer
                name={"Reklama"}
                auth={auth}
                size="small"

                source={`/api/reklama/bymeropriyatieid/${event?.ID}`}
                filters={filters}

                mode={"list"}
                render={render}

                collectionActions={_collectionActions}
                modelActions={_modelActions}
            />
        </div>
    );
}

function EventAd(props) {
    const { auth, sourceKey, form, event, updateEvent } = props;
    return <div>
        <div>
            {event?.ID && <Action
                auth={auth}
                okText="Сохранить"

                action={updateEvent}

                object={event}
                disabledOkOnUncahngedForm={true}
                form={IzmenitMeropriyatiyaAd}
                sourceKey={sourceKey}
                mode={"inline"}
            />}
        </div>
        <AdFiles {...props} />
    </div>
}
function Yacheiki(props) {
    const { auth, sourceKey, form, event, updateEvent } = props;
    return <div>
        <div>
            {event?.ID && <YacheikiUslugiBlock {...props} source={`/api/yacheikiuslugi/list/meropriyatie/${event.ID}`}
                queryDetail="model"
                sourceKey={sourceKey}
                create={true}
                event={event}
            // context={{
            //     mix: (item) => {
            //         return {
            //             meropriyatieID: event.ID,
            //         }
            //     }
            // }}
            />}
        </div>
    </div>
}
function Promokodi(props) {
    const { auth, sourceKey, form, event, updateEvent } = props;
    return <div>
        <div>
            {event?.ID && <PromokodiBlock {...props} source={`/api/promokodi/list/meropriyatie/${event.ID}?detail=model`}
                sourceKey={sourceKey}
                create={true}
                event={event}
            // context={{
            //     mix: (item) => {
            //         return {
            //             meropriyatieID: event.ID,
            //         }
            //     }
            // }}
            />}
        </div>
    </div>
}
function Comission(props) {
    const { auth, sourceKey, form, event, updateEvent } = props;
    return <div>
        <div>
            {event?.ID && <ComissionBlock {...props} source={`/api/komissiipartneram/list/meropriyatie/${event.ID}?detail=model`}
                sourceKey={sourceKey}
                create={true}
                event={event}
            // context={{
            //     mix: (item) => {
            //         return {
            //             meropriyatieID: event.ID,
            //         }
            //     }
            // }}
            />}
        </div>
    </div>
}

export const BoolCell = (props) => {
    const { value: initialValue, onChange, style, disabled, colorClass } = props;
    const [value, setValue] = React.useState(initialValue);
    const [lastError, setLastError] = React.useState();
    const onError = (e) => {
        if (initialValue != value) {
            setLastError(e);
        }
    };
    React.useEffect(() => {
        setLastError(undefined);
    }, [value]);
    React.useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    if (!disabled) {
        return (
            <div style={{ height: "100%" }} onClick={(e) => {
                e.preventDefault();
                onChange(!value, onError)
            }}>
                <div className={`bg ${colorClass} pointer dark-1`} style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center", width: "100%", ...style }}>
                    <div>{(value) ? "Да" : "Нет"}</div>
                </div>
                {lastError && <div style={{
                    position: "absolute",
                    top: "2px",
                    left: "3px",
                    fontSize: "14px"
                }}>
                    {<Tooltip title={(lastError && lastError.message) ? lastError.message : ""}><Icofont icon="exclamation" style={{ color: "red" }} /></Tooltip>}
                </div>}
            </div>
        )
    }
    return (<div className={`bg ${colorClass} dark-1`} style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center", width: "100%", ...style }}>
        <div>{(initialValue) ? "Да" : "Нет"}</div>
    </div>);
};
export const FloatCell = (props) => {
    const { value: initialValue, onChange, style, disabled, colorClass, min, max, step } = props;
    const [value, setValue] = React.useState(initialValue);
    const [lastError, setLastError] = React.useState();
    const onError = (e) => {
        if (initialValue != value) {
            setLastError(e);
        }
    };
    const onEnter = () => {
        onChange(value, onError);
    };
    const onBlur = () => {
        if (initialValue != value) {
            onChange(value, onError);
        }
    };
    React.useEffect(() => {
        setLastError(undefined);
    }, [value]);
    React.useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    const stateClass = () => {
        if (initialValue != value) {
            if (lastError) {
                return "error";
            }
            return "warning";
        }
        return ""
    };
    if (!disabled) {
        return (
            <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center", width: "100%", ...style }} onClick={(e) => { e.preventDefault() }}>
                <div style={{ height: "100%", position: "relative", width: "100%" }}>
                    <InputNumber
                        step={step || 0.01}
                        min={min || 0}
                        max={max || Float64Array.MAX_VALUE}
                        className={`bg ${colorClass} pointer ${stateClass()} input-cell`}
                        value={value}
                        onChange={v => {
                            setValue((v) ? v : undefined);
                        }}
                        placeholder=""
                        style={{ height: "100%", fontSize: "12px", textAlign: "center", cursor: "pointer", padding: "0px" }}
                        onBlurCapture={onBlur}
                        onPressEnter={onEnter}
                    />
                    {lastError && <div style={{
                        position: "absolute",
                        top: "2px",
                        left: "3px",
                        fontSize: "14px"
                    }}>
                        {<Tooltip title={(lastError && lastError.message) ? lastError.message : ""}><Icofont icon="exclamation" style={{ color: "red" }} /></Tooltip>}
                    </div>}
                </div>
            </div>
        )
    }
    return (<div className={`bg ${colorClass} dark-1`} style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center", width: "100%", ...style }}>
        <div>
            {initialValue}
        </div>
    </div>);
};

export function Value({ value, protocolValueTypeID, criterion, onChange, disabled, colorClass }) {
    if (protocolValueTypeID === 1) {
        if (!disabled) {
            return (
                <>
                    <Select style={{ width: "100%", textAlign: "center", padding: 0, }} allowClear
                        className={`bg ${colorClass} pointer input-cell`}
                        disabled={disabled}
                        value={(value) ? (value) : undefined}
                        variant='borderless'
                        onChange={onChange}>
                        <Select.Option value={1}><PlusOutlined /></Select.Option>
                        <Select.Option value={-1}><MinusOutlined /></Select.Option>
                    </Select>
                </>
            );
        } else {
            return (
                <>
                    <div style={{
                        width: "100%", textAlign: "center", padding: 0,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                        className={`bg ${colorClass}`}>
                        {(value == 1) ? <PlusOutlined /> : <></>}
                        {(value == -1) ? <MinusOutlined /> : <></>}
                    </div>
                </>
            );
        }

    } else {
        var arr = [];
        var step = criterion.step || 1;
        step = Math.round(step * 100) / 100
        var val = step;
        while (val <= criterion.maxScoreValue) {
            arr.push(val);
            val += step;
            val = Math.round(val * 100) / 100
        }

        if (!disabled) {
            return (
                <>
                    <Select style={{ width: "100%", textAlign: "center", padding: 0, }} allowClear
                        className={`bg ${colorClass} pointer input-cell`}
                        disabled={disabled}
                        value={(value) ? (value) : undefined}
                        variant='borderless'
                        onChange={onChange}>
                        {arr.map((item, idx) => <Select.Option key={idx} value={item}>{item}</Select.Option>)}
                        {/* Array.apply(null, {length: criterion.maxScoreValue}).map(Number.call, Number) */}
                    </Select>
                </>
            );
        } else {
            return (
                <>
                    <div style={{
                        width: "100%", textAlign: "center", padding: 0,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                        className={`bg ${colorClass}`}>
                        {value}
                    </div >
                </>
            );
        }

    }

}

const PlusMinus = (val) => {
    switch (val) {
        case 1:
            return (<Icofont icon="plus" style={{ fontSize: "14px" }} />);
        case -1:
            return (<Icofont icon="minus" style={{ fontSize: "16px", fontWeight: "600" }} />);
        default:
            return (<></>);
    }
};

function OtchetSudeiskogoKomitetaRow({ item, proveryaushie, idx, eventID, disabled, disabled2, renderProps }) {
    const [collapsed, setCollapsed] = useState(true);
    const auth = useAuth()
    const {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    } = renderProps;

    const FilterFromContextFilter = React.useCallback(() => [
        QueryParam("f-sum-summaVGonorare", 0),
        // QueryParam("f-sum-usluga.summa", 0),
        // QueryParam("f-sum-usluga.summaDoPromokoda", 0),
        // QueryParam("f-sum-summaNaNakopitelnii", 0),
        // QueryParam("f-sum-summaNaTekushchii", 0),
    ], [item, idx, eventID, disabled, disabled2]);
    const filters = () => [
        {
            name: "usluga.polzovatel.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "usluga.polzovatel.firstname",
            sort: true,
            filter: true,
        },
        // {
        //     name: "usluga.polzovatel.patronymic",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "usluga.polzovatel.email",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: <span>Телефон<span style={{
        //         fontStyle: "italic",
        //         fontSize: "11px",
        //         paddingLeft: "5px",
        //         color: "#818181"
        //     }}>(без +)</span></span>,
        //     name: "usluga.polzovatel.phone",
        //     // type: "string",
        //     sort: true,
        //     filter: true,
        // },
        {
            name: "usluga.polzovatel.gender",
            sort: true,
            filter: true,
        },
        {
            label: <FilterFieldLabel label="Услуга" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
            name: "usluga.uslugaKlientu.yacheikaUsluga.nazvanie",
            // queryComparer:"swsim", // sim, wsim, swsim
            sort: true,
            filter: true,
        },
        {
            label: "Категория",
            name: "usluga.kategoriya.kategoriya",
            source: `/api/meropriyatiya/kategoriiuchastnikovnameropriyatiyakh/list/${eventID}`,
            displayString: (item) => {
                return item?.tantsevalnayaDistsiplinaPsevdonim + ", " + item?.kategoriyaUchastnikovPsevdonim
            },
            display: (item) => {
                return <CategoryName category={item} style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }} />
            },
            queryFilter: [
                QueryDetail("model"),
                // QueryParam("w-meropriyatie", eventID),
                QueryOrder("tantsevalnayaDistsiplinaPsevdonim", "ASC"),
                QueryOrder("kategoriyaUchastnikovPsevdonim", "ASC")
            ],
            sort: true,
            filter: true
        },
        {
            label: "Сумма",
            name: "summaVGonorare",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
    ];
    const render = (items, {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    }) => {
        const summaVGonorare = lastFuncStat?.summavgonorare?.sum || 0;
        return (<div>
            <Spin spinning={loading} tip="Загрузка...">
                <div className='scrollable' style={{ /*backgroundColor: "white"*/ }}>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr>
                                <th className={`fixed height-8`} style={{ minWidth: "180px", }}>
                                    <div className='bg bg-grey dark-1'>Услуга</div>
                                </th>

                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey dark-1">
                                        Сумма в гонораре
                                    </div>
                                </th>

                                <th className={`height-8`} style={{ minWidth: "100px" }}>
                                    <div className='bg bg-grey dark-1'>Сумма</div>
                                </th>
                                <th className={`height-8`} style={{ minWidth: "100px" }}>
                                    <div className='bg bg-grey dark-1'>Сумма до промокода</div>
                                </th>
                            </tr>
                            <tr>
                                <th className={`fixed height-4`} style={{ minWidth: "180px", }}>
                                    <div className='bg bg-grey dark-1'></div>
                                </th>

                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма в гонораре */}
                                        {(Number(summaVGonorare.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>

                                <th className={`height-4`} style={{ minWidth: "100px", }}>
                                    <div className='bg bg-grey dark-1'></div>
                                </th>
                                <th className={`height-4`} style={{ minWidth: "100px", }}>
                                    <div className='bg bg-grey dark-1'></div>
                                </th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(items || [], (item, cidx) => {
                                return (<tr key={cidx}>
                                    <td className={`fixed ${(item?.usluga?.kategoriya) ? "height-8" : "height-6"}`} style={{ minWidth: "180px" }}>
                                        <div>
                                            <div>{item?.usluga?.uslugaKlientu?.yacheikaUsluga?.nazvanie}</div>
                                            <div style={{
                                                filter: "grayscale(0.1)", opacity: "0.6",
                                                textAlign: "left",
                                                textWrap: "nowrap",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                fontSize: "12px",
                                                fontWeight: "lighter"
                                            }}>
                                                {item?.usluga?.kategoriya && <div style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}>
                                                    <CategoryName category={item?.usluga?.kategoriya?.kategoriya} style={{
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                    }} />
                                                </div>}
                                                <UserName item={item?.usluga?.polzovatel} noborder={true} />
                                            </div>
                                            {/* <UserName item={item?.usluga?.polzovatel} noborder={true} />
                                            <div style={{
                                                color: "rgba(0, 0, 0, 0.45)",
                                                textAlign: "left",
                                                textWrap: "nowrap",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                fontSize: "12px",
                                                fontWeight: "lighter",
                                                paddingLeft: "20px"
                                            }}>
                                                <span>{item?.vtp?.tipPolzovatelya?.opisanie}</span>
                                            </div> */}
                                        </div>
                                    </td>
                                    <td className={`${(item?.usluga?.kategoriya) ? "height-8" : "height-6"}`} style={{ minWidth: "100px" }}>
                                        <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.summaVGonorare?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>

                                    <td className={`${(item?.usluga?.kategoriya) ? "height-8" : "height-6"}`} style={{ minWidth: "100px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.usluga?.summa?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                    <td className={`${(item?.usluga?.kategoriya) ? "height-8" : "height-6"}`} style={{ minWidth: "100px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.usluga?.summaDoPromokoda?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>

                                </tr>)
                            })}
                        </tbody>
                    </table>
                </div>
            </Spin>
        </div>)
    }

    return (<React.Fragment key={idx + "wrap"}>
        <tr key={idx}>
            {/* <td className={`fixed pointer height-5`} style={{ minWidth: "25px", backgroundColor: "white" }} onClick={() => {
                setCollapsed(o => !o);
            }}>
                <div className={`bg ${(!collapsed) ? "bg-orange dark-5" : "bg-grey"}`} style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
                    {(collapsed) && <i className="fa fa-plus-square-o"></i>}
                    {(!collapsed) && <i className="fa fa-minus-square-o"></i>}
                </div>
            </td> */}
            <td className="fixed height-5" style={{ minWidth: "150px", backgroundColor: "white" }}>
                {item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                    <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplinaPsevdonim}</div>
                        <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikovPsevdonim}</div>
                    </div>
                </div>}
            </td>
            <td className="fixed height-5" style={{ left: "150px", minWidth: "120px", backgroundColor: "white" }}>
                {item?.dancerTour?.tour && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                    <div style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}>
                        №{item?.dancerTour?.tour?.number} {item?.dancerTour?.tour?.tourType?.name}
                    </div>
                </div>}
            </td>
            <td className={`fixed height-5`} style={{ left: "270px", minWidth: "150px", backgroundColor: "white" }}>
                <div>
                    <UserName item={item?.dancerTour?.user} noborder={true} number={item?.dancerTour?.dancerEvent?.number} />
                </div>
            </td>
            <td className={`fixed height-5`} style={{ left: "420px", minWidth: "100px", backgroundColor: "white" }}>
                {(item?.criterionParams?.name !== item?.criterionParams?.criterion?.name) && <div style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}>
                    <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontWeight: "bold" }}>{item?.criterionParams?.criterion?.name}</div>
                    <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item?.criterionParams?.name}</div>
                </div>}
                {(item?.criterionParams?.name === item?.criterionParams?.criterion?.name) && <div style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}>
                    {item?.criterionParams?.name}
                </div>}
            </td>
            {JSXMap(proveryaushie || [], (sudkomItem, cidx) => {
                let itemVal = item?.chleniSudeiskogoKomitetaStrokaOtcheta?.find(el => el?.chlenSudeiskogoKomitetaID == sudkomItem?.ID);
                let min = itemVal?.min;
                let max = itemVal?.max;
                if (item?.dancerTour?.tour?.protocolValueTypeID == 1) {
                    min = PlusMinus(min);
                    max = PlusMinus(max);
                }
                return (<React.Fragment key={"a" + cidx}>
                    {(item?.dancerTour?.tour?.protocolValueTypeID == 1) && <td colSpan={2} className="height-5">
                        <div className='bg bg-grey light-3' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >{min}</div>
                    </td>}
                    {(item?.dancerTour?.tour?.protocolValueTypeID != 1) && <React.Fragment>
                        <td className="height-5">
                            <div className='bg bg-grey light-3' style={{ fontWeight: "bold", display: "flex", justifyContent: "center", alignItems: "center" }} >{min}</div>
                        </td>
                        <td className="height-5">
                            <div className='bg bg-grey light-3' style={{ fontWeight: "bold", display: "flex", justifyContent: "center", alignItems: "center" }} >{max}</div>
                        </td>
                    </React.Fragment>}
                </React.Fragment>)
            })}
            <td className="height-5" style={{ minWidth: "45px", backgroundColor: "white" }}>
                <BoolCell
                    disabled={disabled}
                    colorClass={(!disabled) ? `bg-blue border-transparent` : (item?.otsenkiSudeiDlyaOtchetaStrokaOtcheta?.length) ? `bg-blue border-darkgreen` : `bg-grey border-transparent`}
                    value={item?.uchitivaem}
                    onChange={(val, onError) => {
                        lock()
                        POST(auth, `/api/otchetsudeiskogokomiteta/update`, { ...item, uchitivaem: val },
                            ({ data }) => {
                                // setCollection(o => updateInArray(o, { ...item, ...data }))
                                update()
                                unlock()
                            }, (err) => errorCatch(err, () => { onError(err); unlock(); }))
                    }}
                />
            </td>
            {(item?.dancerTour?.tour?.protocolValueTypeID == 1) && <td colSpan={2} className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <Value value={item?.min} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
                    criterion={item?.criterionParams}
                    disabled={disabled}
                    colorClass={(!disabled) ? `bg-blue border-transparent` : (item?.otsenkiSudeiDlyaOtchetaStrokaOtcheta?.length) ? `bg-blue border-darkgreen` : `bg-grey border-transparent`}
                    onChange={(val) => {
                        lock()
                        POST(auth, `/api/otchetsudeiskogokomiteta/update`, { ...item, min: val, max: val },
                            ({ data }) => {
                                // setCollection(o => updateInArray(o, { ...item, ...data }))
                                update()
                                unlock()
                            }, (err) => errorCatch(err, () => { unlock(); }))
                    }}
                ></Value>
            </td>}
            {(item?.dancerTour?.tour?.protocolValueTypeID != 1) && <React.Fragment>
                <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                    <Value value={item?.min} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
                        criterion={item?.criterionParams}
                        disabled={disabled}
                        colorClass={(!disabled) ? `bg-blue border-transparent` : (item?.otsenkiSudeiDlyaOtchetaStrokaOtcheta?.length) ? `bg-blue border-darkgreen` : `bg-grey border-transparent`}
                        onChange={(val) => {
                            lock()
                            POST(auth, `/api/otchetsudeiskogokomiteta/update`, { ...item, min: val },
                                ({ data }) => {
                                    // setCollection(o => updateInArray(o, { ...item, ...data }))
                                    update()
                                    unlock()
                                }, (err) => errorCatch(err, () => { unlock(); }))
                        }}
                    ></Value>
                </td>
                <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                    <Value value={item?.max} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
                        criterion={item?.criterionParams}
                        disabled={disabled}
                        colorClass={(!disabled) ? `bg-blue border-transparent` : (item?.otsenkiSudeiDlyaOtchetaStrokaOtcheta?.length) ? `bg-blue border-darkgreen` : `bg-grey border-transparent`}
                        onChange={(val) => {
                            lock()
                            POST(auth, `/api/otchetsudeiskogokomiteta/update`, { ...item, max: val },
                                ({ data }) => {
                                    // setCollection(o => updateInArray(o, { ...item, ...data }))
                                    update()
                                    unlock()
                                }, (err) => errorCatch(err, () => { unlock(); }))
                        }}
                    ></Value>
                </td>
            </React.Fragment>}
        </tr>
    </React.Fragment>)
}

function OtchetSudeiskogoKomiteta(props) {
    const { auth, eventID } = props;
    // const [tableData, setTableData] = useState()
    const [reportData, setReportData] = useState();

    const [fullScreenReport, setFullScreenReport] = useState(false)
    const [transposeReport, setTransposeReport] = useState(false)

    const getReportData = useCallback(() => {
        GET(auth, `/api/otchetsudeiskogokomiteta/sudeiskienesootvetstviya/${eventID}`, ({ data }) => {
            if (data?.length) {
                setReportData(data)
            } else {
                setReportData()
            }
        }, errorCatch)
    });

    const reinit = useCallback((
        collection,
        setCollection, update,
        lock,
        unlock) => {
        Modal.confirm({
            title: `Обновить`,
            icon: <ExclamationCircleOutlined />,
            content: (<div>
                <div>Вы уверены что хотите обновить все значения в таблице в соответствии с базой данных?</div>
                <div style={{ color: "rgba(0, 0, 0, 0.45)", fontSize: "12px", fontWeight: "lighter" }}>Если в таблице есть не сохраненные изменения, то они будут утеряны.</div>
            </div>),
            okText: "Да",
            okType: 'danger',
            cancelText: "Нет",
            onOk: () => {
                // setLoading(true)
                // GET(auth, `/api/agentskie-voznagrazhdeniya/list/${eventID}`, ({ data }) => {
                //     setCollection(data)
                //     setLoading(false)
                // }, (err) => errorCatch(err, () => setLoading(false)))
                setReportData(false)
                update()
            },
        });
    }, [eventID])
    const fill = useCallback((
        collection,
        setCollection,
        update,
        lock,
        unlock) => {
        lock()
        GET(auth, `/api/otchetsudeiskogokomiteta/build/${eventID}`, ({ data }) => {
            // setCollection(data)
            update()
            unlock()
        }, (err) => errorCatch(err, () => unlock()))
    }, [eventID])
    const dropfilldata = useCallback((
        collection,
        setCollection,
        update,
        lock,
        unlock) => {
        Modal.confirm({
            title: `Очистить все данные`,
            icon: <ExclamationCircleOutlined />,
            content: (<div>
                <div>Вы уверены что хотите очистить все данные?</div>
            </div>),
            okText: "Да",
            okType: 'danger',
            cancelText: "Нет",
            onOk: () => {
                lock()
                GET(auth, `/api/otchetsudeiskogokomiteta/clear/${eventID}`, ({ data }) => {
                    // setCollection(data)
                    setReportData(false)
                    setCollection([])
                    update()
                    unlock()
                }, (err) => errorCatch(err, () => unlock()))
            },
        });
    }, [eventID])
    const calc = useCallback((
        collection,
        setCollection,
        update,
        lock,
        unlock) => {
        lock()
        GET(auth, `/api/otchetsudeiskogokomiteta/sudeiskienesootvetstviyacalc/${eventID}`, ({ data }) => {
            // setCollection(data)
            update()
            unlock()
        }, (err) => errorCatch(err, () => unlock()))
    }, [eventID])
    const clearcalcdata = useCallback((
        collection,
        setCollection,
        update,
        lock,
        unlock) => {
        Modal.confirm({
            title: `Очистить расчет судейских несоответствий`,
            icon: <ExclamationCircleOutlined />,
            content: (<div>
                <div>Вы уверены что хотите очистить данные выполненного расчета судейских несоответствий?</div>
            </div>),
            okText: "Да",
            okType: 'danger',
            cancelText: "Нет",
            onOk: () => {
                lock()
                GET(auth, `/api/otchetsudeiskogokomiteta/sudeiskienesootvetstviyaclear/${eventID}`, ({ data }) => {
                    // setCollection(data)
                    setReportData()
                    update()
                    unlock()
                }, (err) => errorCatch(err, () => unlock()))
            },
        });
    }, [eventID])
    // const createdocuments = useCallback((
    //     collection,
    //     setCollection,
    //     update,
    //     lock,
    //     unlock) => {
    //     lock()
    //     GET(auth, `/api/agentskie-voznagrazhdeniya/createdocuments/${eventID}`, ({ data }) => {
    //         // setCollection(data)
    //         update()
    //         unlock()
    //     }, (err) => errorCatch(err, () => unlock()))
    // }, [eventID])

    const filters = () => [
        {
            name: "dancerTour.user.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "dancerTour.user.firstname",
            sort: true,
            filter: true,
        },
        // {
        //     name: "dancerTour.user.patronymic",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "dancerTour.user.email",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: <span>Телефон<span style={{
        //         fontStyle: "italic",
        //         fontSize: "11px",
        //         paddingLeft: "5px",
        //         color: "#818181"
        //     }}>(без +)</span></span>,
        //     name: "dancerTour.user.phone",
        //     // type: "string",
        //     sort: true,
        //     filter: true,
        // },
        {
            name: "dancerTour.user.gender",
            sort: true,
            filter: true,
        },
        // {
        //     label: "Параметр критерия",
        //     name: "criterionParams",
        //     filterType: "group",
        //     queryFilter: [
        //         QueryDetail("model"),
        //     ],
        //     display: (o) => o.name,
        //     sort: true,
        //     filter: true,
        // },
        //item?.aktivnost
        // {
        //     label: "Категория",
        //     name: "kategoriya",
        //     source: `/api/meropriyatiya/kategoriiuchastnikovnameropriyatiyakh/list/${eventID}`,
        //     displayString: (item) => {
        //         return item?.tantsevalnayaDistsiplinaPsevdonim + ", " + item?.kategoriyaUchastnikovPsevdonim
        //     },
        //     display: (item) => {
        //         return <CategoryName category={item} style={{
        //             whiteSpace: "nowrap",
        //             overflow: "hidden",
        //             textOverflow: "ellipsis",
        //         }} />
        //     },
        //     queryFilter: [
        //         QueryDetail("model"),
        //         QueryParam("w-meropriyatie", eventID),
        //         QueryOrder("tantsevalnayaDistsiplinaPsevdonim", "ASC"),
        //         QueryOrder("kategoriyaUchastnikovPsevdonim", "ASC")
        //     ],
        //     sort: true,
        //     filter: true
        // },

        {
            label: 'Учитываем',
            display: item => item.uchitivaem, //(item.notActive) ? "Да" : "Нет",
            name: "uchitivaem",
            type: "bool",
            filter: true
        },
        {
            label: 'Не учитываем',
            display: item => !item.uchitivaem, //(item.notActive) ? "Да" : "Нет",
            name: "uchitivaem",
            type: "bool",
            filter: true
        },
        // {
        //     label: "Гонорар расчетный",
        //     name: "gonorarRaschetnii",
        //     type: "int",
        //     filterType: "range",
        //     func: ["min", "max"],
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: "Гонорар к перечислению",
        //     name: "summaRaschetnaya",
        //     type: "int",
        //     filterType: "range",
        //     func: ["min", "max"],
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: "Сумма на накопительный",
        //     name: "summaNaNakopitelnii",
        //     type: "int",
        //     filterType: "range",
        //     func: ["min", "max"],
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: "Сумма на текущий",
        //     name: "summaNaTekushchii",
        //     type: "int",
        //     filterType: "range",
        //     func: ["min", "max"],
        //     sort: true,
        //     filter: true,
        // },
    ];

    const render = (items, {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    }) => {
        //Предобработка (собираем всех проверяющих для шапки)
        let proveryaushie = []
        let proveryaushieMap = {}
        for (let j = 0; j < items?.length; j++) {
            const item = items[j];

            for (let i = 0; i < item?.chleniSudeiskogoKomitetaStrokaOtcheta?.length; i++) {
                const element = item.chleniSudeiskogoKomitetaStrokaOtcheta[i];
                proveryaushieMap[element?.chlenSudeiskogoKomiteta?.ID] = element?.chlenSudeiskogoKomiteta
            }
        }
        for (const key in proveryaushieMap) {
            if (Object.prototype.hasOwnProperty.call(proveryaushieMap, key)) {
                const element = proveryaushieMap[key];
                proveryaushie.push(element)
            }
        }
        proveryaushie.sort((a, b) => (a?.ID - b?.ID))

        return (<div>
            <Spin spinning={loading} tip="Загрузка...">
                <div className='bg bg-grey' style={{ display: "flex", justifyContent: "space-between", padding: "3px", marginBottom: "5px" }}>
                    <div style={{ display: "flex", gap: "3px" }}>
                        <Tooltip title="Заполнить">
                            <div className={`bg bg-grey pointer`} onClick={() => fill(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <BgColorsOutlined style={{ color: "blue" }} />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                        <Tooltip title="Очистить заполнение">
                            <div className={`bg bg-grey pointer`} onClick={() => dropfilldata(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <BgColorsOutlined style={{ color: "red" }} />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                        <Tooltip title="Расчет судейских несоответствий">
                            <div className={`bg bg-grey pointer`} onClick={() => calc(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <CalculatorOutlined style={{ color: "blue" }} />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                        <Tooltip title="Удалить расчет судейских несоответствий">
                            <div className={`bg bg-grey pointer`} onClick={() => clearcalcdata(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <CalculatorOutlined style={{ color: "red" }} />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                    </div>
                    <div style={{ display: "flex", gap: "3px" }}>
                        <Tooltip title="Обновить значения">
                            <div className={`bg bg-grey pointer`} onClick={() => reinit(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <IssuesCloseOutlined />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                    </div>
                </div>
                <div className='scrollable' style={{ backgroundColor: "white" }}>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr>
                                <th rowSpan={2} className={`fixed height-8`} style={{ minWidth: "150px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Категория</div>
                                </th>
                                <th rowSpan={2} className="fixed height-8" style={{ left: "150px", minWidth: "120px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Тур</div>
                                </th>
                                <th rowSpan={2} className="fixed height-8" style={{ left: "270px", minWidth: "150px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Участник</div>
                                </th>
                                <th rowSpan={2} className="fixed height-8" style={{ left: "420px", minWidth: "100px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }} >Параметр</div>
                                </th>
                                {JSXMap(proveryaushie || [], (item, cidx) => {
                                    return (<th key={cidx} colSpan={2} className="height-8" style={{ minWidth: "150px" }}>
                                        <div className="bg bg-grey dark-1">
                                            {item?.user?.lastname} {item?.user?.firstname}
                                        </div>
                                    </th>)
                                })}
                                <th colSpan={3} className="height-8" style={{ minWidth: "150px" }}>
                                    <div className="bg bg-grey dark-1">
                                        Итого
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                {JSXMap(proveryaushie || [], (item, cidx) => {
                                    return (<React.Fragment key={"a" + cidx}>
                                        <th className="height-8">
                                            <div className="bg bg-grey dark-1">Мин</div>
                                        </th>
                                        <th className="height-8">
                                            <div className="bg bg-grey dark-1">Макс</div>
                                        </th>
                                    </React.Fragment>)
                                })}
                                <th className="height-8" style={{ minWidth: "100px" }}>
                                    <div className="bg bg-grey dark-1">Учитываем</div>
                                </th>
                                <th className="height-8">
                                    <div className="bg bg-grey dark-1">Мин</div>
                                </th>
                                <th className="height-8">
                                    <div className="bg bg-grey dark-1">Макс</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(items || [], (item, cidx) => {
                                return (<OtchetSudeiskogoKomitetaRow key={cidx} item={item} proveryaushie={proveryaushie} idx={cidx} eventID={eventID} disabled={!!reportData} renderProps={{
                                    collection,
                                    setCollection,
                                    setCollectionItem,
                                    removeCollectionItem,
                                    collectionActions,
                                    modelActions,
                                    update,
                                    lastFuncStat,
                                    lock,
                                    unlock,
                                    loading
                                }} />)
                            })}
                        </tbody>
                    </table>
                </div>
            </Spin>
        </div>)
    }

    const renderReport = (items) => {
        //Предобработка (собираем всех проверяющих для шапки)
        let judge = []
        let judgeMap = {}
        for (let j = 0; j < items?.length; j++) {
            const item = items[j];

            for (let i = 0; i < item?.otsenkiSudeiDlyaOtchetaStrokaOtcheta?.length; i++) {
                const element = item.otsenkiSudeiDlyaOtchetaStrokaOtcheta[i];
                judgeMap[element?.judgeID] = element?.judge
            }
        }
        for (const key in judgeMap) {
            if (Object.prototype.hasOwnProperty.call(judgeMap, key)) {
                const element = judgeMap[key];
                element.difMinus = 0
                element.difPlus = 0
                element.countOtsenok = 0
                judge.push(element)
            }
        }
        judge.sort((a, b) => (a?.ID - b?.ID))

        for (let j = 0; j < items?.length; j++) {
            const item = items[j];

            for (let c = 0; c < judge.length; c++) {
                const judgeItem = judge[c];
                let itemVal = item?.otsenkiSudeiDlyaOtchetaStrokaOtcheta?.find(el => el?.judgeID == judgeItem?.ID);
                judgeItem.isJudged = true;
                if (itemVal) {
                    judgeItem.countOtsenok++
                }

                let otsenka = itemVal?.otsenka;
                let min = item?.min;
                let max = item?.max
                let dif = '';
                if (otsenka < min) {
                    dif = otsenka - min;
                } else if (otsenka > max) {
                    dif = otsenka - max;
                }

                if (dif != '') {
                    if (dif < 0) {
                        judgeItem.difMinus += dif
                    } else if (dif > 0) {
                        judgeItem.difPlus += dif
                    }
                }
                // console.log(itemVal, dif, judgeItem.difMinus, judgeItem.difPlus);
                if (itemVal?.tipOtsenkiID == 1) {
                    otsenka = PlusMinus(otsenka);
                }
            }
        }

        if (transposeReport) {
            return (<div>
                <div className='scrollable' style={{ backgroundColor: "white" }}>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr>
                                <th colSpan={6} className={`fixed height-8`} style={{ minWidth: "150px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>
                                        <div style={{ fontWeight: "bold" }}>Категория</div>
                                        <div>Тур</div>
                                    </div>
                                </th>
                                {JSXMap(items || [], (item, cidx) => {
                                    return (<th key={cidx} colSpan={2} className="height-8" style={{ minWidth: "110px", backgroundColor: "white" }}>
                                        {item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                                            <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                <div style={{ fontWeight: "bold", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "110px" }}>{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplinaPsevdonim}</div>
                                                <div style={{ fontWeight: "bold", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "110px" }}>{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikovPsevdonim}</div>
                                                <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "110px" }}>
                                                    №{item?.dancerTour?.tour?.number} {item?.dancerTour?.tour?.tourType?.name}
                                                </div>
                                            </div>
                                        </div>}
                                    </th>)
                                })}
                            </tr>
                            <tr>
                                <th colSpan={6} className="fixed height-8" style={{ minWidth: "150px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Участник</div>
                                </th>
                                {JSXMap(items || [], (item, cidx) => {

                                    return (<th key={cidx} colSpan={2} className="height-8" style={{ minWidth: "110px", backgroundColor: "white" }}>
                                        <div className="bg bg-grey">
                                            <UserName2Line item={item?.dancerTour?.user} noborder={true} maxWidth={"90px"} number={item?.dancerTour?.dancerEvent?.number} />
                                        </div>
                                    </th>)
                                })}
                            </tr>
                            <tr>
                                <th colSpan={6} className="fixed height-8" style={{ minWidth: "150px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }} >Параметр</div>
                                </th>
                                {JSXMap(items || [], (item, cidx) => {
                                    return (<th key={cidx} colSpan={2} className="height-8" style={{ minWidth: "110px", maxWidth: "110px", backgroundColor: "white" }}>
                                        {(item?.criterionParams?.name !== item?.criterionParams?.criterion?.name) && <div className="bg bg-grey" style={{
                                            // whiteSpace: "nowrap",
                                            // width: "110px",
                                            whiteSpace: "normal",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            textAlign: "left"
                                        }}>
                                            <div style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis", fontWeight: "bold" }}>{item?.criterionParams?.criterion?.name}</div>
                                            <div style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}>{item?.criterionParams?.name}</div>
                                        </div>}
                                        {(item?.criterionParams?.name === item?.criterionParams?.criterion?.name) && <div className="bg bg-grey" style={{
                                            // whiteSpace: "nowrap",
                                            // width: "110px",
                                            whiteSpace: "normal",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            textAlign: "left"
                                        }}>
                                            {item?.criterionParams?.name}
                                        </div>}
                                    </th>)
                                })}
                            </tr>
                            <tr>
                                <th colSpan={6} className="fixed height-4" style={{ minWidth: "150px", backgroundColor: "white" }}>
                                    <div className="bg bg-blue dark-1">Оценка</div>
                                </th>
                                {JSXMap(items || [], (item, cidx) => {
                                    return (<React.Fragment key={cidx}>
                                        {(item?.dancerTour?.tour?.protocolValueTypeID == 1) && <th colSpan={2} className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
                                            <div className="bg bg-blue dark-1">Оценка</div>
                                        </th>}
                                        {(item?.dancerTour?.tour?.protocolValueTypeID != 1) && <React.Fragment>
                                            <th className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
                                                <div className="bg bg-blue dark-1">Мин.</div>
                                            </th>
                                            <th className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
                                                <div className="bg bg-blue dark-1">Макс.</div>
                                            </th>
                                        </React.Fragment>}
                                    </React.Fragment>)
                                })}
                            </tr>
                            <tr>
                                <th className="fixed height-4" style={{ minWidth: "150px" }}>
                                    <div className="bg bg-green dark-17">
                                        ИТОГО
                                    </div>
                                </th>
                                <th className="fixed height-4" style={{ left: "150px", minWidth: "60px", backgroundColor: "white" }}>
                                    <div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>⁰⏨</div>
                                </th>
                                <th className="fixed height-4" style={{ left: "210px", minWidth: "60px", backgroundColor: "white" }}>
                                    <div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>∑</div>
                                </th>
                                <th className="fixed height-4" style={{ left: "270px", minWidth: "60px", backgroundColor: "white" }}>
                                    <div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>=</div>
                                </th>
                                <th className="fixed height-4" style={{ left: "330px", minWidth: "60px", backgroundColor: "white" }}>
                                    <div className='bg bg-green dark-8' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>+</div>
                                </th>
                                <th className="fixed height-4" style={{ left: "390px", minWidth: "60px", backgroundColor: "white" }}>
                                    <div className='bg bg-green dark-8' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>-</div>
                                </th>
                                {JSXMap(items || [], (item, cidx) => {
                                    return (<React.Fragment key={cidx}>
                                        {(item?.dancerTour?.tour?.protocolValueTypeID == 1) && <th colSpan={2} className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
                                            <Value value={item?.min} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
                                                criterion={item?.criterionParams}
                                                disabled={true}
                                                colorClass={`bg-blue border-transparent`}
                                            ></Value>
                                        </th>}
                                        {(item?.dancerTour?.tour?.protocolValueTypeID != 1) && <React.Fragment>
                                            <th className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
                                                <Value value={item?.min} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
                                                    criterion={item?.criterionParams}
                                                    disabled={true}
                                                    colorClass={`bg-blue border-transparent`}
                                                ></Value>
                                            </th>
                                            <th className="height-4" style={{ minWidth: "65px", backgroundColor: "white" }}>
                                                <Value value={item?.max} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
                                                    criterion={item?.criterionParams}
                                                    disabled={true}
                                                    colorClass={`bg-blue border-transparent`}
                                                ></Value>
                                            </th>
                                        </React.Fragment>}
                                    </React.Fragment>)
                                })}
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(judge || [], (judgeItem, cidx) => {
                                return (<tr key={cidx}>
                                    <td key={cidx} className="fixed height-8" style={{ minWidth: "150px", backgroundColor: "white" }}>
                                        <div className="bg bg-grey dark-1">
                                            <div>{judgeItem?.user?.lastname}</div>
                                            <div>{judgeItem?.user?.firstname}</div>
                                        </div>
                                    </td>
                                    <td className="fixed height-8" style={{ left: "150px", minWidth: "60px", backgroundColor: "white" }}>
                                        <div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
                                            {(!!judgeItem?.isJudged) ? (Math.round(((Math.abs(judgeItem.difPlus) + Math.abs(judgeItem.difMinus)) / judgeItem?.countOtsenok) * 100) / 100) : ""}
                                        </div>
                                    </td>
                                    <td className="fixed height-8" style={{ left: "210px", minWidth: "60px", backgroundColor: "white" }}>
                                        <div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
                                            {(!!judgeItem?.isJudged) ? judgeItem?.countOtsenok : ""}
                                        </div>
                                    </td>
                                    <td className="fixed height-8" style={{ left: "270px", minWidth: "60px", backgroundColor: "white" }}>
                                        <div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
                                            {(!!judgeItem?.isJudged) ? (Math.abs(judgeItem.difPlus) + Math.abs(judgeItem.difMinus)) : ""}
                                        </div>
                                    </td>
                                    <td className="fixed height-8" style={{ left: "330px", minWidth: "60px", backgroundColor: "white" }}>
                                        <div className='bg bg-green dark-8' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
                                            {(!!judgeItem?.isJudged) ? judgeItem.difPlus : ""}
                                        </div>
                                    </td>
                                    <td className="fixed height-8" style={{ left: "390px", minWidth: "60px", backgroundColor: "white" }}>
                                        <div className='bg bg-green dark-8' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>
                                            {(!!judgeItem?.isJudged) ? judgeItem.difMinus : ""}
                                        </div>
                                    </td>
                                    {JSXMap(items || [], (item, cidx) => {
                                        let itemVal = item?.otsenkiSudeiDlyaOtchetaStrokaOtcheta?.find(el => el?.judgeID == judgeItem?.ID);
                                        let otsenka = itemVal?.otsenka;
                                        let min = item?.min;
                                        let max = item?.max
                                        let dif = 0;
                                        if (otsenka < min) {
                                            dif = otsenka - min;
                                        } else if (otsenka > max) {
                                            dif = otsenka - max;
                                        }

                                        // if (dif != '') {
                                        //     if (dif < 0) {
                                        //         judgeItem.difMinus += dif
                                        //     } else if (dif > 0) {
                                        //         judgeItem.difPlus += dif
                                        //     }
                                        // }

                                        // if (itemVal?.tipOtsenkiID == 1) {
                                        //     otsenka = PlusMinus(otsenka);
                                        // }

                                        return (<td key={cidx} colSpan={2} className="height-8" style={{ minWidth: "110px", backgroundColor: "white" }}>
                                            <div className='bg bg-grey light-3' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >{(itemVal) ? dif : ""}</div>
                                        </td>)
                                    })}

                                </tr>)
                            })}
                        </tbody>
                    </table>
                </div>
            </div>)
        }
        if (!transposeReport) {
            return (<div>
                <div className='scrollable' style={{ backgroundColor: "white" }}>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr>
                                <th className={`fixed height-8`} style={{ minWidth: "150px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>
                                        <div style={{ fontWeight: "bold" }}>Категория</div>
                                        <div>Тур</div>

                                    </div>
                                </th>
                                {/* <th className="fixed height-8" style={{ left: "150px", minWidth: "120px", backgroundColor: "white" }}>
                                <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Тур</div>
                            </th> */}
                                <th className="fixed height-8" style={{ left: "150px", minWidth: "110px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Участник</div>
                                </th>
                                <th className="fixed height-8" style={{ left: "260px", minWidth: "100px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }} >Параметр</div>
                                </th>
                                <th className="height-8">
                                    <div className="bg bg-blue dark-1">Оценка (мин.)</div>
                                </th>
                                <th className="height-8">
                                    <div className="bg bg-blue dark-1">Оценка (макс.)</div>
                                </th>
                                {JSXMap(judge || [], (item, cidx) => {
                                    return (<th key={cidx} className="height-8" style={{ minWidth: "85px" }}>
                                        <div className="bg bg-grey dark-1">
                                            <div>{item?.user?.lastname}</div>
                                            <div>{item?.user?.firstname}</div>
                                        </div>
                                    </th>)
                                })}
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(items || [], (item, cidx) => {
                                return (<tr key={cidx}>
                                    <td className="fixed height-5" style={{ minWidth: "150px", backgroundColor: "white" }}>
                                        {item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                                            <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                <div style={{ fontWeight: "bold", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "135px" }}>{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplinaPsevdonim}</div>
                                                <div style={{ fontWeight: "bold", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "135px" }}>{item?.dancerTour?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikovPsevdonim}</div>
                                                <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "135px" }}>
                                                    №{item?.dancerTour?.tour?.number} {item?.dancerTour?.tour?.tourType?.name}
                                                </div>
                                            </div>
                                        </div>}
                                    </td>
                                    {/* <td className="fixed height-5" style={{ left: "150px", minWidth: "120px", backgroundColor: "white" }}>
                                    {item?.dancerTour?.tour && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                                        <div style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}>
                                            №{item?.dancerTour?.tour?.number} {item?.dancerTour?.tour?.tourType?.name}
                                        </div>
                                    </div>}
                                </td> */}
                                    <td className={`fixed height-5`} style={{ left: "150px", minWidth: "110px", backgroundColor: "white" }}>
                                        <div className="bg bg-grey">
                                            <UserName2Line item={item?.dancerTour?.user} noborder={true} maxWidth={"90px"} number={item?.dancerTour?.dancerEvent?.number} />
                                        </div>
                                    </td>
                                    <td className={`fixed height-5`} style={{ left: "260px", minWidth: "100px", backgroundColor: "white" }}>
                                        {(item?.criterionParams?.name !== item?.criterionParams?.criterion?.name) && <div className="bg bg-grey" style={{
                                            // whiteSpace: "nowrap",
                                            width: "200px",
                                            whiteSpace: "normal",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            textAlign: "left"
                                        }}>
                                            <div style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis", fontWeight: "bold" }}>{item?.criterionParams?.criterion?.name}</div>
                                            <div style={{ whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}>{item?.criterionParams?.name}</div>
                                        </div>}
                                        {(item?.criterionParams?.name === item?.criterionParams?.criterion?.name) && <div className="bg bg-grey" style={{
                                            // whiteSpace: "nowrap",
                                            width: "200px",
                                            whiteSpace: "normal",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            textAlign: "left"
                                        }}>
                                            {item?.criterionParams?.name}
                                        </div>}
                                    </td>
                                    {(item?.dancerTour?.tour?.protocolValueTypeID == 1) && <td colSpan={2} className="height-5" style={{ minWidth: "65px", backgroundColor: "white" }}>
                                        <Value value={item?.min} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
                                            criterion={item?.criterionParams}
                                            disabled={true}
                                            colorClass={`bg-blue border-transparent`}
                                        ></Value>
                                    </td>}
                                    {(item?.dancerTour?.tour?.protocolValueTypeID != 1) && <React.Fragment>
                                        <td className="height-5" style={{ minWidth: "65px", backgroundColor: "white" }}>
                                            <Value value={item?.min} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
                                                criterion={item?.criterionParams}
                                                disabled={true}
                                                colorClass={`bg-blue border-transparent`}
                                            ></Value>
                                        </td>
                                        <td className="height-5" style={{ minWidth: "65px", backgroundColor: "white" }}>
                                            <Value value={item?.max} protocolValueTypeID={item?.dancerTour?.tour?.protocolValueTypeID}
                                                criterion={item?.criterionParams}
                                                disabled={true}
                                                colorClass={`bg-blue border-transparent`}
                                            ></Value>
                                        </td>
                                    </React.Fragment>}
                                    {JSXMap(judge || [], (judgeItem, cidx) => {
                                        let itemVal = item?.otsenkiSudeiDlyaOtchetaStrokaOtcheta?.find(el => el?.judgeID == judgeItem?.ID);
                                        let otsenka = itemVal?.otsenka;
                                        let min = item?.min;
                                        let max = item?.max
                                        let dif = 0;
                                        if (otsenka < min) {
                                            dif = otsenka - min;
                                        } else if (otsenka > max) {
                                            dif = otsenka - max;
                                        }

                                        // if (dif != '') {
                                        //     if (dif < 0) {
                                        //         judgeItem.difMinus += dif
                                        //     } else if (dif > 0) {
                                        //         judgeItem.difPlus += dif
                                        //     }
                                        // }

                                        // if (itemVal?.tipOtsenkiID == 1) {
                                        //     otsenka = PlusMinus(otsenka);
                                        // }
                                        return (<React.Fragment key={"a" + cidx}>
                                            {(itemVal?.tipOtsenkiID == 1) && <td className="height-5">
                                                <div className='bg bg-grey light-3' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >{(itemVal) ? dif : ""}</div>
                                            </td>}
                                            {(itemVal?.tipOtsenkiID != 1) && <td className="height-5">
                                                <div className='bg bg-grey light-3' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >{(itemVal) ? dif : ""}</div>
                                            </td>}
                                        </React.Fragment>)
                                    })}
                                </tr>)
                            })}
                            <tr>
                                <td colSpan={3} className="fixed height-5" style={{ minWidth: "260px", backgroundColor: "white" }}>
                                    <div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>Итого (в плюс)</div>
                                </td>
                                <td colSpan={2} className="height-5">
                                    <div className='bg bg-green dark-7' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} ></div>
                                </td>
                                {JSXMap(judge || [], (judgeItem, cidx) => {
                                    return (<React.Fragment key={"a" + cidx}>
                                        <td className="height-5">
                                            <div className='bg bg-green dark-7' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >{(!!judgeItem?.isJudged) ? judgeItem.difPlus : ""}</div>
                                        </td>
                                    </React.Fragment>)
                                })}
                            </tr>
                            <tr>
                                <td colSpan={3} className="fixed height-5" style={{ minWidth: "260px", backgroundColor: "white" }}>
                                    <div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>Итого (в минус)</div>
                                </td>
                                <td colSpan={2} className="height-5">
                                    <div className='bg bg-green dark-7' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} ></div>
                                </td>
                                {JSXMap(judge || [], (judgeItem, cidx) => {
                                    return (<React.Fragment key={"a" + cidx}>
                                        <td className="height-5">
                                            <div className='bg bg-green dark-7' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >{(!!judgeItem?.isJudged) ? judgeItem.difMinus : ""}</div>
                                        </td>
                                    </React.Fragment>)
                                })}
                            </tr>
                            <tr>
                                <td colSpan={3} className="fixed height-5" style={{ minWidth: "260px", backgroundColor: "white" }}>
                                    <div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>Итого (по модулю)</div>
                                </td>
                                <td colSpan={2} className="height-5">
                                    <div className='bg bg-green dark-15' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} ></div>
                                </td>
                                {JSXMap(judge || [], (judgeItem, cidx) => {
                                    return (<React.Fragment key={"a" + cidx}>
                                        <td className="height-5">
                                            <div className='bg bg-green dark-15' style={{ fontWeight: "bold", display: "flex", justifyContent: "center", alignItems: "center" }} >{(!!judgeItem?.isJudged) ? (Math.abs(judgeItem.difPlus) + Math.abs(judgeItem.difMinus)) : ""}</div>
                                        </td>
                                    </React.Fragment>)
                                })}
                            </tr>
                            <tr>
                                <td colSpan={3} className="fixed height-5" style={{ minWidth: "260px", backgroundColor: "white" }}>
                                    <div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>Общее количество проверяемых оценок</div>
                                </td>
                                <td colSpan={2} className="height-5">
                                    <div className='bg bg-green dark-15' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} ></div>
                                </td>
                                {JSXMap(judge || [], (judgeItem, cidx) => {
                                    return (<React.Fragment key={"a" + cidx}>
                                        <td className="height-5">
                                            <div className='bg bg-green dark-15' style={{ fontWeight: "bold", display: "flex", justifyContent: "center", alignItems: "center" }} >{(!!judgeItem?.isJudged) ? judgeItem?.countOtsenok : ""}</div>
                                        </td>
                                    </React.Fragment>)
                                })}
                            </tr>
                            <tr>
                                <td colSpan={3} className="fixed height-5" style={{ minWidth: "260px", backgroundColor: "white" }}>
                                    <div className='bg bg-green dark-17' style={{ display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold" }}>Коэффициент отклонений</div>
                                </td>
                                <td colSpan={2} className="height-5">
                                    <div className='bg bg-green dark-15' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} ></div>
                                </td>
                                {JSXMap(judge || [], (judgeItem, cidx) => {
                                    return (<React.Fragment key={"a" + cidx}>
                                        <td className="height-5">
                                            <div className='bg bg-green dark-15' style={{ fontWeight: "bold", display: "flex", justifyContent: "center", alignItems: "center" }} >{(!!judgeItem?.isJudged) ? (Math.round(((Math.abs(judgeItem.difPlus) + Math.abs(judgeItem.difMinus)) / judgeItem?.countOtsenok) * 100) / 100) : ""}</div>
                                        </td>
                                    </React.Fragment>)
                                })}
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>)
        }

    }

    // const FilterFromContextFilter = React.useCallback(() => [
    //     QueryParam("f-sum-agentskoeVoznagrazhdenieSumma", 0),
    //     QueryParam("f-sum-gonorarRaschetnii", 0),
    //     QueryParam("f-sum-summaRaschetnaya", 0),
    //     QueryParam("f-sum-summaNaNakopitelnii", 0),
    //     QueryParam("f-sum-summaNaTekushchii", 0),
    // ], [eventID]);

    return (<div>
        <CollectionServer
            auth={auth}
            floatingFilter={true}
            disableScrollTo={true}
            allowFullscreen={true}
            onCollectionChange={(items) => {
                getReportData()
            }}
            name={"OtchetSudeiskogoKomiteta"}
            // count={() => 10} // !!!! ИСПРАВИТЬ - сделать редактируемым или подобрать нужное количество !!!!
            // queryDetail={"collection"}
            source={`/api/otchetsudeiskogokomiteta/getlistbymeropriyatieid/${eventID}`}
            // contextFilters={FilterFromContextFilter}
            filters={filters}
            size={"small"}
            mode={"list"}
            customRender={render}
        />

        {(reportData) && <div style={{ marginTop: "30px" }}>
            <Overlay open={fullScreenReport} setOpen={setFullScreenReport}>
                <div>
                    <div style={{ display: "flex", justifyContent: "right", gap: "5px", paddingBottom: "10px" }}>
                        <div className={`bg ${(transposeReport) ? "bg-altblue" : "bg-grey"} pointer`}
                            style={{
                                minWidth: "28px",
                                fontSize: "14px",
                                lineHeight: "22px",
                                color: (transposeReport) ? "white" : "black",
                            }}
                            onClick={(e) => { (transposeReport) ? setTransposeReport(false) : setTransposeReport(true) }}
                        >
                            {(!transposeReport) && <RotateRightOutlined />}
                            {(transposeReport) && <RotateLeftOutlined />}
                        </div>
                        <div className={`bg ${(fullScreenReport) ? "bg-altblue" : "bg-grey"} pointer`}
                            style={{
                                minWidth: "28px",
                                fontSize: "14px",
                                lineHeight: "22px",
                                color: (fullScreenReport) ? "white" : "black",
                            }}
                            onClick={(e) => { (fullScreenReport) ? setFullScreenReport(false) : setFullScreenReport(true) }}
                        >
                            {(!fullScreenReport) && <FullscreenOutlined />}
                            {(fullScreenReport) && <FullscreenExitOutlined />}
                        </div>
                    </div>
                    {renderReport(reportData)}
                </div>
            </Overlay>
        </div>}
    </div>)
}

function AgentskieVoznagrazhdeniyaRow({ item, idx, eventID, disabled, disabled2, renderProps }) {
    const [collapsed, setCollapsed] = useState(true);
    const auth = useAuth()
    const {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    } = renderProps;

    const FilterFromContextFilter = React.useCallback(() => [
        QueryParam("f-sum-summaVGonorare", 0),
        // QueryParam("f-sum-usluga.summa", 0),
        // QueryParam("f-sum-usluga.summaDoPromokoda", 0),
        // QueryParam("f-sum-summaNaNakopitelnii", 0),
        // QueryParam("f-sum-summaNaTekushchii", 0),
    ], [item, idx, eventID, disabled, disabled2]);
    const filters = () => [
        {
            name: "usluga.polzovatel.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "usluga.polzovatel.firstname",
            sort: true,
            filter: true,
        },
        // {
        //     name: "usluga.polzovatel.patronymic",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "usluga.polzovatel.email",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: <span>Телефон<span style={{
        //         fontStyle: "italic",
        //         fontSize: "11px",
        //         paddingLeft: "5px",
        //         color: "#818181"
        //     }}>(без +)</span></span>,
        //     name: "usluga.polzovatel.phone",
        //     // type: "string",
        //     sort: true,
        //     filter: true,
        // },
        {
            name: "usluga.polzovatel.gender",
            sort: true,
            filter: true,
        },
        {
            label: <FilterFieldLabel label="Услуга" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
            name: "usluga.uslugaKlientu.yacheikaUsluga.nazvanie",
            // queryComparer:"swsim", // sim, wsim, swsim
            sort: true,
            filter: true,
        },
        {
            label: "Категория",
            name: "usluga.kategoriya.kategoriya",
            source: `/api/meropriyatiya/kategoriiuchastnikovnameropriyatiyakh/list/${eventID}`,
            displayString: (item) => {
                return item?.tantsevalnayaDistsiplinaPsevdonim + ", " + item?.kategoriyaUchastnikovPsevdonim
            },
            display: (item) => {
                return <CategoryName category={item} style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }} />
            },
            queryFilter: [
                QueryDetail("model"),
                // QueryParam("w-meropriyatie", eventID),
                QueryOrder("tantsevalnayaDistsiplinaPsevdonim", "ASC"),
                QueryOrder("kategoriyaUchastnikovPsevdonim", "ASC")
            ],
            sort: true,
            filter: true
        },
        {
            label: "Сумма",
            name: "summaVGonorare",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
    ];
    const render = (items, {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    }) => {
        const summaVGonorare = lastFuncStat?.summavgonorare?.sum || 0;
        return (<div>
            <Spin spinning={loading} tip="Загрузка...">
                <div className='scrollable' style={{ /*backgroundColor: "white"*/ }}>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr>
                                <th className={`fixed height-8`} style={{ minWidth: "180px", }}>
                                    <div className='bg bg-grey dark-1'>Услуга</div>
                                </th>

                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey dark-1">
                                        Сумма в гонораре
                                    </div>
                                </th>

                                <th className={`height-8`} style={{ minWidth: "100px" }}>
                                    <div className='bg bg-grey dark-1'>Сумма</div>
                                </th>
                                <th className={`height-8`} style={{ minWidth: "100px" }}>
                                    <div className='bg bg-grey dark-1'>Сумма до промокода</div>
                                </th>
                            </tr>
                            <tr>
                                <th className={`fixed height-4`} style={{ minWidth: "180px", }}>
                                    <div className='bg bg-grey dark-1'></div>
                                </th>

                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма в гонораре */}
                                        {(Number(summaVGonorare.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>

                                <th className={`height-4`} style={{ minWidth: "100px", }}>
                                    <div className='bg bg-grey dark-1'></div>
                                </th>
                                <th className={`height-4`} style={{ minWidth: "100px", }}>
                                    <div className='bg bg-grey dark-1'></div>
                                </th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(items || [], (item, cidx) => {
                                return (<tr key={cidx}>
                                    <td className={`fixed ${(item?.usluga?.kategoriya) ? "height-8" : "height-6"}`} style={{ minWidth: "180px" }}>
                                        <div>
                                            <div>{item?.usluga?.uslugaKlientu?.yacheikaUsluga?.nazvanie}</div>
                                            <div style={{
                                                filter: "grayscale(0.1)", opacity: "0.6",
                                                textAlign: "left",
                                                textWrap: "nowrap",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                fontSize: "12px",
                                                fontWeight: "lighter"
                                            }}>
                                                {item?.usluga?.kategoriya && <div style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}>
                                                    <CategoryName category={item?.usluga?.kategoriya?.kategoriya} style={{
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                    }} />
                                                </div>}
                                                <UserName item={item?.usluga?.polzovatel} noborder={true} />
                                            </div>
                                            {/* <UserName item={item?.usluga?.polzovatel} noborder={true} />
                                            <div style={{
                                                color: "rgba(0, 0, 0, 0.45)",
                                                textAlign: "left",
                                                textWrap: "nowrap",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                fontSize: "12px",
                                                fontWeight: "lighter",
                                                paddingLeft: "20px"
                                            }}>
                                                <span>{item?.vtp?.tipPolzovatelya?.opisanie}</span>
                                            </div> */}
                                        </div>
                                    </td>
                                    <td className={`${(item?.usluga?.kategoriya) ? "height-8" : "height-6"}`} style={{ minWidth: "100px" }}>
                                        <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.summaVGonorare?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>

                                    <td className={`${(item?.usluga?.kategoriya) ? "height-8" : "height-6"}`} style={{ minWidth: "100px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.usluga?.summa?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                    <td className={`${(item?.usluga?.kategoriya) ? "height-8" : "height-6"}`} style={{ minWidth: "100px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.usluga?.summaDoPromokoda?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>

                                </tr>)
                            })}
                        </tbody>
                    </table>
                </div>
            </Spin>
        </div>)
    }
    return (<React.Fragment key={idx + "wrap"}>
        <tr key={idx}>
            <td className={`fixed pointer height-5`} style={{ minWidth: "25px", backgroundColor: "white" }} onClick={() => {
                setCollapsed(o => !o);
            }}>
                <div className={`bg ${(!collapsed) ? "bg-orange dark-5" : "bg-grey"}`} style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
                    {(collapsed) && <i className="fa fa-plus-square-o"></i>}
                    {(!collapsed) && <i className="fa fa-minus-square-o"></i>}
                </div>
            </td>
            <td className={`fixed height-5`} style={{ left: "25px", minWidth: "180px", backgroundColor: "white" }}>
                <div>
                    <UserName item={item?.vtp?.user} noborder={true} />
                    <div style={{
                        color: "rgba(0, 0, 0, 0.45)",
                        textAlign: "left",
                        textWrap: "nowrap",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "12px",
                        fontWeight: "lighter",
                        paddingLeft: "20px"
                    }}>
                        <span>{item?.vtp?.tipPolzovatelya?.opisanie}</span>
                    </div>
                </div>
            </td>
            <td className="fixed height-5" style={{ left: "205px", minWidth: "200px", backgroundColor: "white" }}>
                {item?.aktivnost && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                    <div style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}>
                        <div style={{
                            color: "rgba(0, 0, 0, 0.45)",
                            textAlign: "left",
                            textWrap: "nowrap",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "12px",
                            fontWeight: "lighter"
                        }}>
                            Активность
                        </div>
                        <div style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}>{item?.aktivnost?.nazvanie}</div>
                    </div>
                </div>}
                {item?.kategoriya && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                    <div style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}>
                        <div style={{
                            color: "rgba(0, 0, 0, 0.45)",
                            textAlign: "left",
                            textWrap: "nowrap",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "12px",
                            fontWeight: "lighter"
                        }}>
                            Категория
                        </div>
                        <CategoryName category={item?.kategoriya} style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }} />
                    </div>
                </div>}
                {item?.promokod && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                    <div style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}>
                        <div style={{
                            color: "rgba(0, 0, 0, 0.45)",
                            textAlign: "left",
                            textWrap: "nowrap",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "12px",
                            fontWeight: "lighter"
                        }}>
                            Промокод
                        </div>
                        <div style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}>{item?.promokod?.promokod}</div>
                    </div>
                </div>}
                {(!item?.aktivnost && !item?.kategoriya && !item?.promokod) && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                    <div>

                    </div>
                </div>}
            </td>
            <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <FloatCell
                    disabled={disabled}
                    colorClass={(!disabled) ? `bg-blue border-transparent` : (item?.raschetProizveden) ? `bg-blue border-darkgreen` : `bg-grey border-transparent`}
                    value={item?.agentskoeVoznagrazhdenieProtsent}
                    onChange={(val, onError) => {
                        lock()
                        POST(auth, `/api/agentskie-voznagrazhdeniya/update`, { ...item, agentskoeVoznagrazhdenieProtsent: val },
                            ({ data }) => {
                                // setCollection(o => updateInArray(o, { ...item, ...data }))
                                update()
                                unlock()
                            }, (err) => errorCatch(err, () => { onError(err); unlock(); }))
                    }}
                />
            </td>
            <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <FloatCell
                    disabled={disabled}
                    colorClass={(!disabled) ? `bg-blue border-transparent` : (item?.raschetProizveden) ? `bg-blue border-darkgreen` : `bg-grey border-transparent`}
                    value={item?.agentskoeVoznagrazhdenieSumma}
                    onChange={(val, onError) => {
                        lock()
                        POST(auth, `/api/agentskie-voznagrazhdeniya/update`, { ...item, agentskoeVoznagrazhdenieSumma: val },
                            ({ data }) => {
                                // setCollection(o => updateInArray(o, { ...item, ...data }))
                                update()
                                unlock()
                            }, (err) => errorCatch(err, () => { onError(err); unlock(); }))
                    }}
                />
            </td>
            <td className="height-5" style={{ minWidth: "45px", backgroundColor: "white" }}>
                <BoolCell
                    disabled={disabled}
                    colorClass={(!disabled) ? `bg-blue border-transparent` : (item?.raschetProizveden) ? `bg-blue border-darkgreen` : `bg-grey border-transparent`}
                    value={item?.aktivno}
                    onChange={(val, onError) => {
                        lock()
                        POST(auth, `/api/agentskie-voznagrazhdeniya/update`, { ...item, aktivno: val },
                            ({ data }) => {
                                // setCollection(o => updateInArray(o, { ...item, ...data }))
                                update()
                                unlock()
                            }, (err) => errorCatch(err, () => { onError(err); unlock(); }))
                    }}
                />
            </td>
            <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {(Number(item?.gonorarRaschetnii?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <FloatCell
                    disabled={disabled2}
                    colorClass={(!disabled2) ? `bg-blue border-transparent` : (item?.dokumentVoznagrazhdenieKViplateID) ? `bg-blue border-darkgreen` : `bg-grey border-transparent`}
                    value={item?.summaRaschetnaya}
                    onChange={(val, onError) => {
                        lock()
                        POST(auth, `/api/agentskie-voznagrazhdeniya/updatesummaraschetnaya`, { ...item, summaRaschetnaya: val },
                            ({ data }) => {
                                // setCollection(o => updateInArray(o, { ...item, ...data }))
                                update()
                                unlock()
                            }, (err) => errorCatch(err, () => { onError(err); unlock(); }))
                    }}
                />
            </td>
            <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <FloatCell
                    disabled={disabled2}
                    colorClass={(!disabled2) ? `bg-blue border-transparent` : (item?.dokumentVoznagrazhdenieKViplateID) ? `bg-blue border-darkgreen` : `bg-grey border-transparent`}
                    value={item?.summaNaNakopitelnii}
                    onChange={(val, onError) => {
                        lock()
                        POST(auth, `/api/agentskie-voznagrazhdeniya/updatesummananakopitelnii`, { ...item, summaNaNakopitelnii: val },
                            ({ data }) => {
                                // setCollection(o => updateInArray(o, { ...item, ...data }))
                                update()
                                unlock()
                            }, (err) => errorCatch(err, () => { onError(err); unlock(); }))
                    }}
                />
            </td>
            <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <FloatCell
                    disabled={disabled2}
                    colorClass={(!disabled2) ? `bg-blue border-transparent` : (item?.dokumentVoznagrazhdenieKViplateID) ? `bg-blue border-darkgreen` : `bg-grey border-transparent`}
                    value={item?.summaNaTekushchii}
                    onChange={(val, onError) => {
                        lock()
                        POST(auth, `/api/agentskie-voznagrazhdeniya/updatesummanatekushchii`, { ...item, summaNaTekushchii: val },
                            ({ data }) => {
                                // setCollection(o => updateInArray(o, { ...item, ...data }))
                                update()
                                unlock()
                            }, (err) => errorCatch(err, () => { onError(err); unlock(); }))
                    }}
                />
            </td>
        </tr>
        {(!collapsed) && <tr key={idx + "ext"}>
            <td colSpan={10}>
                <div className="bg bg-orange border-grey" style={{ borderColor: "darkgrey", textAlign: "left", marginLeft: "25px", paddingTop: "10px", marginTop: "5px", marginBottom: "5px" }}>
                    {item && <CollectionServer
                        auth={auth}
                        floatingFilter={true}
                        disableScrollTo={true}
                        headerStyle={{ flexDirection: "row-reverse" }}
                        footerStyle={{ flexDirection: "row-reverse" }}
                        filterPopoverPlacement="bottomLeft"
                        // onCollectionChange={(items) => {
                        //     if (items && items.length) {
                        //         const disabled = items[0]?.meropriyatie?.raschetAgentskikhProizveden;
                        //         const disabled2 = !disabled || items[0]?.meropriyatie?.dokAgentskikhVoznagrSozdani;
                        //         setDisabled(disabled)
                        //         setDisabled2(disabled2)
                        //     }
                        // }}
                        name={"OkazannieUslugiVAgentskikh"}
                        count={() => 10} // !!!! ИСПРАВИТЬ - сделать редактируемым или подобрать нужное количество !!!!
                        // queryDetail={"collection"}
                        source={`/api/agentskie-voznagrazhdeniya/uslugi/page/${item?.ID}`}
                        contextFilters={FilterFromContextFilter}
                        filters={filters}
                        size={"small"}
                        mode={"list"}
                        customRender={render}
                    />}
                </div>
            </td>
        </tr>}
    </React.Fragment>)
}

function AgentskieVoznagrazhdeniya(props) {
    const { auth, eventID } = props;
    // const [tableData, setTableData] = useState()
    const [disabled, setDisabled] = useState(false)
    const [disabled2, setDisabled2] = useState(false)

    const reinit = useCallback((
        collection,
        setCollection, update,
        lock,
        unlock) => {
        Modal.confirm({
            title: `Обновить`,
            icon: <ExclamationCircleOutlined />,
            content: (<div>
                <div>Вы уверены что хотите обновить все значения в таблице в соответствии с базой данных?</div>
                <div style={{ color: "rgba(0, 0, 0, 0.45)", fontSize: "12px", fontWeight: "lighter" }}>Если в таблице есть не сохраненные изменения, то они будут утеряны.</div>
            </div>),
            okText: "Да",
            okType: 'danger',
            cancelText: "Нет",
            onOk: () => {
                // setLoading(true)
                // GET(auth, `/api/agentskie-voznagrazhdeniya/list/${eventID}`, ({ data }) => {
                //     setCollection(data)
                //     setLoading(false)
                // }, (err) => errorCatch(err, () => setLoading(false)))
                update()
            },
        });
    }, [eventID])
    const fill = useCallback((
        collection,
        setCollection,
        update,
        lock,
        unlock) => {
        lock()
        GET(auth, `/api/agentskie-voznagrazhdeniya/fill/${eventID}`, ({ data }) => {
            // setCollection(data)
            update()
            unlock()
        }, (err) => errorCatch(err, () => unlock()))
    }, [eventID])
    const dropfilldata = useCallback((
        collection,
        setCollection,
        update,
        lock,
        unlock) => {
        Modal.confirm({
            title: `Очистить заполненые агентские вознаграждения`,
            icon: <ExclamationCircleOutlined />,
            content: (<div>
                <div>Вы уверены что хотите очистить значения заполненых агентских вознаграждений?</div>
            </div>),
            okText: "Да",
            okType: 'danger',
            cancelText: "Нет",
            onOk: () => {
                lock()
                GET(auth, `/api/agentskie-voznagrazhdeniya/dropfilldata/${eventID}`, ({ data }) => {
                    // setCollection(data)
                    setCollection([])
                    update()
                    unlock()
                }, (err) => errorCatch(err, () => unlock()))
            },
        });
    }, [eventID])
    const calc = useCallback((
        collection,
        setCollection,
        update,
        lock,
        unlock) => {
        lock()
        GET(auth, `/api/agentskie-voznagrazhdeniya/calc/${eventID}`, ({ data }) => {
            // setCollection(data)
            update()
            unlock()
        }, (err) => errorCatch(err, () => unlock()))
    }, [eventID])
    const clearcalcdata = useCallback((
        collection,
        setCollection,
        update,
        lock,
        unlock) => {
        Modal.confirm({
            title: `Очистить расчет агентских вознаграждений`,
            icon: <ExclamationCircleOutlined />,
            content: (<div>
                <div>Вы уверены что хотите очистить данные выполненного расчета агентских вознаграждений?</div>
            </div>),
            okText: "Да",
            okType: 'danger',
            cancelText: "Нет",
            onOk: () => {
                lock()
                GET(auth, `/api/agentskie-voznagrazhdeniya/clearcalcdata/${eventID}`, ({ data }) => {
                    // setCollection(data)
                    update()
                    unlock()
                }, (err) => errorCatch(err, () => unlock()))
            },
        });
    }, [eventID])
    const createdocuments = useCallback((
        collection,
        setCollection,
        update,
        lock,
        unlock) => {
        lock()
        GET(auth, `/api/agentskie-voznagrazhdeniya/createdocuments/${eventID}`, ({ data }) => {
            // setCollection(data)
            update()
            unlock()
        }, (err) => errorCatch(err, () => unlock()))
    }, [eventID])

    const filters = () => [
        {
            name: "vtp.user.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "vtp.user.firstname",
            sort: true,
            filter: true,
        },
        // {
        //     name: "vtp.user.patronymic",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "vtp.user.email",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: <span>Телефон<span style={{
        //         fontStyle: "italic",
        //         fontSize: "11px",
        //         paddingLeft: "5px",
        //         color: "#818181"
        //     }}>(без +)</span></span>,
        //     name: "vtp.user.phone",
        //     // type: "string",
        //     sort: true,
        //     filter: true,
        // },
        {
            name: "vtp.user.gender",
            sort: true,
            filter: true,
        },
        {
            label: "Тип пользователя",
            name: "vtp.tipPolzovatelya",
            filterType: "group",
            queryFilter: [
                QueryDetail("model"),
                QueryParam("w-in-id", "18,33,34,35")
                // QueryParam("w-neq-id", "7")
            ],
            display: (o) => o.opisanie,
            sort: true,
            filter: true,
        },
        //item?.aktivnost
        {
            label: "Категория",
            name: "kategoriya",
            source: `/api/meropriyatiya/kategoriiuchastnikovnameropriyatiyakh/list/${eventID}`,
            displayString: (item) => {
                return item?.tantsevalnayaDistsiplinaPsevdonim + ", " + item?.kategoriyaUchastnikovPsevdonim
            },
            display: (item) => {
                return <CategoryName category={item} style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }} />
            },
            queryFilter: [
                QueryDetail("model"),
                QueryParam("w-meropriyatie", eventID),
                QueryOrder("tantsevalnayaDistsiplinaPsevdonim", "ASC"),
                QueryOrder("kategoriyaUchastnikovPsevdonim", "ASC")
            ],
            sort: true,
            filter: true
        },
        {
            label: <FilterFieldLabel label="Промокод" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
            name: "promokod.promokod",
            // queryComparer:"swsim", // sim, wsim, swsim
            sort: true,
            filter: true,
        },
        {
            label: "Агентское вознаграждение %",
            name: "agentskoeVoznagrazhdenieProtsent",
            type: "int",
            filterType: "range",
            // func: ["min", "max"],
            min: 0,
            max: 100,
            sort: true,
            filter: true,
        },
        {
            label: "Агентское вознаграждение сумма",
            name: "agentskoeVoznagrazhdenieSumma",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: 'Активная',
            display: item => item.aktivno, //(item.notActive) ? "Да" : "Нет",
            name: "active",
            type: "bool",
            filter: true
        },
        {
            label: 'Неактивная',
            display: item => !item.aktivno, //(item.notActive) ? "Да" : "Нет",
            name: "aktivno",
            type: "bool",
            filter: true
        },
        {
            label: "Гонорар расчетный",
            name: "gonorarRaschetnii",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Гонорар к перечислению",
            name: "summaRaschetnaya",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Сумма на накопительный",
            name: "summaNaNakopitelnii",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Сумма на текущий",
            name: "summaNaTekushchii",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
    ];

    const render = (items, {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    }) => {
        const agentskoeVoznagrazhdenieSumma = lastFuncStat?.agentskoevoznagrazhdeniesumma?.sum || 0;
        const gonorarRaschetnii = lastFuncStat?.gonorarraschetnii?.sum || 0;
        const summaRaschetnaya = lastFuncStat?.summaraschetnaya?.sum || 0;
        const summaNaNakopitelnii = lastFuncStat?.summananakopitelnii?.sum || 0;
        const summaNaTekushchii = lastFuncStat?.summanatekushchii?.sum || 0;

        return (<div>
            <Spin spinning={loading} tip="Загрузка...">
                <div className='bg bg-grey' style={{ display: "flex", justifyContent: "space-between", padding: "3px", marginBottom: "5px" }}>
                    <div style={{ display: "flex", gap: "3px" }}>
                        <Tooltip title="Заполнить">
                            <div className={`bg bg-grey pointer`} onClick={() => fill(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <BgColorsOutlined style={{ color: "blue" }} />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                        <Tooltip title="Очистить заполнение">
                            <div className={`bg bg-grey pointer`} onClick={() => dropfilldata(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <BgColorsOutlined style={{ color: "red" }} />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                        <Tooltip title="Расчет гонораров">
                            <div className={`bg bg-grey pointer`} onClick={() => calc(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <CalculatorOutlined style={{ color: "blue" }} />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                        <Tooltip title="Удалить расчет гонораров">
                            <div className={`bg bg-grey pointer`} onClick={() => clearcalcdata(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <CalculatorOutlined style={{ color: "red" }} />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                        <Tooltip title="Создание документов">
                            <div className={`bg bg-grey pointer`} onClick={() => createdocuments(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <DiffOutlined style={{ color: "green" }} />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                    </div>
                    <div style={{ display: "flex", gap: "3px" }}>
                        <Tooltip title="Обновить значения">
                            <div className={`bg bg-grey pointer`} onClick={() => reinit(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <IssuesCloseOutlined />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                    </div>
                </div>
                <div className='scrollable' style={{ backgroundColor: "white" }}>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr>
                                <th className={`fixed height-8`} style={{ minWidth: "25px", backgroundColor: "white" }}>
                                    <div className="bg bg-grey" style={{ minWidth: "25px", backgroundColor: "white" }}></div>
                                </th>
                                <th className={`fixed height-8`} style={{ left: "25px", minWidth: "180px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Промоутер / артист / куратор / владелец школы</div>
                                </th>
                                <th className="fixed height-8" style={{ left: "205px", minWidth: "200px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Активность / Категория / Промокод</div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Агентское вознаграждение %
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Агентское вознаграждение сумма
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "45px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Активно
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Гонорар расчетный
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Гонорар к перечислению
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Сумма на накопительный
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Сумма на текущий
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th className={`fixed height-4`} style={{ minWidth: "25px", minWidth: "unset" }}>
                                    <div className="bg bg-grey" style={{ minWidth: "25px", backgroundColor: "white" }}></div>
                                </th>
                                <th className={`fixed height-4`} style={{ left: "25px", minWidth: "180px", minWidth: "unset", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}></div>
                                </th>
                                <th className="fixed height-4" style={{ left: "205px", minWidth: "200px", minWidth: "unset", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}></div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">

                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Агентское вознаграждение сумма */}
                                        {(Number(agentskoeVoznagrazhdenieSumma.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "45px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">

                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Гонорар расчетный */}
                                        {(Number(gonorarRaschetnii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма расчетная */}
                                        {(Number(summaRaschetnaya.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма на накопительный */}
                                        {(Number(summaNaNakopitelnii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма на текущий */}
                                        {(Number(summaNaTekushchii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(items || [], (item, cidx) => {
                                return (<AgentskieVoznagrazhdeniyaRow key={cidx} item={item} idx={cidx} eventID={eventID} disabled={disabled} disabled2={disabled2} renderProps={{
                                    collection,
                                    setCollection,
                                    setCollectionItem,
                                    removeCollectionItem,
                                    collectionActions,
                                    modelActions,
                                    update,
                                    lastFuncStat,
                                    lock,
                                    unlock,
                                    loading
                                }} />)
                            })}
                        </tbody>
                    </table>
                </div>
            </Spin>
        </div>)
    }

    const FilterFromContextFilter = React.useCallback(() => [
        QueryParam("f-sum-agentskoeVoznagrazhdenieSumma", 0),
        QueryParam("f-sum-gonorarRaschetnii", 0),
        QueryParam("f-sum-summaRaschetnaya", 0),
        QueryParam("f-sum-summaNaNakopitelnii", 0),
        QueryParam("f-sum-summaNaTekushchii", 0),
    ], [eventID]);

    return (<div>
        <CollectionServer
            auth={auth}
            floatingFilter={true}
            disableScrollTo={true}
            allowFullscreen={true}
            onCollectionChange={(items) => {
                if (items && items.length) {
                    const disabled = items[0]?.meropriyatie?.raschetAgentskikhProizveden;
                    const disabled2 = !disabled || items[0]?.meropriyatie?.dokAgentskikhVoznagrSozdani;
                    setDisabled(disabled)
                    setDisabled2(disabled2)
                }
            }}
            name={"AgentskieVoznagrazhdeniya"}
            // count={() => 10} // !!!! ИСПРАВИТЬ - сделать редактируемым или подобрать нужное количество !!!!
            // queryDetail={"collection"}
            source={`/api/agentskie-voznagrazhdeniya/page/${eventID}`}
            contextFilters={FilterFromContextFilter}
            filters={filters}
            size={"small"}
            mode={"list"}
            customRender={render}
        />
    </div>)
}

function AgentskieVoznagrazhdeniyaKViplateRow({ item, idx, eventID, disabled, renderProps }) {
    const [collapsed, setCollapsed] = useState(true);
    const auth = useAuth()
    const {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    } = renderProps;

    const FilterFromContextFilter = React.useCallback(() => [
        QueryParam("f-sum-agentskoeVoznagrazhdenieSumma", 0),
        QueryParam("f-sum-gonorarRaschetnii", 0),
        QueryParam("f-sum-summaRaschetnaya", 0),
        QueryParam("f-sum-summaNaNakopitelnii", 0),
        QueryParam("f-sum-summaNaTekushchii", 0),
    ], [item, idx, eventID, disabled]);
    const filters = () => [
        {
            name: "vtp.user.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "vtp.user.firstname",
            sort: true,
            filter: true,
        },
        // {
        //     name: "vtp.user.patronymic",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "vtp.user.email",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: <span>Телефон<span style={{
        //         fontStyle: "italic",
        //         fontSize: "11px",
        //         paddingLeft: "5px",
        //         color: "#818181"
        //     }}>(без +)</span></span>,
        //     name: "vtp.user.phone",
        //     // type: "string",
        //     sort: true,
        //     filter: true,
        // },
        {
            name: "vtp.user.gender",
            sort: true,
            filter: true,
        },
        {
            label: "Тип пользователя",
            name: "vtp.tipPolzovatelya",
            filterType: "group",
            queryFilter: [
                QueryDetail("model"),
                QueryParam("w-in-id", "18,33,34,35")
                // QueryParam("w-neq-id", "7")
            ],
            display: (o) => o.opisanie,
            sort: true,
            filter: true,
        },
        //item?.aktivnost
        {
            label: "Категория",
            name: "kategoriya",
            source: `/api/meropriyatiya/kategoriiuchastnikovnameropriyatiyakh/list/${eventID}`,
            displayString: (item) => {
                return item?.tantsevalnayaDistsiplinaPsevdonim + ", " + item?.kategoriyaUchastnikovPsevdonim
            },
            display: (item) => {
                return <CategoryName category={item} style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }} />
            },
            queryFilter: [
                QueryDetail("model"),
                QueryParam("w-meropriyatie", eventID),
                QueryOrder("tantsevalnayaDistsiplinaPsevdonim", "ASC"),
                QueryOrder("kategoriyaUchastnikovPsevdonim", "ASC")
            ],
            sort: true,
            filter: true
        },
        {
            label: <FilterFieldLabel label="Промокод" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
            name: "promokod.promokod",
            // queryComparer:"swsim", // sim, wsim, swsim
            sort: true,
            filter: true,
        },
        {
            label: "Агентское вознаграждение %",
            name: "agentskoeVoznagrazhdenieProtsent",
            type: "int",
            filterType: "range",
            // func: ["min", "max"],
            min: 0,
            max: 100,
            sort: true,
            filter: true,
        },
        {
            label: "Агентское вознаграждение сумма",
            name: "agentskoeVoznagrazhdenieSumma",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: 'Активная',
            display: item => item.aktivno, //(item.notActive) ? "Да" : "Нет",
            name: "active",
            type: "bool",
            filter: true
        },
        {
            label: 'Неактивная',
            display: item => !item.aktivno, //(item.notActive) ? "Да" : "Нет",
            name: "aktivno",
            type: "bool",
            filter: true
        },
        {
            label: "Гонорар расчетный",
            name: "gonorarRaschetnii",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Сумма расчетная",
            name: "summaRaschetnaya",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Сумма на накопительный",
            name: "summaNaNakopitelnii",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Сумма на текущий",
            name: "summaNaTekushchii",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
    ];
    const render = (items, {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    }) => {
        const agentskoeVoznagrazhdenieSumma = lastFuncStat?.agentskoevoznagrazhdeniesumma?.sum || 0;
        const gonorarRaschetnii = lastFuncStat?.gonorarraschetnii?.sum || 0;
        const summaRaschetnaya = lastFuncStat?.summaraschetnaya?.sum || 0;
        const summaNaNakopitelnii = lastFuncStat?.summananakopitelnii?.sum || 0;
        const summaNaTekushchii = lastFuncStat?.summanatekushchii?.sum || 0;

        return (<div>
            <Spin spinning={loading} tip="Загрузка...">
                <div className='scrollable' style={{}}>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr>
                                {/* <th className={`fixed height-8`} style={{ width: "25px" }}></th> */}
                                <th className={`fixed height-8`} style={{ minWidth: "180px", maxWidth: "180px" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Промоутер / артист / куратор / владелец школы</div>
                                </th>
                                <th className="fixed height-8" style={{ left: "180px", minWidth: "180px", maxWidth: "180px" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Активность / Категория / Промокод</div>
                                </th>
                                <th className="height-8" style={{ minWidth: "120px", maxWidth: "120px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Агентское вознаграждение %
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "120px", maxWidth: "120px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Агентское вознаграждение сумма
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "45px", maxWidth: "45px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Активно
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", maxWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Гонорар расчетный
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "110px", maxWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Гонорар к перечислению
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "110px", maxWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Сумма на накопительный
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", maxWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Сумма на текущий
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                {/* <th className={`fixed height-4`} style={{ minWidth: "25px", minWidth: "unset" }}></th> */}
                                <th className={`fixed height-4`} style={{ minWidth: "180px", minWidth: "unset" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}></div>
                                </th>
                                <th className="fixed height-4" style={{ left: "180px", minWidth: "180px", minWidth: "unset" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}></div>
                                </th>
                                <th className="height-4" style={{ minWidth: "120px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">

                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "120px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Агентское вознаграждение сумма */}
                                        {(Number(agentskoeVoznagrazhdenieSumma.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "45px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">

                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Гонорар расчетный */}
                                        {(Number(gonorarRaschetnii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "110px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма расчетная */}
                                        {(Number(summaRaschetnaya.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "110px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма на накопительный */}
                                        {(Number(summaNaNakopitelnii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма на текущий */}
                                        {(Number(summaNaTekushchii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(items || [], (item, cidx) => {
                                return (<tr key={idx}>
                                    {/* <td className={`fixed pointer height-5`} style={{ minWidth: "25px" }} onClick={() => {
                                        setCollapsed(o => !o);
                                    }}>
                                        <div className={`bg ${(!collapsed) ? "bg-orange dark-5" : "bg-grey"}`} style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
                                            {(collapsed) && <i className="fa fa-plus-square-o"></i>}
                                            {(!collapsed) && <i className="fa fa-minus-square-o"></i>}
                                        </div>
                                    </td> */}
                                    <td className={`fixed height-5`} style={{ minWidth: "180px" }}>
                                        <div>
                                            <UserName item={item?.vtp?.user} noborder={true} />
                                            <div style={{
                                                color: "rgba(0, 0, 0, 0.45)",
                                                textAlign: "left",
                                                textWrap: "nowrap",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                fontSize: "12px",
                                                fontWeight: "lighter",
                                                paddingLeft: "20px"
                                            }}>
                                                <span>{item?.vtp?.tipPolzovatelya?.opisanie}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="fixed height-5" style={{ left: "180px", minWidth: "180px" }}>
                                        {item?.aktivnost && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                                            <div style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}>
                                                <div style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    textAlign: "left",
                                                    textWrap: "nowrap",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter"
                                                }}>
                                                    Активность
                                                </div>
                                                <div style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}>{item?.aktivnost?.nazvanie}</div>
                                            </div>
                                        </div>}
                                        {item?.kategoriya && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                                            <div style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}>
                                                <div style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    textAlign: "left",
                                                    textWrap: "nowrap",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter"
                                                }}>
                                                    Категория
                                                </div>
                                                <CategoryName category={item?.kategoriya} style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }} />
                                            </div>
                                        </div>}
                                        {item?.promokod && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                                            <div style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}>
                                                <div style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    textAlign: "left",
                                                    textWrap: "nowrap",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter"
                                                }}>
                                                    Промокод
                                                </div>
                                                <div style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}>{item?.promokod?.promokod}</div>
                                            </div>
                                        </div>}
                                        {(!item?.aktivnost && !item?.kategoriya && !item?.promokod) && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                                            <div>

                                            </div>
                                        </div>}
                                    </td>
                                    <td className="height-5" style={{ minWidth: "120px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.agentskoeVoznagrazhdenieProtsent?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "120px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.agentskoeVoznagrazhdenieSumma?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "100px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>{(item?.aktivno) ? "Да" : "Нет"}</div>
                                        </div>
                                    </td>

                                    <td className="height-5" style={{ minWidth: "100px" }}>
                                        <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.gonorarRaschetnii?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "110px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.summaRaschetnaya?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "110px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.summaNaNakopitelnii?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "100px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.summaNaTekushchii?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                </tr>)
                            })}
                        </tbody>
                    </table>
                </div>
            </Spin>
        </div>)
    }
    return (<React.Fragment key={idx + "wrap"}>
        <tr key={idx}>
            <td className={`fixed pointer height-5`} style={{ minWidth: "25px", backgroundColor: "white" }} onClick={() => {
                setCollapsed(o => !o);
            }}>
                <div className={`bg ${(!collapsed) ? "bg-orange dark-5" : "bg-grey"}`} style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
                    {(collapsed) && <i className="fa fa-plus-square-o"></i>}
                    {(!collapsed) && <i className="fa fa-minus-square-o"></i>}
                </div>
            </td>
            <td className={`fixed height-4`} style={{ left: "25px", minWidth: "180px", backgroundColor: "white" }}>
                <div style={{ padding: "2px 0px" }}>
                    <UserName item={item?.polzovatel} noborder={true} />
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/* Общее расчетное вознаграждение */}
                        {(Number(item?.obshcheeRaschetnoeVoznagrazhdenie?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/* Общее расчетное (НЕ Промоутер) */}
                        {(Number(item?.summaRaschetnayaNePromouter?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/* Сумма на накопительный (НЕ Промоутер) */}
                        {(Number(item?.summaNaNakopitelniiNePromouter?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/*  Сумма на текущий (НЕ Промоутер) */}
                        {(Number(item?.summaNaTekushchiiNePromouter?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/* Оборот по промоутерству */}
                        {(Number(item?.oborotPoPromouterstvu?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/* Сумма расчетная (Промоутер) */}
                        {(Number(item?.summaRaschetnayaPromouter?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/* Сумма на накопительный (Промоутер) */}
                        {(Number(item?.summaNaNakopitelniiPromouter?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/* Сумма на текущий (Промоутер) */}
                        {(Number(item?.summaNaTekushchiiPromouter?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                {/* ! Гонорар как приглашенный артист */}
                <FloatCell
                    disabled={disabled}
                    colorClass={(!disabled) ? `bg-blue border-transparent` : `bg-blue border-darkgreen`}
                    value={item?.gonorarPriglashennogoArtista}
                    onChange={(val, onError) => {
                        lock()
                        POST(auth, `/api/agentskie-voznagrazhdeniya/updatedocument`, { ...item, gonorarPriglashennogoArtista: val },
                            ({ data }) => {
                                update()
                                unlock()
                            }, (err) => errorCatch(err, () => { onError(err); unlock(); }))
                    }}
                />
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                {/* ! Доп затраты на промоутера */}
                <FloatCell
                    disabled={disabled}
                    colorClass={(!disabled) ? `bg-blue border-transparent` : `bg-blue border-darkgreen`}
                    value={item?.dopZatratiNaPromoutera}
                    onChange={(val, onError) => {
                        lock()
                        POST(auth, `/api/agentskie-voznagrazhdeniya/updatedocument`, { ...item, dopZatratiNaPromoutera: val },
                            ({ data }) => {
                                update()
                                unlock()
                            }, (err) => errorCatch(err, () => { onError(err); unlock(); }))
                    }}
                />
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                {/* ! Процент рентабельности */}
                <FloatCell
                    disabled={disabled}
                    colorClass={(!disabled) ? `bg-blue border-transparent` : `bg-blue border-darkgreen`}
                    value={item?.protsentRentabelnosti}
                    onChange={(val, onError) => {
                        lock()
                        POST(auth, `/api/agentskie-voznagrazhdeniya/updatedocument`, { ...item, protsentRentabelnosti: val },
                            ({ data }) => {
                                update()
                                unlock()
                            }, (err) => errorCatch(err, () => { onError(err); unlock(); }))
                    }}
                />
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/* База для расчета промоутерства */}
                        {(Number(item?.bazaDlyaRaschetaPromouterstva?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/*  К выплате гонорар как приглашенный (Артист) */}
                        {(Number(item?.kViplateGonorarKakPriglashenniiArtist?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        {/*  Общее вознаграждение к выплате (Промоутер) */}
                        {(Number(item?.obshcheeVoznagrazhdenieKViplatePromouter?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                    </div>
                </div>
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                {/* ! К выплате на накопительный счет */}
                <FloatCell
                    disabled={disabled}
                    colorClass={(!disabled) ? `bg-blue border-transparent` : `bg-blue border-darkgreen`}
                    value={item?.kViplateNaNakopitelniiSchet}
                    onChange={(val, onError) => {
                        lock()
                        POST(auth, `/api/agentskie-voznagrazhdeniya/updatekviplatenanakopitelniischet`, { ...item, kViplateNaNakopitelniiSchet: val },
                            ({ data }) => {
                                update()
                                unlock()
                            }, (err) => errorCatch(err, () => { onError(err); unlock(); }))
                    }}
                />
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                {/* ! К выплате на текущий счет */}
                <FloatCell
                    disabled={disabled}
                    colorClass={(!disabled) ? `bg-blue border-transparent` : `bg-blue border-darkgreen`}
                    value={item?.kViplateNaTekushchiiSchet}
                    onChange={(val, onError) => {
                        lock()
                        POST(auth, `/api/agentskie-voznagrazhdeniya/updatekviplatenatekushchiischet`, { ...item, kViplateNaTekushchiiSchet: val },
                            ({ data }) => {
                                update()
                                unlock()
                            }, (err) => errorCatch(err, () => { onError(err); unlock(); }))
                    }}
                />
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                {/* Проводка на накопительный*/}
                <FloatCell
                    disabled={disabled}
                    colorClass={(!disabled) ? `bg-blue border-transparent` : `bg-blue border-darkgreen`}
                    value={item?.provodkaNaNakopitelnii}
                    onChange={(val, onError) => {
                        lock()
                        POST(auth, `/api/agentskie-voznagrazhdeniya/updateprovodkananakopitelnii`, { ...item, provodkaNaNakopitelnii: val },
                            ({ data }) => {
                                update()
                                unlock()
                            }, (err) => errorCatch(err, () => { onError(err); unlock(); }))
                    }}
                />
            </td>
            <td className="height-4" style={{ minWidth: "100px", backgroundColor: "white" }}>
                {/*  Проводка на текущий*/}
                <FloatCell
                    disabled={disabled}
                    colorClass={(!disabled) ? `bg-blue border-transparent` : `bg-blue border-darkgreen`}
                    value={item?.provodkaNaTekushchii}
                    onChange={(val, onError) => {
                        lock()
                        POST(auth, `/api/agentskie-voznagrazhdeniya/updateprovodkanatekushchii`, { ...item, provodkaNaTekushchii: val },
                            ({ data }) => {
                                update()
                                unlock()
                            }, (err) => errorCatch(err, () => { onError(err); unlock(); }))
                    }}
                />
            </td>
            <td className="height-4" style={{ minWidth: "250px", maxWidth: "250px", backgroundColor: "white" }}>
                <StringValueCell item={item} value={item?.kommentarii} style={{ height: "100%", textAlign: "left" }}
                    onChange={(val, onError) => {
                        lock()
                        POST(auth, `/api/agentskie-voznagrazhdeniya/updatedocument`, { ...item, kommentarii: val },
                            ({ data }) => {
                                update()
                                unlock()
                            }, (err) => errorCatch(err, () => { onError(err); unlock(); }))
                    }} />
            </td>
        </tr>
        {(!collapsed) && <tr key={idx + "ext"}>
            <td colSpan={21}>
                <div className="bg bg-orange border-grey" style={{ borderColor: "darkgrey", textAlign: "left", marginLeft: "25px", paddingTop: "10px", marginTop: "5px", marginBottom: "5px" }}>
                    {item && <CollectionServer
                        auth={auth}
                        floatingFilter={true}
                        disableScrollTo={true}
                        headerStyle={{ flexDirection: "row-reverse" }}
                        footerStyle={{ flexDirection: "row-reverse" }}
                        filterPopoverPlacement="bottomLeft"
                        // onCollectionChange={(items) => {
                        //     if (items && items.length) {
                        //         const disabled = items[0]?.meropriyatie?.raschetAgentskikhProizveden;
                        //         const disabled2 = !disabled || items[0]?.meropriyatie?.dokAgentskikhVoznagrSozdani;
                        //         setDisabled(disabled)
                        //         setDisabled2(disabled2)
                        //     }
                        // }}
                        name={"AgentskieVoznagrazhdeniya"}
                        count={() => 10} // !!!! ИСПРАВИТЬ - сделать редактируемым или подобрать нужное количество !!!!
                        // queryDetail={"collection"}
                        source={`/api/agentskie-voznagrazhdeniya-k-viplate/agentskie-voznagrazhdeniya/page/${item?.ID}`}
                        contextFilters={FilterFromContextFilter}
                        filters={filters}
                        size={"small"}
                        mode={"list"}
                        customRender={render}
                    />}
                </div>
            </td>
        </tr>}
    </React.Fragment>)
}

function AgentskieVoznagrazhdeniyaKViplate(props) {
    const { auth, eventID } = props;

    const reinit = useCallback((
        collection,
        setCollection, update,
        lock,
        unlock) => {
        update()
        // Modal.confirm({
        //     title: `Обновить`,
        //     icon: <ExclamationCircleOutlined />,
        //     content: (<div>
        //         <div>Вы уверены что хотите обновить все значения в таблице в соответствии с базой данных?</div>
        //         <div style={{ color: "rgba(0, 0, 0, 0.45)", fontSize: "12px", fontWeight: "lighter" }}>Если в таблице есть не сохраненные изменения, то они будут утеряны.</div>
        //     </div>),
        //     okText: "Да",
        //     okType: 'danger',
        //     cancelText: "Нет",
        //     onOk: () => {
        //         lock()
        //         GET(auth, `/api/agentskie-voznagrazhdeniya-k-viplate/list/${eventID}`, ({ data }) => {
        //             update()
        //             unlock()
        //         }, (err) => errorCatch(err, () => unlock()))
        //     },
        // });
    }, [eventID])
    const dropdocuments = useCallback((
        collection,
        setCollection, update,
        lock,
        unlock) => {
        Modal.confirm({
            title: `Удалить документы`,
            icon: <ExclamationCircleOutlined />,
            content: (<div>
                <div>Вы уверены что хотите удалить документы агентских вознаграждений?</div>
                <div style={{ color: "rgba(0, 0, 0, 0.45)", fontSize: "12px", fontWeight: "lighter" }}>Документы будут удалены только в том случае если ещё нет проведенных документов.</div>
            </div>),
            okText: "Да",
            okType: 'danger',
            cancelText: "Нет",
            onOk: () => {
                lock()
                GET(auth, `/api/agentskie-voznagrazhdeniya/dropdocuments/${eventID}`, ({ data }) => {
                    update()
                    unlock()
                }, (err) => errorCatch(err, () => unlock()))
            },
        });
    }, [eventID])
    const fixed = useCallback((
        collection,
        setCollection, update,
        lock,
        unlock) => {
        Modal.confirm({
            title: `Провести документы агентских вознаграждений`,
            icon: <ExclamationCircleOutlined />,
            content: (<div>
                <div>Вы уверены что хотите выполнить проведение документов агентских вознаграждений?</div>
                <div style={{ color: "rgba(0, 0, 0, 0.45)", fontSize: "12px", fontWeight: "lighter" }}>
                    Будет выполнено начисление денежных средств на счета агентов. Отмена невозможна!
                </div>
            </div>),
            okText: "Да",
            okType: 'danger',
            cancelText: "Нет",
            onOk: () => {
                lock()
                GET(auth, `/api/agentskie-voznagrazhdeniya/fixed/${eventID}`, ({ data }) => {
                    update()
                    unlock()
                }, (err) => errorCatch(err, () => unlock()))
            },
        });
    }, [eventID])

    const filters = () => [
        {
            name: "polzovatel.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "polzovatel.firstname",
            sort: true,
            filter: true,
        },
        // {
        //     name: "polzovatel.patronymic",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "polzovatel.email",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: <span>Телефон<span style={{
        //         fontStyle: "italic",
        //         fontSize: "11px",
        //         paddingLeft: "5px",
        //         color: "#818181"
        //     }}>(без +)</span></span>,
        //     name: "polzovatel.phone",
        //     // type: "string",
        //     sort: true,
        //     filter: true,
        // },
        {
            name: "polzovatel.gender",
            sort: true,
            filter: true,
        },
        {
            label: "Общее расчетное вознаграждение",
            name: "obshcheeRaschetnoeVoznagrazhdenie",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            //min: 0,
            //max: 100,
            sort: true,
            filter: true,
        },
        {
            label: (<div>
                <div>Общее расчетное</div>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>(НЕ Промоутер)</div>
            </div>),
            name: "summaRaschetnayaNePromouter",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: (<div>
                <div>Сумма на накопительный</div>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>(НЕ Промоутер)</div>
            </div>),
            // label: "Сумма на накопительный (НЕ Промоутер)",
            name: "summaNaNakopitelniiNePromouter",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: (<div>
                <div>Сумма на текущий</div>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>(НЕ Промоутер)</div>
            </div>),
            // label: "Сумма на текущий (НЕ Промоутер)",
            name: "summaNaTekushchiiNePromouter",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Оборот по промоутерству",
            name: "oborotPoPromouterstvu",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: (<div>
                <div>Сумма расчетная</div>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>(Промоутер)</div>
            </div>),
            // label: "Сумма расчетная (Промоутер)",
            name: "summaRaschetnayaPromouter",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: (<div>
                <div>Сумма на накопительный</div>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>(Промоутер)</div>
            </div>),
            // label: "Сумма на накопительный (Промоутер)",
            name: "summaNaNakopitelniiPromouter",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: (<div>
                <div>Сумма на текущий</div>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>(Промоутер)</div>
            </div>),
            // label: "Сумма на текущий (Промоутер)",
            name: "summaNaTekushchiiPromouter",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Гонорар как приглашенный артист",
            name: "gonorarPriglashennogoArtista",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            //min: 0,
            //max: 100,
            sort: true,
            filter: true,
        },
        {
            label: "Доп затраты на промоутера",
            name: "dopZatratiNaPromoutera",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Процент рентабельности",
            name: "protsentRentabelnosti",
            type: "int",
            filterType: "range",
            // func: ["min", "max"],
            min: 0,
            max: 100,
            sort: true,
            filter: true,
        },
        {
            label: (<div>
                <div>К выплате гонорар как приглашенный</div>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>(Артист)</div>
            </div>),
            // label: "К выплате гонорар как приглашенный (Артист)",
            name: "kViplateGonorarKakPriglashenniiArtist",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: (<div>
                <div>Общее вознаграждение к выплате</div>
                <div style={{
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "#818181"
                }}>(Промоутер)</div>
            </div>),
            // label: "Общее вознаграждение к выплате (Промоутер)",
            name: "obshcheeVoznagrazhdenieKViplatePromouter",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "К выплате на накопительный счет",
            name: "kViplateNaNakopitelniiSchet",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "К выплате на текущий счет",
            name: "kViplateNaTekushchiiSchet",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Проводка на накопительный",
            name: "provodkaNaNakopitelnii",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Проводка на текущий",
            name: "provodkaNaTekushchii",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
    ];

    const render = (items, {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    }) => {
        const obshcheeRaschetnoeVoznagrazhdenie = lastFuncStat?.obshcheeraschetnoevoznagrazhdenie?.sum || 0;
        const summaRaschetnayaNePromouter = lastFuncStat?.summaraschetnayanepromouter?.sum || 0;
        const summaNaNakopitelniiNePromouter = lastFuncStat?.summananakopitelniinepromouter?.sum || 0;
        const summaNaTekushchiiNePromouter = lastFuncStat?.summanatekushchiinepromouter?.sum || 0;
        const oborotPoPromouterstvu = lastFuncStat?.oborotpopromouterstvu?.sum || 0;
        const summaRaschetnayaPromouter = lastFuncStat?.summaraschetnayapromouter?.sum || 0;
        const summaNaNakopitelniiPromouter = lastFuncStat?.summananakopitelniipromouter?.sum || 0;
        const summaNaTekushchiiPromouter = lastFuncStat?.summanatekushchiipromouter?.sum || 0;
        const gonorarPriglashennogoArtista = lastFuncStat?.gonorarpriglashennogoartista?.sum || 0;
        const dopZatratiNaPromoutera = lastFuncStat?.dopzatratinapromoutera?.sum || 0;
        const kViplateGonorarKakPriglashenniiArtist = lastFuncStat?.kviplategonorarkakpriglashenniiartist?.sum || 0;
        const obshcheeVoznagrazhdenieKViplatePromouter = lastFuncStat?.obshcheevoznagrazhdeniekviplatepromouter?.sum || 0;
        const kViplateNaNakopitelniiSchet = lastFuncStat?.kviplatenanakopitelniischet?.sum || 0;
        const kViplateNaTekushchiiSchet = lastFuncStat?.kviplatenatekushchiischet?.sum || 0;
        const provodkaNaNakopitelnii = lastFuncStat?.provodkananakopitelnii?.sum || 0;
        const provodkaNaTekushchii = lastFuncStat?.provodkanatekushchii?.sum || 0;

        return (<div>
            <Spin spinning={loading} tip="Загрузка...">
                <div className='bg bg-grey' style={{ display: "flex", justifyContent: "space-between", padding: "3px", marginBottom: "5px" }}>
                    <div style={{ display: "flex", gap: "3px" }}>
                        <Tooltip title="Удаление документов">
                            <div className={`bg bg-grey pointer`} onClick={() => dropdocuments(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <DiffOutlined style={{ color: "red" }} />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                        <Tooltip title="Проведение документов">
                            <div className={`bg bg-grey pointer`} onClick={() => fixed(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <FileDoneOutlined style={{ color: "green" }} />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                    </div>
                    <div style={{ display: "flex", gap: "3px" }}>
                        <Tooltip title="Обновить значения">
                            <div className={`bg bg-grey pointer`} onClick={() => reinit(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <IssuesCloseOutlined />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                    </div>
                </div>
                <div className='scrollable' style={{ backgroundColor: "white" }}>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr style={{ backgroundColor: "white" }}>
                                <th className={`fixed height-10`} style={{ minWidth: "25px", backgroundColor: "white" }}>
                                    <div className="bg bg-grey" style={{ minWidth: "25px", backgroundColor: "white" }}></div>
                                </th>
                                <th className={`fixed height-10`} style={{ left: "25px", minWidth: "180px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1'>Пользователь</div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Общее расчетное вознаграждение
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* Общее расчетное (НЕ Промоутер) */}
                                        <div>
                                            <div>Общее расчетное</div>
                                            <div style={{
                                                fontStyle: "italic",
                                                fontSize: "11px",
                                                color: "#818181"
                                            }}>(НЕ Промоутер)</div>
                                        </div>
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        <div>
                                            <div>Сумма на накопительный</div>
                                            <div style={{
                                                fontStyle: "italic",
                                                fontSize: "11px",
                                                color: "#818181"
                                            }}>(НЕ Промоутер)</div>
                                        </div>
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        <div>
                                            <div>Сумма на текущий</div>
                                            <div style={{
                                                fontStyle: "italic",
                                                fontSize: "11px",
                                                color: "#818181"
                                            }}>(НЕ Промоутер)</div>
                                        </div>
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Оборот по промоутерству
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* Сумма расчетная (Промоутер) */}
                                        <div>
                                            <div>Сумма расчетная</div>
                                            <div style={{
                                                fontStyle: "italic",
                                                fontSize: "11px",
                                                color: "#818181"
                                            }}>(Промоутер)</div>
                                        </div>
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* Сумма на накопительный (Промоутер) */}
                                        <div>
                                            <div>Сумма на накопительный</div>
                                            <div style={{
                                                fontStyle: "italic",
                                                fontSize: "11px",
                                                color: "#818181"
                                            }}>(Промоутер)</div>
                                        </div>
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* Сумма на текущий (Промоутер) */}
                                        <div>
                                            <div>Сумма на текущий</div>
                                            <div style={{
                                                fontStyle: "italic",
                                                fontSize: "11px",
                                                color: "#818181"
                                            }}>(Промоутер)</div>
                                        </div>
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Гонорар как приглашенный артист
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Доп затраты на промоутера
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Процент рентабельности
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        База для расчета промоутерства
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* К выплате гонорар как приглашенный (Артист) */}
                                        <div>
                                            <div>К выплате гонорар как приглашенный</div>
                                            <div style={{
                                                fontStyle: "italic",
                                                fontSize: "11px",
                                                color: "#818181"
                                            }}>(Артист)</div>
                                        </div>
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* Общее вознаграждение к выплате (Промоутер) */}
                                        <div>
                                            <div>Общее вознаграждение к выплате</div>
                                            <div style={{
                                                fontStyle: "italic",
                                                fontSize: "11px",
                                                color: "#818181"
                                            }}>(Промоутер)</div>
                                        </div>
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        К выплате на накопительный счет
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        К выплате на текущий счет
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Проводка на накопительный
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Проводка на текущий
                                    </div>
                                </th>
                                <th className="height-10" style={{ minWidth: "200px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Комментарий
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th className={`fixed height-4`} style={{ minWidth: "25px", minWidth: "unset", backgroundColor: "white" }}>
                                    <div className="bg bg-grey" style={{ minWidth: "25px", backgroundColor: "white" }}></div>
                                </th>
                                <th className={`fixed height-4`} style={{ left: "25px", minWidth: "180px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1'>
                                        {/* Пользователь */}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Общее расчетное вознаграждение */}
                                        {(Number(obshcheeRaschetnoeVoznagrazhdenie.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Общее расчетное (НЕ Промоутер) */}
                                        {(Number(summaRaschetnayaNePromouter.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма на накопительный (НЕ Промоутер) */}
                                        {(Number(summaNaNakopitelniiNePromouter.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма на текущий (НЕ Промоутер) */}
                                        {(Number(summaNaTekushchiiNePromouter.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Оборот по промоутерству */}
                                        {(Number(oborotPoPromouterstvu.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма расчетная (Промоутер) */}
                                        {(Number(summaRaschetnayaPromouter.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма на накопительный (Промоутер) */}
                                        {(Number(summaNaNakopitelniiPromouter.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Сумма на текущий (Промоутер) */}
                                        {(Number(summaNaTekushchiiPromouter.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Гонорар как приглашенный артист */}
                                        {(Number(gonorarPriglashennogoArtista.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Доп затраты на промоутера */}
                                        {(Number(dopZatratiNaPromoutera.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* Процент рентабельности */}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* База для расчета промоутерства */}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* К выплате гонорар как приглашенный (Артист) */}
                                        {(Number(kViplateGonorarKakPriglashenniiArtist.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Общее вознаграждение к выплате (Промоутер) */}
                                        {(Number(obshcheeVoznagrazhdenieKViplatePromouter.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* К выплате на накопительный счет */}
                                        {(Number(kViplateNaNakopitelniiSchet.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* К выплате на текущий счет */}
                                        {(Number(kViplateNaTekushchiiSchet.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Проводка на накопительный */}
                                        {(Number(provodkaNaNakopitelnii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                        {/* Проводка на текущий */}
                                        {(Number(provodkaNaTekushchii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "200px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        {/* Комментарий */}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(items || [], (item, cidx) => {
                                var disabled = item?.documentNaTekushchiiID || item?.documentNaNakopitelniiID;
                                return (<AgentskieVoznagrazhdeniyaKViplateRow key={cidx} item={item} idx={cidx} eventID={eventID} disabled={disabled} renderProps={{
                                    collection,
                                    setCollection,
                                    setCollectionItem,
                                    removeCollectionItem,
                                    collectionActions,
                                    modelActions,
                                    update,
                                    lastFuncStat,
                                    lock,
                                    unlock,
                                    loading
                                }} />)
                            })}
                        </tbody>
                    </table>
                </div>
            </Spin>
        </div>)
    }

    const FilterFromContextFilter = React.useCallback(() => [
        QueryParam("f-sum-obshcheeRaschetnoeVoznagrazhdenie", 0),
        QueryParam("f-sum-summaRaschetnayaNePromouter", 0),
        QueryParam("f-sum-summaNaNakopitelniiNePromouter", 0),
        QueryParam("f-sum-summaNaTekushchiiNePromouter", 0),
        QueryParam("f-sum-oborotPoPromouterstvu", 0),
        QueryParam("f-sum-summaRaschetnayaPromouter", 0),
        QueryParam("f-sum-summaNaNakopitelniiPromouter", 0),
        QueryParam("f-sum-summaNaTekushchiiPromouter", 0),
        QueryParam("f-sum-gonorarPriglashennogoArtista", 0),
        QueryParam("f-sum-dopZatratiNaPromoutera", 0),
        QueryParam("f-sum-kViplateGonorarKakPriglashenniiArtist", 0),
        QueryParam("f-sum-obshcheeVoznagrazhdenieKViplatePromouter", 0),
        QueryParam("f-sum-kViplateNaNakopitelniiSchet", 0),
        QueryParam("f-sum-kViplateNaTekushchiiSchet", 0),
        QueryParam("f-sum-provodkaNaNakopitelnii", 0),
        QueryParam("f-sum-provodkaNaTekushchii", 0),
    ], [eventID]);

    return (<div>
        <CollectionServer
            auth={auth}
            floatingFilter={true}
            disableScrollTo={true}
            allowFullscreen={true}
            name={"AgentskieVoznagrazhdeniyaKViplate"}
            // count={() => 5} // !!!! ИСПРАВИТЬ - сделать редактируемым или подобрать нужное количество !!!!
            // queryDetail={"collection"}
            source={`/api/agentskie-voznagrazhdeniya-k-viplate/page/${eventID}`}
            contextFilters={FilterFromContextFilter}
            filters={filters}
            size={"small"}
            mode={"list"}
            customRender={render}
        />
    </div>)
}

function AgentskieVoznagrazhdeniyaReport(props) {
    const { auth, eventID } = props;

    const reinit = useCallback((
        collection,
        setCollection, update,
        lock,
        unlock) => {
        update()
        // Modal.confirm({
        //     title: `Обновить`,
        //     icon: <ExclamationCircleOutlined />,
        //     content: (<div>
        //         <div>Вы уверены что хотите обновить все значения в таблице в соответствии с базой данных?</div>
        //         <div style={{ color: "rgba(0, 0, 0, 0.45)", fontSize: "12px", fontWeight: "lighter" }}>Если в таблице есть не сохраненные изменения, то они будут утеряны.</div>
        //     </div>),
        //     okText: "Да",
        //     okType: 'danger',
        //     cancelText: "Нет",
        //     onOk: () => {
        //         lock()
        //         GET(auth, `/api/agentskie-voznagrazhdeniya-k-viplate/list/${eventID}`, ({ data }) => {
        //             update()
        //             unlock()
        //         }, (err) => errorCatch(err, () => unlock()))
        //     },
        // });
    }, [eventID])
    const fill = useCallback((
        collection,
        setCollection,
        update,
        lock,
        unlock) => {
        lock()
        GET(auth, `/api/agentskie-voznagrazhdeniya/fillotchetpoagentskimvoznagrazhdeniyam/${eventID}`, ({ data }) => {
            // setCollection(data)
            update()
            unlock()
        }, (err) => errorCatch(err, () => unlock()))
    }, [eventID])

    const filters = () => [
        {
            label: "Фамилия",
            name: "okazannayaUsluga.polzovatel.lastname",
            type: "string",
            sort: true,
            filter: true,
            sorted: true
        },
        {
            label: "Имя",
            name: "okazannayaUsluga.polzovatel.firstname",
            type: "string",
            sort: true,
            filter: true,
        },
        // {
        //     name: "okazannayaUsluga.polzovatel.patronymic",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     name: "okazannayaUsluga.polzovatel.email",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: <span>Телефон<span style={{
        //         fontStyle: "italic",
        //         fontSize: "11px",
        //         paddingLeft: "5px",
        //         color: "#818181"
        //     }}>(без +)</span></span>,
        //     name: "okazannayaUsluga.polzovatel.phone",
        //     // type: "string",
        //     sort: true,
        //     filter: true,
        // },
        {
            label: "Пол",
            name: "okazannayaUsluga.polzovatel.gender",
            sort: true,
            filter: true,
        },
        {
            label: <FilterFieldLabel label="Промокод" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
            name: "okazannayaUsluga.uchastik.tovarVZakaze.zakaz.promokodSsilka.promokod",
            // queryComparer:"swsim", // sim, wsim, swsim
            sort: true,
            filter: true,
        },
        {
            label: "Ячейка",
            type: "object",
            relation: {
                reference: {
                    source: `/api/yacheikiuslugi/list-in-meropriyatie//${eventID}`,
                    queryFilter: [
                        QueryOrder("nazvanie", "ASC"),
                    ],
                }
            },
            name: "okazannayaUsluga.uslugaKlientu.yacheikaUsluga",
            filterType: "group",
            display: (o) => o.nazvanie,
            sort: true,
            filter: true
        },
        {
            label: "Услуга",
            type: "object",
            relation: {
                reference: {
                    source: `/api/usluginameropriyatii/bymeropriyatie/${eventID}`,
                    queryFilter: [
                        QueryOrder("nazvanie", "ASC"),
                    ],
                }
            },
            name: "okazannayaUsluga.uslugaKlientu.uslugaNaMeropriyatii",
            filterType: "group",
            display: (o) => o.nazvanie,
            sort: true,
            filter: true
        },
        {
            label: "Школа",
            name: "shkola.agentskoeVoznagrazhdenie.vtp.shkola",
            source: "/papi/fed/school/list",
            filterType: "group",
            display: (o) => o.nazvanieShkoliTantsev,
            queryFilter: [
                QueryOrder("nazvanieShkoliTantsev", "ASC"),
            ],
            sort: true,
            filter: true
        },
        {
            label: "Школа: Сумма",
            name: "shkolaSumma",
            // type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Промоутер",
            name: "promouter.agentskoeVoznagrazhdenie.vtp",
            source: `/api/meropriyatiya/promouteri-meropiyatiya/${eventID}`,
            filterType: "group",
            displayString: (o) => o.user.lastname + " " + o.user.firstname,
            display: (o) => (<UserName item={o.user} noborder={true} />),
            queryFilter: [
                QueryOrder("user.lastname", "ASC"),
                QueryOrder("user.firstname", "ASC"),
            ],
            sort: true,
            filter: true
        },
        {
            label: "Промоутер: Сумма",
            name: "promouterSumma",
            // type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Артист",
            name: "artist.agentskoeVoznagrazhdenie.vtp",
            source: `/api/meropriyatiya/artist-meropiyatiya/${eventID}`,
            filterType: "group",
            displayString: (o) => o.user.lastname + " " + o.user.firstname,
            display: (o) => (<UserName item={o.user} noborder={true} />),
            queryFilter: [
                QueryOrder("user.lastname", "ASC"),
                QueryOrder("user.firstname", "ASC"),
            ],
            sort: true,
            filter: true
        },
        {
            label: "Артист: Сумма",
            name: "artistSumma",
            // type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Куратор",
            name: "kurator.agentskoeVoznagrazhdenie.vtp",
            source: `/api/meropriyatiya/kuratori-meropiyatiya/${eventID}`,
            filterType: "group",
            displayString: (o) => o.user.lastname + " " + o.user.firstname,
            display: (o) => (<UserName item={o.user} noborder={true} />),
            queryFilter: [
                QueryOrder("user.lastname", "ASC"),
                QueryOrder("user.firstname", "ASC"),
            ],
            sort: true,
            filter: true
        },
        {
            label: "Куратор: Сумма",
            name: "kuratorSumma",
            // type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },

        {
            label: "Сумма",
            name: "summa",
            // type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Суммарные комиссии",
            name: "summarnieKomissii",
            // type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
    ];

    const FilterFromContextFilter = React.useCallback(() => [
        QueryParam("f-sum-shkolaSumma", 0),
        QueryParam("f-sum-promouterSumma", 0),
        QueryParam("f-sum-kuratorSumma", 0),
        QueryParam("f-sum-artistSumma", 0),
        QueryParam("f-sum-summa", 0),
        QueryParam("f-sum-summarnieKomissii", 0),
    ], [eventID]);

    const render = (items, {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    }) => {
        const shkolaSumma = lastFuncStat?.shkolasumma?.sum || 0;
        const promouterSumma = lastFuncStat?.promoutersumma?.sum || 0;
        const artistSumma = lastFuncStat?.artistsumma?.sum || 0;
        const kuratorSumma = lastFuncStat?.kuratorsumma?.sum || 0;
        const summa = lastFuncStat?.summa?.sum || 0;
        const summarnieKomissii = lastFuncStat?.summarniekomissii?.sum || 0;

        return (<div>
            <Spin spinning={loading} tip="Загрузка...">
                <div className='bg bg-grey' style={{ display: "flex", justifyContent: "space-between", padding: "3px", marginBottom: "5px" }}>
                    <div style={{ display: "flex", gap: "3px" }}>
                        <Tooltip title="Рассчитать">
                            <div className={`bg bg-grey pointer`} onClick={() => fill(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <ReloadOutlined style={{ color: "blue" }} />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                    </div>
                    <div style={{ display: "flex", gap: "3px" }}>
                        <Tooltip title="Обновить">
                            <div className={`bg bg-grey pointer`} onClick={() => reinit(collection, setCollection, update, lock, unlock)} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <IssuesCloseOutlined />}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                    </div>
                </div>
                <div className='scrollable' style={{ backgroundColor: "white" }}>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr>
                                <th className={`fixed height-8`} style={{ minWidth: "180px", backgroundColor: "white" }} rowSpan={2}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Пользователь, на которого купили</div>
                                </th>
                                <th className="fixed height-8" style={{ left: "180px", minWidth: "200px", maxWidth: "200px", backgroundColor: "white" }} rowSpan={2}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Ячейка</div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }} rowSpan={2}>
                                    <div className="bg bg-grey">
                                        Сумма
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }} rowSpan={2}>
                                    <div className="bg bg-grey">
                                        Сумма заказа
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }} rowSpan={2}>
                                    <div className="bg bg-grey">
                                        Промокод
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }} rowSpan={2}>
                                    <div className="bg bg-grey">
                                        Суммарные комиссии
                                    </div>
                                </th>

                                <th className="height-8" style={{ minWidth: "200px", fontWeight: "300" }} colSpan={2}>
                                    <div className="bg bg-blue light-2">
                                        Школа
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "200px", fontWeight: "300" }} colSpan={2}>
                                    <div className="bg bg-red light-2">
                                        Промоутер
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "200px", fontWeight: "300" }} colSpan={2}>
                                    <div className="bg bg-orange light-2">
                                        Артист
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "200px", fontWeight: "300" }} colSpan={2}>
                                    <div className="bg bg-green light-2">
                                        Куратор
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-blue light-2">
                                        Пользователь
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-blue light-2">
                                        Сумма/Сумма к выплате
                                    </div>
                                </th>

                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-red light-2">
                                        Пользователь
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-red light-2">
                                        Сумма/Сумма к выплате
                                    </div>
                                </th>

                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-orange light-2">
                                        Пользователь
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-orange light-2">
                                        Сумма/Сумма к выплате
                                    </div>
                                </th>

                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green light-2">
                                        Пользователь
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green light-2">
                                        Сумма/Сумма к выплате
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th className={`fixed height-4`} style={{ minWidth: "180px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>
                                        {/* Пользователь, на которого купили */}
                                    </div>
                                </th>
                                <th className="fixed height-4" style={{ left: "180px", minWidth: "200px", maxWidth: "200px", backgroundColor: "white" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>
                                        {/* Ячейка */}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
                                    <div className="bg bg-green">
                                        {(Number(summa.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
                                    <div className="bg bg-grey">
                                        {/* Сумма заказа */}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
                                    <div className="bg bg-grey">
                                        {/* Промокод */}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
                                    <div className="bg bg-green">
                                        {(Number(summarnieKomissii.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
                                    <div className="bg bg-blue light-2">
                                        {/* Пользователь */}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>

                                    <div className="bg bg-green">
                                        {(Number(shkolaSumma.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>

                                </th>

                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
                                    <div className="bg bg-red light-2">
                                        {/* Пользователь */}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
                                    <div className="bg bg-green">
                                        {(Number(promouterSumma.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>

                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
                                    <div className="bg bg-orange light-2">
                                        {/* Пользователь */}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
                                    <div className="bg bg-green">
                                        {(Number(artistSumma.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>

                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
                                    <div className="bg bg-green light-2">
                                        {/* Пользователь */}
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "bold" }}>
                                    <div className="bg bg-green">
                                        {(Number(kuratorSumma.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(items || [], (item, idx) => {
                                return (<tr key={idx}>
                                    <td className={`fixed height-5`} style={{ minWidth: "180px", backgroundColor: "white" }}>
                                        <div className="bg bg-grey light-30 border-transparent" style={{ textAlign: "left", height: "100%" }}>
                                            {item?.okazannayaUsluga?.polzovatelStrokoi && <span>{item?.okazannayaUsluga?.polzovatelStrokoi}</span>}
                                            {item?.okazannayaUsluga?.polzovatel && <UserName item={item?.okazannayaUsluga?.polzovatel} noborder={true} />}
                                            {/* <div style={{
                                                color: "rgba(0, 0, 0, 0.45)",
                                                textAlign: "left",
                                                textWrap: "nowrap",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                fontSize: "12px",
                                                fontWeight: "lighter",
                                                paddingLeft: "20px"
                                            }}>
                                                <span>{item?.vtp?.tipPolzovatelya?.opisanie}</span>
                                            </div> */}
                                        </div>
                                    </td>
                                    <td className="fixed height-5" style={{ left: "180px", minWidth: "200px", maxWidth: "200px", backgroundColor: "white" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ textAlign: "left", height: "100%" }}>
                                            <div style={{ height: "unset" }}>{item?.okazannayaUsluga?.uslugaKlientu?.yacheikaUsluga?.nazvanie}</div>
                                            {(item?.okazannayaUsluga?.uslugaKlientu?.yacheikaUsluga?.nazvanie !== item?.okazannayaUsluga?.uslugaKlientu?.uslugaNaMeropriyatii?.nazvanie) && <div style={{
                                                color: "rgba(0, 0, 0, 0.45)",
                                                textAlign: "left",
                                                textWrap: "nowrap",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                fontSize: "12px",
                                                fontWeight: "lighter",
                                            }}>
                                                <span>{item?.okazannayaUsluga?.uslugaKlientu?.uslugaNaMeropriyatii?.nazvanie}</span>
                                            </div>}
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                                        <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.okazannayaUsluga?.summa?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.okazannayaUsluga?.uchastik?.tovarVZakaze?.zakaz?.obshchayaSumma?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {item?.okazannayaUsluga?.uchastik?.tovarVZakaze?.zakaz?.promokodSsilka?.promokod}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                                {(Number(item?.summarnieKomissii?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>
                                        </div>
                                    </td>

                                    <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                                        <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            {item?.shkola && <div>
                                                <UserName item={item?.shkola?.agentskoeVoznagrazhdenie?.vtp?.user} noborder={true} />
                                                <div style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    textAlign: "left",
                                                    textWrap: "nowrap",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter",
                                                    paddingLeft: "20px"
                                                }}>
                                                    <div>{item?.shkola?.agentskoeVoznagrazhdenie?.vtp?.tipPolzovatelya?.opisanie}</div>
                                                    {item?.shkola?.agentskoeVoznagrazhdenie?.vtp?.shkola?.nazvanieShkoliTantsev && <div>
                                                        {item?.shkola?.agentskoeVoznagrazhdenie?.vtp?.shkola?.nazvanieShkoliTantsev}
                                                    </div>}
                                                </div>

                                            </div>}
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                                        <div className="bg bg-blue dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            {item?.shkola && <div>
                                                {(Number(item?.shkola?.summaVGonorare?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>}
                                        </div>
                                    </td>

                                    <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                                        <div className="bg bg-red dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            {item?.promouter && <div>
                                                <UserName item={item?.promouter?.agentskoeVoznagrazhdenie?.vtp?.user} noborder={true} />
                                                <div style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    textAlign: "left",
                                                    textWrap: "nowrap",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter",
                                                    paddingLeft: "20px"
                                                }}>
                                                    <span>{item?.promouter?.agentskoeVoznagrazhdenie?.vtp?.tipPolzovatelya?.opisanie}</span>
                                                </div>
                                            </div>}
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                                        <div className="bg bg-red dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            {item?.promouter && <div>
                                                {(Number(item?.promouter?.summaVGonorare?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>}
                                        </div>
                                    </td>

                                    <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                                        <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            {item?.artist && <div>
                                                <UserName item={item?.artist?.agentskoeVoznagrazhdenie?.vtp?.user} noborder={true} />
                                                <div style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    textAlign: "left",
                                                    textWrap: "nowrap",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter",
                                                    paddingLeft: "20px"
                                                }}>
                                                    <span>{item?.artist?.agentskoeVoznagrazhdenie?.vtp?.tipPolzovatelya?.opisanie}</span>
                                                </div>
                                            </div>}
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                                        <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            {item?.artist && <div>
                                                {(Number(item?.artist?.summaVGonorare?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>}
                                        </div>
                                    </td>

                                    <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                                        <div className="bg bg-green dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            {item?.kurator && <div>
                                                <UserName item={item?.kurator?.agentskoeVoznagrazhdenie?.vtp?.user} noborder={true} />
                                                <div style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    textAlign: "left",
                                                    textWrap: "nowrap",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter",
                                                    paddingLeft: "20px"
                                                }}>
                                                    <span>{item?.kurator?.agentskoeVoznagrazhdenie?.vtp?.tipPolzovatelya?.opisanie}</span>
                                                </div>
                                            </div>}
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "100px", backgroundColor: "white" }}>
                                        <div className="bg bg-green dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            {item?.kurator && <div>
                                                {(Number(item?.kurator?.summaVGonorare?.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })}
                                            </div>}
                                        </div>
                                    </td>
                                </tr>)
                            })}
                        </tbody>
                    </table>
                </div>
            </Spin>
        </div>)
    }

    return (<div>
        <CollectionServer
            auth={auth}
            floatingFilter={true}
            disableScrollTo={true}
            allowFullscreen={true}
            // onCollectionChange={(items) => {
            //     if (items && items.length) {
            //         const disabled = items[0]?.meropriyatie?.raschetAgentskikhProizveden;
            //         const disabled2 = !disabled || items[0]?.meropriyatie?.dokAgentskikhVoznagrSozdani;
            //         setDisabled(disabled)
            //         setDisabled2(disabled2)
            //     }
            // }}
            name={"OtchetPoAgentskimVoznagrazhdeniyam"}
            // count={() => 200} // !!!! ИСПРАВИТЬ - сделать редактируемым или подобрать нужное количество !!!!
            // queryDetail={"collection"}
            // source={`/api/agentskie-voznagrazhdeniya/report-okazannie-uslugi/filter/${eventID}`}
            source={`/api/agentskie-voznagrazhdeniya/otchetpoagentskimvoznagrazhdeniyam/page/${eventID}`}
            contextFilters={FilterFromContextFilter}
            filters={filters}
            size={"small"}
            mode={"list"}
            customRender={render}
        />
    </div>)
}

function PromoterParameters(props) {
    const { auth, sourceKey, form, event, updateEvent } = props;
    const meta = useMetaContext();

    let funcs = []
    const metaProperties = (obj, context, funcs) => {
        const { name, field, fieldName, contextObject, object } = context;

        if (!obj) { return obj }

        let p = GetMetaProperties(obj)

        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt", "Meropriyatie"])

        //object-owner-description
        if (object && obj.type == "object") {
            p = updateInPropertiesUUID(p, {
                uuid: "object-owner-description",
                type: "func",
                render: () => (<ObjectOwnerDescription object={object} style={{ marginBottom: "5px" }} />)
            }, true)
        }

        //object-context-description
        if (contextObject && obj.type == "object" && field) {
            let fName = _.get(field, "relation.reference.property");
            let o = obj?.properties?.find(e => e.name == fName)
            if (o) {
                let oObj = _.get(o, "relation.reference.object");
                let oMeta = meta[oObj];
                p = updateInPropertiesUUID(p, {
                    uuid: "object-context-description",
                    type: "func",
                    render: () => (<div className='bg bg-grey' style={{ textAlign: "left", padding: "5px", marginBottom: "5px" }}>
                        {(oMeta) && <div style={{
                            fontSize: "10px",
                            color: "rgb(106, 106, 106)",
                            lineHeight: "10px",
                            fontStyle: "italic"
                        }}>{o?.label} ({oMeta?.label})</div>}
                        <div>{getObjectDisplay(contextObject, oObj, meta)}</div>
                        <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={contextObject} inline={true} /></div>
                    </div>)
                }, true)
            }
        }

        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }

        return SetMetaProperties(obj, p)
    }

    const items = [
        {
            key: '1',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Параметры  агентских</div>,
            children: <div>
                {event?.ID && <Action
                    auth={auth}
                    okText="Сохранить"

                    action={(values, unlock, close) => {
                        updateEvent({ ...event, nastroikaAgentskikh: { ...event?.nastroikaAgentskikh, ...values, meropriyatieID: event?.ID } }, unlock, close)
                    }}
                    // action={updateEvent}

                    object={event?.nastroikaAgentskikh}
                    disabledOkOnUncahngedForm={true}

                    form={Model}
                    meta={metaProperties(meta["NastroikaAgentskikh"], {
                        name: "NastroikaAgentskikh",
                        // field: ,
                        fieldName: "MeropriyatiyaNastroikaAgentskikh",
                        contextObject: event,
                        object: event?.nastroikaAgentskikh
                    }, funcs)}
                    // form={IzmenitPromoterParametersMeropriyatiya}

                    sourceKey={sourceKey}
                    mode={"inline"}
                />}
            </div>,
        },
        {
            key: '2',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Агентские вознаграждения</div>,
            children: <div>
                <AgentskieVoznagrazhdeniya auth={auth} eventID={event?.ID} />
            </div>,
        },
        {
            key: '3',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Агентские вознаграждения к выплате</div>,
            children: <div>
                <AgentskieVoznagrazhdeniyaKViplate auth={auth} eventID={event?.ID} />
            </div>,
        },
        {
            key: '4',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Агентские вознаграждения (отчет)</div>,
            children: <div>
                <AgentskieVoznagrazhdeniyaReport auth={auth} eventID={event?.ID} />
            </div>,
        }
    ];
    const { token } = theme.useToken();
    return <div>
        <Collapse
            bordered={false}
            defaultActiveKey={['1']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            style={{
                background: token.colorBgContainer,
            }}
            ghost items={items} />
    </div>
}
const IntegerValueCell = (props) => {
    const auth = useAuth();
    const t = useTranslateContext();

    const { item, value: initialValue, onChange, style } = props;

    const [value, setValue] = React.useState(initialValue);
    const [lastError, setLastError] = React.useState();
    // const [readyToChange, setReadyToChange] = React.useState(false);

    const onError = (e) => {
        if (initialValue != value) {
            setLastError(e);
        }
    };
    const onEnter = () => {
        // setReadyToChange(false);
        onChange(value, onError);
    };
    const onBlur = () => {
        // if (readyToChange) {
        //     setReadyToChange(false);
        // } else 
        if (initialValue != value) {
            onChange(value, onError);
        }
    };
    React.useEffect(() => {
        setLastError(undefined);
        // setReadyToChange(false);
    }, [value]);
    React.useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    let fixed = item?.document?.fixed;
    let colorClass = (fixed) ?
        (item?.toPayment == item?.calcPayment) ? `bg-blue border-darkgreen` : `bg-grey border-darkgreen` :
        (item?.toPayment == item?.calcPayment) ? `bg-blue border-blue` : `bg-grey border-blue`;
    const stateClass = () => {
        // if (readyToChange) {
        //     return "change"
        // }
        if (initialValue != value) {
            if (lastError) {
                return "error";
            }
            return "warning";
        }
        return ""
    };
    if (!fixed) {
        return (
            <div style={style} onClick={(e) => { e.preventDefault() }}>
                <div style={{ position: "relative" }}>
                    <InputNumber
                        key={item.ID}
                        min={0}
                        className={`bg ${colorClass} pointer ${stateClass()}`}
                        value={value}
                        onChange={v => {
                            setValue((v) ? v : undefined);
                        }}
                        placeholder=""
                        style={{ fontSize: "12px", textAlign: "center", cursor: "pointer", padding: "0px" }}
                        onBlurCapture={onBlur}
                        onPressEnter={onEnter}
                    />
                    {lastError && <div style={{
                        position: "absolute",
                        top: "2px",
                        left: "3px",
                        fontSize: "14px"
                    }}>
                        {<Tooltip title={(lastError && lastError.message) ? lastError.message : ""}><Icofont icon="exclamation" style={{ color: "red" }} /></Tooltip>}
                    </div>}
                </div>
            </div>
        )
    }
    return (<div key={item.ID} className={`bg ${colorClass} dark-1`} style={style}>{item?.toPayment}</div>);
};
const StringValueCell = (props) => {
    const auth = useAuth();
    const t = useTranslateContext();

    const { item, value: initialValue, onChange, style, className } = props;

    const [value, setValue] = React.useState(initialValue);
    const [lastError, setLastError] = React.useState();

    const onError = (e) => {
        if (initialValue != value) {
            setLastError(e);
        }
    };
    const onEnter = () => {
        onChange(value, onError);
    };
    const onBlur = () => {
        if (initialValue != value) {
            onChange(value, onError);
        }
    };
    React.useEffect(() => {
        setLastError(undefined);
    }, [value]);
    React.useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    let fixed = item?.document?.fixed;
    let colorClass = (fixed) ?
        (!item?.kommentarii) ? `bg-blue border-darkgreen` : `bg-grey border-darkgreen` :
        (!item?.kommentarii) ? `bg-blue border-blue` : `bg-grey border-blue`;
    const stateClass = () => {
        if (initialValue != value) {
            if (lastError) {
                return "error";
            }
            return "warning";
        }
        return ""
    };
    if (!fixed) {
        return (
            <div style={{ height: "100%", ...style }} onClick={(e) => { e.preventDefault() }}>
                <div style={{ height: "100%", position: "relative" }}>
                    <Input
                        key={item.ID}
                        className={`bg ${colorClass} pointer ${stateClass()}`}
                        value={value}
                        onChange={v => {
                            setValue(v.target.value);
                        }}
                        placeholder=""
                        style={{ height: "100%", fontSize: "12px", textAlign: "left", cursor: "pointer", padding: "0px 5px" }}
                        onBlurCapture={onBlur}
                        onPressEnter={onEnter}
                    />
                    {lastError && <div style={{
                        position: "absolute",
                        top: "2px",
                        left: "3px",
                        fontSize: "14px"
                    }}>
                        {<Tooltip title={(lastError && lastError.message) ? lastError.message : ""}><Icofont icon="exclamation" style={{ color: "red" }} /></Tooltip>}
                    </div>}
                </div>
            </div>
        )
    }
    return (<div key={item.ID} className={`bg ${colorClass} dark-1`} style={style}>{item?.kommentarii}</div>);
};
function GonorarTable(props) {
    const { auth, eventID } = props;
    const [tableData, setTableData] = useState()
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        setLoading(true)
        GET(auth, `/api/sudifederatsii/gonorari/get/${eventID}`, ({ data }) => {
            setTableData(data)
            setLoading(false)
        }, (err) => errorCatch(err, () => setLoading(false)))
    }, [])

    const reinit = useCallback(() => {
        Modal.confirm({
            title: `Изменение размеров выплат`,
            icon: <ExclamationCircleOutlined />,
            content: (<div>
                <div>Вы уверены что хотите изменить значения выплат судьям в соответствии с шаблоном?</div>
            </div>),
            okText: "Да",
            okType: 'danger',
            cancelText: "Нет",
            onOk: () => {
                setLoading(true)
                GET(auth, `/api/sudifederatsii/gonorari/reinit-topayment/${eventID}`, ({ data }) => {
                    setTableData(data)
                    setLoading(false)
                }, (err) => errorCatch(err, () => setLoading(false)))
            },
        });

    }, [eventID])
    const calc = useCallback(() => {
        setLoading(true)
        GET(auth, `/api/sudifederatsii/calc-and-save-gonorari/${eventID}`, ({ data }) => {
            setTableData(data)
            setLoading(false)
        }, (err) => errorCatch(err, () => setLoading(false)))
    }, [eventID])
    const fixed = useCallback(() => {
        Modal.confirm({
            title: `Проведение документов`,
            icon: <ExclamationCircleOutlined />,
            content: (<div>
                <div>Вы уверены что хотите провести все документы и зачислить указанные гонорары судьям?</div>
            </div>),
            okText: "Да",
            okType: 'danger',
            cancelText: "Нет",
            onOk: () => {
                setLoading(true)
                GET(auth, `/api/sudifederatsii/gonorari/fixed/${eventID}`, ({ data }) => {
                    setTableData(data)
                    setLoading(false)
                }, (err) => errorCatch(err, () => setLoading(false)))
            },
        });
    }, [eventID])

    return (<div>
        <div className='bg bg-grey' style={{ display: "flex", justifyContent: "space-between", padding: "3px", marginBottom: "5px" }}>
            <div style={{ display: "flex", gap: "3px" }}>
                <Tooltip title="Расчет гонораров">
                    <div className={`bg bg-grey pointer`} onClick={calc} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                        {/* <i className="fa fa-ellipsis-h"></i> */}
                        {!loading && <CalculatorOutlined style={{ color: "blue" }} />}
                        {loading && <Spin
                            indicator={
                                <LoadingOutlined
                                    style={{
                                        color: "grey",
                                        fontSize: 12,
                                    }}
                                    spin
                                />
                            }
                        />}
                    </div>
                </Tooltip>
                <Tooltip title="Проведение гонораров">
                    <div className={`bg bg-grey pointer`} onClick={fixed} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                        {/* <i className="fa fa-ellipsis-h"></i> */}
                        {!loading && <FileDoneOutlined style={{ color: "green" }} />}
                        {loading && <Spin
                            indicator={
                                <LoadingOutlined
                                    style={{
                                        color: "grey",
                                        fontSize: 12,
                                    }}
                                    spin
                                />
                            }
                        />}
                    </div>
                </Tooltip>
            </div>
            <div style={{ display: "flex", gap: "3px" }}>
                <Tooltip title="Обновить значения выплат">
                    <div className={`bg bg-grey pointer`} onClick={reinit} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                        {/* <i className="fa fa-ellipsis-h"></i> */}
                        {!loading && <IssuesCloseOutlined />}
                        {loading && <Spin
                            indicator={
                                <LoadingOutlined
                                    style={{
                                        color: "grey",
                                        fontSize: 12,
                                    }}
                                    spin
                                />
                            }
                        />}
                    </div>
                </Tooltip>
            </div>

        </div>
        <div className='scrollable' style={{ backgroundColor: "white" }}>
            <table className="table" style={{ fontSize: "13px", lineHeight: "normal" }}>
                <thead>
                    <tr>
                        <th className={`wrap fixed`} style={{ minWidth: "200px", backgroundColor: "white" }} rowSpan="2">
                            <div className='bg bg-grey dark-1'>Судья</div>
                        </th>
                        <th className="wrap fixed" style={{ left: "200px", minWidth: "50px", maxWidth: "50px", backgroundColor: "white" }} rowSpan="2">
                            <div className='bg bg-orange dark-5 border-orange'>#</div>
                        </th>
                        <th className="wrap fixed" style={{ left: "250px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }} rowSpan="2">
                            <div className='bg bg-blue border-blue'>Судейские гонорары к выплате</div>
                        </th>
                        <th className="wrap fixed" style={{ left: "350px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }} rowSpan="2">
                            <div className='bg bg-blue dark-1 border-blue'>Расчетные судейские гонорары</div>
                        </th>
                        {JSXMap(tableData?.meropriyatie?.kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie, (kategoriya, cidx) => {
                            let color = getIndexColorLighter(cidx, 0.25);
                            return (<th className="wrap" style={{ fontWeight: "300" }} key={cidx}>
                                <div className="bg bg-grey" style={{ backgroundColor: color }}>
                                    {kategoriya?.tantsevalnayaDistsiplina?.nazvanie}
                                </div>
                            </th>)
                        })}
                        <th className="wrap" style={{ minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }} rowSpan="2">
                            <div className='bg bg-blue border-blue'>Комментарий</div>
                        </th>
                    </tr>
                    <tr>
                        {JSXMap(tableData?.meropriyatie?.kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie, (kategoriya, cidx) => {
                            let color = getIndexColorLighter(cidx, 0.15);
                            return (<th className="wrap" style={{ fontWeight: "300" }} key={cidx}>
                                <div className="bg bg-grey" style={{ backgroundColor: color }}>
                                    {kategoriya?.kategoriyaUchastnikov?.nazvanie}
                                </div>
                            </th>)
                        })}
                    </tr>
                    <tr>
                        <th className={`wrap fixed`} style={{ minWidth: "200px", backgroundColor: "white" }}>
                            <div className='bg bg-blue'></div>
                        </th>
                        <th className="wrap fixed" style={{ left: "200px", minWidth: "50px", maxWidth: "50px", backgroundColor: "white" }}>
                            <div className='bg bg-blue' style={{ fontWeight: "bold" }}></div>
                        </th>
                        <th className="wrap fixed" style={{ left: "250px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }} rowSpan="2">
                            <div className='bg bg-blue border-blue'></div>
                        </th>
                        <th className="wrap fixed" style={{ left: "350px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white" }} rowSpan="2">
                            <div className='bg bg-blue dark-1 border-blue'></div>
                        </th>
                        {JSXMap(tableData?.meropriyatie?.kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie, (kategoriya, cidx) => {
                            let summa = 0;
                            let o = tableData?.meropriyatie?.shablonSudeiskikhGonorarov?.detShablonaSudGonorarovShablon?.find(e => kategoriya?.kategoriyaUchastnikovID == e.kategoriyaID && kategoriya?.tantsevalnayaDistsiplinaID == e.tantsevalnayaDistsiplinaID);
                            if (o) {
                                summa = o.summa;
                            }
                            return (<th className="wrap" style={{ fontWeight: "bold" }} key={cidx}>
                                <div className="bg bg-blue">
                                    {(summa > 0) ? summa : undefined}
                                </div>
                            </th>)
                        })}
                        <th className="wrap" style={{ minWidth: "250px", maxWidth: "250px", backgroundColor: "white" }} rowSpan="2">
                            <div className='bg bg-blue border-blue'></div>
                        </th>
                    </tr>
                </thead>
                <tbody style={{ fontSize: "12px" }}>
                    {JSXMap(tableData?.gonorari || [], (judgeItem, cidx) => {

                        return (<tr key={cidx}>
                            <td className={`fixed`} style={{ minWidth: "200px", backgroundColor: "white", height: '1px' }}>
                                <UserName item={judgeItem?.sudiya} noborder={true} />
                            </td>
                            <td className={`fixed`} style={{ left: "200px", minWidth: "50px", maxWidth: "50px", backgroundColor: "white", height: '1px' }}>
                                <div className="bg bg-orange dark-1 border-transparent" style={{ fontWeight: "bold", height: "100%" }}>
                                    {judgeItem?.paymentKategoriiCount}
                                </div>
                            </td>
                            <td className="wrap fixed" style={{ left: "250px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white", height: '1px' }}>
                                <IntegerValueCell item={judgeItem} value={judgeItem?.toPayment} style={{ height: "100%" }}
                                    onChange={(val, onError) => {
                                        POST(auth, `/api/sudifederatsii/gonorari/update`, { ...judgeItem, toPayment: val },
                                            ({ data }) => {
                                                setTableData(o => ({ ...o, gonorari: updateInArray(o?.gonorari, data) }))
                                            }, (err) => errorCatch(err, () => onError(err)))
                                    }} />
                            </td>
                            <td className="wrap fixed" style={{ left: "350px", minWidth: "100px", maxWidth: "100px", backgroundColor: "white", height: '1px' }}>
                                <div className='bg bg-blue dark-1 border-blue' style={{ height: "100%" }}>
                                    {judgeItem?.calcPayment}
                                </div>
                            </td>
                            {JSXMap(tableData?.meropriyatie?.kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie, (kategoriya, cidx) => {
                                let summa = 0;
                                let o = judgeItem.gonorarSudiKategoriyaGonorarSudi?.find(e => kategoriya?.kategoriyaUchastnikovID == e.kategoriya.kategoriyaUchastnikovID && kategoriya?.tantsevalnayaDistsiplinaID == e.kategoriya.tantsevalnayaDistsiplinaID);
                                if (o) {
                                    summa = o.toPayment;
                                }
                                return (<td className="wrap" style={{ fontWeight: "300", height: '1px' }} key={cidx}>
                                    <div className={(o && o.koefficient < 1 && summa > 0) ? "bg bg-orange dark-3 border-transparent" : "bg bg-blue border-transparent"} style={{ height: "100%" }}>
                                        {(summa > 0) ? summa : undefined}
                                    </div>
                                </td>)
                            })}
                            <td className="wrap" style={{ minWidth: "250px", maxWidth: "250px", backgroundColor: "white", height: '1px' }}>
                                <StringValueCell item={judgeItem} value={judgeItem?.kommentarii} style={{ height: "100%", textAlign: "left" }}
                                    onChange={(val, onError) => {
                                        POST(auth, `/api/sudifederatsii/gonorari/update`, { ...judgeItem, kommentarii: val },
                                            ({ data }) => {
                                                setTableData(o => ({ ...o, gonorari: updateInArray(o?.gonorari, data) }))
                                            }, (err) => errorCatch(err, () => onError(err)))
                                    }} />
                            </td>
                        </tr>)
                    })}
                </tbody>
            </table>
        </div>
    </div>)
}
function Gonorar(props) {
    const { auth, sourceKey, form, event, updateEvent } = props;
    const { token } = theme.useToken();
    const items = [
        {
            key: '1',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Шаблоны гонораров</div>,
            children: <div>
                {event?.ID && <GonorarBlock {...props} source={`/api/shablonisudeiskikhgonorarov/list/meropriyatie/${event.ID}?detail=model`}
                    sourceKey={sourceKey}
                    create={true}
                    event={event}
                    title={<></>}
                />}
            </div>,
        },
    ];
    return <div>
        <div style={{ padding: "10px" }}>
            <Divider type="horizontal" orientation="left">
                Гонорары судей в мероприятии
            </Divider>
            <EventGonorar auth={auth} sourceKey={sourceKey} form={form} event={event} updateEvent={updateEvent} id={event.ID} />
        </div>
        <div style={{ padding: "10px" }}>
            <Divider type="horizontal" orientation="left">
                Расчет гонораров судей
            </Divider>
            <GonorarTable auth={auth} eventID={event?.ID} />
        </div>
        <div>
            <Collapse
                size='small'
                bordered={false}
                // defaultActiveKey={['1']}
                expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                style={{
                    background: token.colorBgContainer,
                }}
                ghost items={items} />

        </div>
    </div>
}
function EventActors(props) {
    const { auth, sourceKey, form, event } = props;
    const { token } = theme.useToken();
    const items = [
        ...IfElse((event && event?.ID && sourceKey !== "admin"), [{
            key: '0',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Администраторы</div>,
            children: <AdministratorsMeropriyatiya auth={auth} object={event} />,
        }], []),
        {
            key: '1',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Контролеры</div>,
            children: <ControllersMeropriyatiya auth={auth} object={event} />,
        },
        {
            key: '2',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Главный судья</div>,
            children: <MainJudgeMeropriyatiya auth={auth} object={event} />,
        },
        {
            key: '3',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Судьи</div>,
            children: <JudgeMeropriyatiya auth={auth} object={event} />,
        },
        {
            key: '4',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Спец. гости</div>,
            children: <SpecialguestMeropriyatiya auth={auth} object={event} />,
        },
        {
            key: '5',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Ведущие</div>,
            children: <PresenterMeropriyatiya auth={auth} object={event} />,
        },

        {
            key: '6',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>DJ</div>,
            children: <DjMeropriyatiya auth={auth} object={event} />,
        },
        {
            key: '7',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Оператор OBS</div>,
            children: <OperatorOBSMeropriyatiya auth={auth} object={event} />,
        },
        {
            key: '8',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Члены комитета по судейству</div>,
            children: <ChlenKomitetaPoSudeistvuMeropriyatiya auth={auth} object={event} />,
        },
    ];
    return <div>
        {(event && event?.ID) && <Collapse
            bordered={false}
            defaultActiveKey={['0']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            style={{
                background: token.colorBgContainer,
            }}
            ghost items={items} />}

    </div>
}
function EventServices(props) {
    const { auth, sourceKey, form, event } = props;
    const { token } = theme.useToken();
    const items = [
        {
            key: '1',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Шаблон тарифов</div>,
            children: <TarifTemplate auth={auth} object={event} sourceKey={sourceKey} queryFilterContext={undefined} />,
        },
        {
            key: '2',
            label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Установка цен на услуги</div>,
            children: <UslugiNaMeropriyatii auth={auth} object={event} sourceKey={sourceKey} queryFilterContext={undefined} soruceID={event?.ID} orgID={
                event?.organizatorFederatsiyaID || event?.organizatorMeropriyatiyaID || event?.organizatorRegionalnoeOtdelenieID || event?.organizatorShkolaID
            } />,
        },
        // {
        //     key: '3',
        //     label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Даты возвратов</div>,
        //     children: <DativozvratovNaMeropriyatii auth={auth} object={event} sourceKey={sourceKey} queryFilterContext={undefined} />,
        // },
    ];
    return <div>
        {(event && event?.ID) && <Collapse
            bordered={false}
            defaultActiveKey={['1']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            style={{
                background: token.colorBgContainer,
            }}
            ghost items={items} />}
    </div>
}
function EventOrders(props) {
    const { auth, sourceKey, form, event, id } = props;
    const [oplatiPostavki, setOplatiPostavki] = useState(undefined);

    useEffect(() => {
        GET(auth, `/api/meropriyatiya/oplati-postavki/${id}`,
            ({ data }) => {
                setOplatiPostavki(data);
            }, errorCatch);
    }, [])
    return <div>
        <div className='scrollable'>
            <table className="table" style={{ width: "initial", fontSize: "13px" }}>
                <thead>
                    <tr>
                        <th className={`wrap`} style={{ minWidth: "25px", maxWidth: "25px" }}></th>
                        <th className={`wrap`} style={{ minWidth: "260px", maxWidth: "260px" }}><div className='bg bg-grey dark-1'>ФИО</div></th>
                        <th className={`wrap`} style={{ minWidth: "130px", maxWidth: "130px" }}><div className='bg bg-grey dark-1'>
                            <div>Дата/время</div>
                            <div style={{
                                fontStyle: "italic",
                                color: "rgba(0, 0, 0, 0.45)",
                            }}>№ заказа</div>
                        </div></th>
                        <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Сумма заказа</div></th>

                        <th className={`wrap`} style={{ minWidth: "100px", maxWidth: "100px" }}><div className='bg bg-grey dark-1'>Сумма активности</div></th>
                        <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Комиссия партнеру</div></th>
                        <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Остаток организатору</div></th>
                    </tr>
                    <tr className="tr-rounded">
                        <th></th>
                        <th className={`wrap`}><div className="bg bg-blue"></div></th>
                        <th><div className="bg bg-blue"></div></th>
                        <th><div className="bg bg-blue">{getCurrencyAbsValue(oplatiPostavki?.ItogRealizatsiya)}</div></th>

                        <th><div className="bg bg-blue">{getCurrencyAbsValue(oplatiPostavki?.SummaSKotorikhAgentskie)}</div></th>
                        <th><div className="bg bg-blue">{getCurrencyAbsValue(oplatiPostavki?.SummaAgentskih, "red")}</div></th>
                        <th><div className="bg bg-blue">{getCurrencyAbsValue(oplatiPostavki?.OstatokOrganizatoru)}</div></th>
                    </tr>
                </thead>
                <tbody style={{ fontSize: "12px" }}>
                    {JSXMap(oplatiPostavki?.OplatiPostavkiData, (op, opidx) => {
                        return (<OplataRow key={opidx} item={op} idx={opidx} />)
                    })}
                </tbody>
            </table>
        </div>

        <hr />

        <table className="table" style={{ fontSize: "13px" }}>
            <thead>
                <tr>
                    <th className={`wrap`} style={{ minWidth: "25px", maxWidth: "25px", width: "25px" }}></th>
                    <th className={`wrap`} style={{ minWidth: "260px", maxWidth: "260px" }}><div className='bg bg-grey dark-1'>Партнер</div></th>
                    <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Сумма</div></th>
                </tr>
                <tr className="tr-rounded">
                    <th></th>
                    <th className={`wrap`}><div className="bg bg-blue"></div></th>
                    <th><div className="bg bg-blue">{getCurrencyAbsValue(oplatiPostavki?.SummaAgentskih, "red")}</div></th>
                </tr>
            </thead>
            <tbody style={{ fontSize: "12px" }}>
                {JSXMap(oplatiPostavki?.PostavkiOplatiData, (op, opidx) => {
                    return (<PostavkiRow key={opidx} item={op} idx={opidx} />)
                })}
            </tbody>
        </table>

        <hr />

        <table className="table" style={{ fontSize: "13px" }}>
            <tbody style={{ fontSize: "12px" }}>
                <tr>
                    <td><div className="bg bg-grey" style={{ textAlign: "left", padding: "4px 7px" }}>Итого реализация (сумма по заказам)</div></td>
                    <td><div className="bg bg-grey" style={{ padding: "4px 7px" }}>{getCurrencyAbsValue(oplatiPostavki?.ItogRealizatsiya)}</div></td>
                </tr>
                <tr>
                    <td><div className="bg bg-grey" style={{ textAlign: "left", padding: "4px 7px" }}>Сумма с которой агентские</div></td>
                    <td><div className="bg bg-grey" style={{ padding: "4px 7px" }}>{getCurrencyAbsValue(oplatiPostavki?.SummaSKotorikhAgentskie)}</div></td>
                </tr>
                <tr>
                    <td><div className="bg bg-grey" style={{ textAlign: "left", padding: "4px 7px" }}>Сумма остатка после возвратов</div></td>
                    <td><div className="bg bg-grey" style={{ padding: "4px 7px" }}>{getCurrencyAbsValue(oplatiPostavki?.SummaOstatkaVozvratov)}</div></td>
                </tr>
                <tr>
                    <td><div className="bg bg-grey" style={{ textAlign: "left", padding: "4px 7px" }}>Процент</div></td>
                    <td><div className="bg bg-grey" style={{ padding: "4px 7px" }}>{oplatiPostavki?.Protsent}%</div></td>
                </tr>
                <tr>
                    <td><div className="bg bg-grey" style={{ textAlign: "left", padding: "4px 7px" }}>Сумма агентских</div></td>
                    <td><div className="bg bg-grey" style={{ padding: "4px 7px" }}>{getCurrencyAbsValue(oplatiPostavki?.SummaAgentskih, "red")}</div></td>
                </tr>
                <tr>
                    <td><div className="bg bg-grey" style={{ textAlign: "left", padding: "4px 7px" }}>Процент агентских</div></td>
                    <td><div className="bg bg-grey" style={{ padding: "4px 7px" }}>{oplatiPostavki?.ProtsentAgentskih}%</div></td>
                </tr>
                <tr>
                    <td><div className="bg bg-grey" style={{ textAlign: "left", padding: "4px 7px" }}>Процент агентских с общей суммы</div></td>
                    <td><div className="bg bg-grey" style={{ padding: "4px 7px" }}>{oplatiPostavki?.ProtsentAgentskihSObsheySummi}%</div></td>
                </tr>
                <tr>
                    <td><div className="bg bg-grey" style={{ textAlign: "left", padding: "4px 7px" }}>Остаток организатору</div></td>
                    <td><div className="bg bg-grey" style={{ padding: "4px 7px" }}>{getCurrencyAbsValue(oplatiPostavki?.OstatokOrganizatoru)}</div></td>
                </tr>
            </tbody>
        </table>
    </div>
}

function EventReports(props) {
    const { auth, sourceKey, form, event, id, setEvent, updateEvent } = props;

    const user = useUserContext();

    const [errorList, setErrorList] = useState([])
    const [warnings, setWarnings] = useState()
    const [loading, setLoading] = useState(false)

    const { token } = theme.useToken();

    // `/api/rating-event/calc-by-meropriyatie/${id}`
    // `/api/rating-event/report-by-meropriyatie/${id}`

    return <div>
        <div style={{ display: "flex", alignItems: "center" }}>
            <Action
                auth={auth}
                action={(values, unlock, close) => {
                    // Первичные основные направления и регистрация на соревнования
                    // /api/report/register-jac-table/${id}
                    // showempty  true | false
                    // showdisplay true | false

                    if (!!values.showdisplay) {
                        close();
                        goTo(`/app/reports/register-jac-table/${id}?showdisplay=true&showempty=${!!values.showempty}&showbasic=${!!values.showbasic}&showcategory=${!!values.showcategory}`)
                        // var a = document.createElement("a");
                        // document.body.appendChild(a);
                        // a.style = "display: none";
                        // return function (data, name, type) {
                        //     a.href = `/api/report/register-jac-table/${id}?showdisplay=true&showempty=${!!values.showempty}`;
                        //     a.target = "_blank"
                        //     a.click();
                        //     a.remove();
                        // };
                    } else {
                        auth.fetchFile(`/api/report/register-jac-table/${id}?showempty=${!!values.showempty}&showbasic=${!!values.showbasic}&showcategory=${!!values.showcategory}&showdisplay=${!!values.showdisplay}`)
                            .then(async (res) => {
                                close();
                            });
                    }
                }}
                modal={{
                    title: "Первичные основные направления и регистрация на соревнования" + ((event) ? " - " + event.nazvanieMeropriyatiya : "")
                }}
                okText="Построить отчет"
                mode={"func"}
                form={(props) => {
                    const { auth, form, submit } = props;
                    return (
                        <Form
                            form={form}
                            onFinish={submit}
                            labelAlign={"left"}
                            layout={"vertical"}
                            initialValues={{
                                showbasic: false,
                                showcategory: true,
                                showempty: false,
                                showdisplay: false
                            }}
                        >
                            <Form.Item name="showbasic" valuePropName="checked">
                                <Checkbox>
                                    Показывать основные направления
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showcategory" valuePropName="checked">
                                <Checkbox>
                                    Показывать категории участников
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showempty" valuePropName="checked">
                                <Checkbox>
                                    Показывать пустые
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showdisplay" valuePropName="checked">
                                <Checkbox>
                                    Вывести на экран
                                </Checkbox>
                            </Form.Item>
                        </Form>
                    )
                }}
                trigger={(click) => (
                    <div>
                        <Button type="link" style={{ paddingRight: "0px" }} onClick={click}>Первичные основные направления и регистрация на соревнования</Button>
                    </div>
                )}
            />
            <FedTooltip title="Таблица распределения участников по категориям" />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
            <Action
                auth={auth}
                action={(values, unlock, close) => {
                    if (!!values.showdisplay) {
                        close();
                        goTo(`/app/reports/register-jac-table-by-dancer-event/${id}?showdisplay=true&showempty=${!!values.showempty}&showbasic=${!!values.showbasic}&showcategory=${!!values.showcategory}`)
                    } else {
                        auth.fetchFile(`/api/report/register-jac-table-by-dancer-event/${id}?showempty=${!!values.showempty}&showbasic=${!!values.showbasic}&showcategory=${!!values.showcategory}&showdisplay=${!!values.showdisplay}`)
                            .then(async (res) => {
                                close();
                            });
                    }
                }}
                modal={{
                    title: "Текущие основные направления и регистрация на соревнования" + ((event) ? " - " + event.nazvanieMeropriyatiya : "")
                }}
                okText="Построить отчет"
                mode={"func"}
                form={(props) => {
                    const { auth, form, submit } = props;
                    return (
                        <Form
                            form={form}
                            onFinish={submit}
                            labelAlign={"left"}
                            layout={"vertical"}
                            initialValues={{
                                showbasic: false,
                                showcategory: true,
                                showempty: false,
                                showdisplay: false
                            }}
                        >
                            <Form.Item name="showbasic" valuePropName="checked">
                                <Checkbox>
                                    Показывать основные направления
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showcategory" valuePropName="checked">
                                <Checkbox>
                                    Показывать категории участников
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showempty" valuePropName="checked">
                                <Checkbox>
                                    Показывать пустые
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showdisplay" valuePropName="checked">
                                <Checkbox>
                                    Вывести на экран
                                </Checkbox>
                            </Form.Item>
                        </Form>
                    )
                }}
                trigger={(click) => (
                    <div>
                        <Button type="link" style={{ paddingRight: "0px" }} onClick={click}>Текущие основные направления и регистрация на соревнования</Button>
                    </div>
                )}
            />
            <FedTooltip title="Таблица распределения участников по категориям" />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
            <Action
                auth={auth}
                action={(values, unlock, close) => {
                    // Текущая таблица продаж
                    // /api/report/total-payment-table/${id}
                    // showempty  true|false
                    // showpromo true|false
                    // showsum     true|false
                    // showemail true | false
                    // showdisplay true | false

                    if (!!values.showdisplay) {
                        close();
                        goTo(`/app/reports/total-payment-table/${id}/admin?showdisplay=true&showempty=${!!values.showempty}&showpromo=${!!values.showpromo}&showsum=${!!values.showsum}&showemail=${!!values.showemail}&showcomment=${!!values.showcomment}`)

                        // var a = document.createElement("a");
                        // document.body.appendChild(a);
                        // a.style = "display: none";
                        // return function (data, name, type) {
                        //     a.href = `/api/report/total-payment-table/${id}/admin?showdisplay=true&showempty=${!!values.showempty}&showpromo=${!!values.showpromo}&showsum=${!!values.showsum}&showemail=${!!values.showemail}`;
                        //     a.target = "_blank"
                        //     a.click();
                        //     a.remove();
                        // };

                        // GETWITH(auth,`/api/report/total-payment-table/${id}`,[
                        //     QueryParam("showempty",!!values.showempty),
                        //     QueryParam("showpromo",!!values.showpromo),
                        //     QueryParam("showsum",!!values.showsum),
                        //     QueryParam("showemail",!!values.showemail),
                        //     QueryParam("showdisplay",!!values.showdisplay),
                        // ],(res)=>{

                        //     close();
                        // },(err)=>errorCatch(err, unlock));
                    } else {
                        auth.fetchFile(`/api/report/total-payment-table/${id}/admin?showempty=${!!values.showempty}&showpromo=${!!values.showpromo}&showsum=${!!values.showsum}&showemail=${!!values.showemail}&showcomment=${!!values.showcomment}&showdisplay=${!!values.showdisplay}`)
                            .then(async (res) => {
                                close();
                            });
                    }

                }}
                modal={{
                    title: "Текущая таблица продаж" + ((event) ? " - " + event.nazvanieMeropriyatiya : "")
                }}
                okText="Построить отчет"
                mode={"func"}
                form={(props) => {
                    const { auth, form, submit } = props;
                    return (
                        <Form
                            form={form}
                            onFinish={submit}
                            labelAlign={"left"}
                            layout={"vertical"}
                            initialValues={{
                                showempty: true,
                                showpromo: true,
                                showsum: true,
                                showemail: true,
                                showcomment: true,
                                showdisplay: true,
                            }}
                        >
                            <Form.Item name="showempty" valuePropName="checked">
                                <Checkbox>
                                    Показывать пустые
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showpromo" valuePropName="checked">
                                <Checkbox>
                                    Показывать промокоды
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showsum" valuePropName="checked">
                                <Checkbox>
                                    Показывать общую сумму покупки
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showemail" valuePropName="checked">
                                <Checkbox>
                                    Показывать e-mail и телефон
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showcomment" valuePropName="checked">
                                <Checkbox>
                                    Показывать комментарии
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showdisplay" valuePropName="checked">
                                <Checkbox>
                                    Вывести на экран
                                </Checkbox>
                            </Form.Item>
                        </Form>
                    )
                }}
                trigger={(click) => (
                    <div>
                        <Button type="link" style={{ paddingRight: "0px" }} onClick={click}>Текущая таблица продаж</Button>
                    </div>
                )}
            />
            <FedTooltip title={"В строках - участник, указана последняя дата покупки. \"Плюсики\" в ячейках."} />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
            <Action
                auth={auth}
                action={(values, unlock, close) => {
                    // Расширенная текущая таблица продаж
                    // /api/report/extended-total-payment-table/${id}
                    // showempty  true|false
                    // showpromo true|false
                    // showsum     true|false
                    // showemail true | false
                    // showdisplay true | false

                    if (!!values.showdisplay) {
                        close();
                        goTo(`/app/reports/extended-total-payment-table/${id}/admin?showdisplay=true&showempty=${!!values.showempty}&showpromo=${!!values.showpromo}&showsum=${!!values.showsum}&showemail=${!!values.showemail}&showcomment=${!!values.showcomment}`)
                    } else {
                        auth.fetchFile(`/api/report/total-payment-table/${id}/admin?showempty=${!!values.showempty}&showpromo=${!!values.showpromo}&showsum=${!!values.showsum}&showemail=${!!values.showemail}&showcomment=${!!values.showcomment}&showdisplay=${!!values.showdisplay}&extended=true`)
                            .then(async (res) => {
                                close();
                            });
                    }

                }}
                modal={{
                    title: "Расширенная текущая таблица продаж" + ((event) ? " - " + event.nazvanieMeropriyatiya : "")
                }}
                okText="Построить отчет"
                mode={"func"}
                form={(props) => {
                    const { auth, form, submit } = props;
                    return (
                        <Form
                            form={form}
                            onFinish={submit}
                            labelAlign={"left"}
                            layout={"vertical"}
                            initialValues={{
                                showempty: true,
                                showpromo: true,
                                showsum: true,
                                showemail: true,
                                showcomment: true,
                                showdisplay: true,
                            }}
                        >
                            <Form.Item name="showempty" valuePropName="checked">
                                <Checkbox>
                                    Показывать пустые
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showpromo" valuePropName="checked">
                                <Checkbox>
                                    Показывать промокоды
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showsum" valuePropName="checked">
                                <Checkbox>
                                    Показывать общую сумму покупки
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showemail" valuePropName="checked">
                                <Checkbox>
                                    Показывать e-mail и телефон
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showcomment" valuePropName="checked">
                                <Checkbox>
                                    Показывать комментарии
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showdisplay" valuePropName="checked">
                                <Checkbox>
                                    Вывести на экран
                                </Checkbox>
                            </Form.Item>
                        </Form>
                    )
                }}
                trigger={(click) => (
                    <div>
                        <Button type="link" style={{ paddingRight: "0px" }} onClick={click}>Расширенная текущая таблица продаж</Button>
                    </div>
                )}
            />
            <FedTooltip title={"В строках - участник, указана последняя дата покупки. Суммы покупок в ячейках."} />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
            <Action
                auth={auth}
                action={(values, unlock, close) => {
                    // Таблица продаж по заказам
                    // /api/report/payment-table-by-orders/${id}
                    // showempty  true|false
                    // showpromo true|false
                    // showsum     true|false
                    // showemail true | false
                    // showdisplay true | false

                    if (!!values.showdisplay) {
                        close();
                        goTo(`/app/reports/payment-table-by-orders/${id}?showdisplay=true&showempty=${!!values.showempty}&showpromo=${!!values.showpromo}&showsum=${!!values.showsum}&showemail=${!!values.showemail}&showcomment=${!!values.showcomment}`)
                    } else {
                        auth.fetchFile(`/api/report/payment-table-by-orders/${id}?showempty=${!!values.showempty}&showpromo=${!!values.showpromo}&showsum=${!!values.showsum}&showemail=${!!values.showemail}&showcomment=${!!values.showcomment}&showdisplay=${!!values.showdisplay}`)
                            .then(async (res) => {
                                close();
                            });
                    }

                }}
                modal={{
                    title: "Таблица продаж по заказам" + ((event) ? " - " + event.nazvanieMeropriyatiya : "")
                }}
                okText="Построить отчет"
                mode={"func"}
                form={(props) => {
                    const { auth, form, submit } = props;
                    return (
                        <Form
                            form={form}
                            onFinish={submit}
                            labelAlign={"left"}
                            layout={"vertical"}
                            initialValues={{
                                showempty: true,
                                showpromo: true,
                                showsum: true,
                                showemail: true,
                                showcomment: true,
                                showdisplay: true,
                            }}
                        >
                            <Form.Item name="showempty" valuePropName="checked">
                                <Checkbox>
                                    Показывать пустые
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showpromo" valuePropName="checked">
                                <Checkbox>
                                    Показывать промокоды
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showsum" valuePropName="checked">
                                <Checkbox>
                                    Показывать общую сумму покупки
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showemail" valuePropName="checked">
                                <Checkbox>
                                    Показывать e-mail и телефон
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showcomment" valuePropName="checked">
                                <Checkbox>
                                    Показывать комментарии
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="showdisplay" valuePropName="checked">
                                <Checkbox>
                                    Вывести на экран
                                </Checkbox>
                            </Form.Item>
                        </Form>
                    )
                }}
                trigger={(click) => (
                    <div>
                        <Button type="link" style={{ paddingRight: "0px" }} onClick={click}>Таблица продаж по заказам</Button>
                    </div>
                )}
            />
            <FedTooltip title={"В строках - один заказ на одного человека (если в заказе покупка двум участникам, будет две строки). Суммы покупок в ячейках."} />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
            <Action
                readonly={false}
                auth={auth}
                action={(values, unlock, close) => {
                    close();
                }}
                modal={{
                    title: 'Первичные списки участников для VK',
                    width: "900px"
                }}
                // okText="Построить отчет"
                mode={"func"}
                trigger={(click) => (
                    <div>
                        <Button type="link" style={{ paddingRight: "0px" }} onClick={click}>Первичные списки участников для VK</Button>
                    </div>
                )}
                steps={[
                    {
                        key: "request",
                        name: "Шаг 1",
                        form: (props) => {
                            const { auth, form, submit } = props;
                            return (<Form
                                form={form}
                                onFinish={submit}
                                labelAlign={"left"}
                                layout={"vertical"}
                            >

                                <Form.Item
                                    label={"Дата последней публикации отчета"}
                                    name={"prevdate"}
                                // rules={[{ required: true, message: 'Пожалуйста, укажите дату!' }]}
                                >
                                    <DatePicker
                                        format="YYYY-MM-DD HH:mm:ss" locale={locale}
                                        showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }} />
                                </Form.Item>
                            </Form>)
                        },
                        action: (values, unlock, close) => {
                            let prevdate = dayjs(values.prevdate).format("YYYY-MM-DD HH:mm:ss")
                            POSTFormData(auth, `/api/report/register-jac-statvk/${id}`, makeFormData({ ...values, prevdate }),
                                ({ data }) => {
                                    close({ text: data });
                                },
                                (err) => errorCatch(err, () => unlock())
                            );
                        },
                    },
                    {
                        key: "view",
                        name: "Шаг 3",
                        noAntForm: true,
                        okText: "Закрыть",
                        form: (props) => {
                            let text = props?.data?.request?.text || ""
                            return (
                                <div>
                                    <div style={{ padding: "0 0 25px 0", textAlign: "right" }}>
                                        <CopyToClipboard text={text}
                                            onCopy={() => message.success("Скопировано")}>
                                            <Button>Скопировать</Button>
                                        </CopyToClipboard>
                                    </div>

                                    <div style={{ maxHeight: "600px", overflow: "auto" }}>
                                        <pre>
                                            {text}
                                        </pre>
                                    </div>
                                </div>
                            )
                        },
                    }
                ]}
            />
            <FedTooltip title={"Текст для поста в ВК о количестве участников и распределению по категориям."} />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
            <Action
                readonly={false}
                auth={auth}
                action={(values, unlock, close) => {
                    close();
                }}
                modal={{
                    title: 'Текущие списки участников для VK',
                    width: "900px"
                }}
                // okText="Построить отчет"
                mode={"func"}
                trigger={(click) => (
                    <div>
                        <Button type="link" style={{ paddingRight: "0px" }} onClick={click}>Текущие списки участников для VK</Button>
                    </div>
                )}
                steps={[
                    {
                        key: "request",
                        name: "Шаг 1",
                        form: (props) => {
                            const { auth, form, submit } = props;
                            return (<Form
                                form={form}
                                onFinish={submit}
                                labelAlign={"left"}
                                layout={"vertical"}
                            >

                                <Form.Item
                                    label={"Дата последней публикации отчета"}
                                    name={"prevdate"}
                                // rules={[{ required: true, message: 'Пожалуйста, укажите дату!' }]}
                                >
                                    <DatePicker
                                        format="YYYY-MM-DD HH:mm:ss" locale={locale}
                                        showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }} />
                                </Form.Item>
                            </Form>)
                        },
                        action: (values, unlock, close) => {
                            let prevdate = dayjs(values.prevdate).format("YYYY-MM-DD HH:mm:ss")
                            POSTFormData(auth, `/api/report/register-jac-statvk-by-dancer-event/${id}`, makeFormData({ ...values, prevdate }),
                                ({ data }) => {
                                    close({ text: data });
                                },
                                (err) => errorCatch(err, () => unlock())
                            );
                        },
                    },
                    {
                        key: "view",
                        name: "Шаг 3",
                        noAntForm: true,
                        okText: "Закрыть",
                        form: (props) => {
                            let text = props?.data?.request?.text || ""
                            return (
                                <div>
                                    <div style={{ padding: "0 0 25px 0", textAlign: "right" }}>
                                        <CopyToClipboard text={text}
                                            onCopy={() => message.success("Скопировано")}>
                                            <Button>Скопировать</Button>
                                        </CopyToClipboard>
                                    </div>

                                    <div style={{ maxHeight: "600px", overflow: "auto" }}>
                                        <pre>
                                            {text}
                                        </pre>
                                    </div>
                                </div>
                            )
                        },
                    }
                ]}
            />
            <FedTooltip title={"Текст для поста в ВК о количестве участников и распределению по категориям."} />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
            <Action
                auth={auth}
                action={(values, unlock, close) => {
                    setLoading(true);
                    auth.fetch(`/api/sudifederatsii/clear-effektivnost-sudei/${id}`).then(function (res) {
                        if (res?.errorList?.length) {
                            setErrorList(res.errorList)
                        } else {
                            setErrorList([])
                        }
                        if (res && res.status === true) {
                            message.success('Готово');
                        } else if (res && res.status === false) {
                            message.error(res.message)
                        }
                        setLoading(false);
                    })
                }}
                mode={"func"}
                trigger={(click) => (
                    <div>
                        <Button loading={loading} style={{ paddingRight: "0px" }} type="link" onClick={click}>Очистить эффективность судей</Button>
                    </div>
                )}
            />
            <FedTooltip title={"Очистить эффективность судей"} />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
            <Action
                auth={auth}
                action={(values, unlock, close) => {
                    setLoading(true);
                    auth.fetch(`/api/sudifederatsii/calc-effektivnost-sudei/${id}`).then(function (res) {
                        if (res?.errorList?.length) {
                            setErrorList(res.errorList)
                        } else {
                            setErrorList([])
                        }
                        if (res && res.status === true) {
                            message.success('Готово');
                        } else if (res && res.status === false) {
                            message.error(res.message)
                        }
                        setLoading(false);
                    })
                }}
                mode={"func"}
                trigger={(click) => (
                    <div>
                        <Button loading={loading} style={{ paddingRight: "0px" }} type="link" onClick={click}>Рассчитать эффективность судей</Button>
                    </div>
                )}
            />
            <FedTooltip title={"Рассчитать эффективность судей"} />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
            <Action
                auth={auth}
                action={(values, unlock, close) => {
                    close();
                    goTo(`/app/reports/effektivnost-sudei/event/${id}`)
                }}

                mode={"func"}
                trigger={(click) => (
                    <div>
                        <Button loading={loading} style={{ paddingRight: "0px" }} type="link" onClick={click}>Эффективность судей</Button>
                    </div>
                )}
            />
            <FedTooltip title={"Эффективность судей"} />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
            <Action
                auth={auth}
                action={(values, unlock, close) => {
                    close();
                    goTo(`/app/reports/predvzyatost-sudi/period`)
                }}

                mode={"func"}
                trigger={(click) => (
                    <div>
                        <Button loading={loading} style={{ paddingRight: "0px" }} type="link" onClick={click}>Предвзятость судей</Button>
                    </div>
                )}
            />
            <FedTooltip title={"Предвзятость судей"} />
        </div>
        {(isAnyFederationAdministrator(user)) && <div>
            <hr />
            <div style={{ display: "flex", alignItems: "center" }}>
                <Action
                    auth={auth}
                    mode={"func"}
                    trigger={(click) => (
                        <div>
                            <Button loading={loading} style={{ paddingRight: "0px" }} type="link" onClick={click}>Результаты</Button>
                        </div>
                    )}
                    title="Результаты"
                    readonly={true}
                    noAntForm={true}
                    titles={{
                        subheader: <div style={{ paddingBottom: "15px" }}><div style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.45)" }}>
                            {event?.nazvanieMeropriyatiya} - {dayjs(event?.nachaloSorevnovaniya).format("DD.MM.YYYY")},  {_.get(event, "mestoProvedeniya.name")}
                        </div></div>
                    }}
                    modal={{
                        width: "940px",
                    }}
                    object={event}
                    form={RezultatiPoMeropriyatiu}
                    action={(values, unlock, close, { collection, setCollection }) => { }}
                />
                <FedTooltip title={"Результаты"} />
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
                <Action
                    auth={auth}
                    action={(values, unlock, close) => {
                        setLoading(true);
                        auth.fetchFile(`/api/rezultati-final/${id}`)
                            .then(async (res) => {
                                setLoading(false);
                                // close();
                            });
                    }}
                    mode={"func"}
                    trigger={(click) => (
                        <div>
                            <Button loading={loading} style={{ paddingRight: "0px" }} type="link" onClick={click}>Результаты для финала (зеленая таблица)</Button>
                        </div>
                    )}
                />
                <FedTooltip title={"Результаты для финала (зеленая таблица)"} />
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
                <Action
                    auth={auth}
                    action={(values, unlock, close) => {
                        setLoading(true);
                        GET(auth, `/api/save-rezultati-final/${id}`, ({ data, errorList, _message, status }) => {
                            message.success('Готово');
                            setLoading(false);
                        }, (err) => errorCatch(err, () => { setLoading(false); unlock(); }))
                    }}
                    mode={"func"}
                    trigger={(click) => (
                        <div>
                            <Button loading={loading} style={{ paddingRight: "0px" }} type="link" onClick={click}>Рассчитать результаты для финала</Button>
                        </div>
                    )}
                />
                <FedTooltip title={"Рассчитать результаты для финала"} />
            </div>
            <div className='bg bg-grey border-grey' style={{ textAlign: 'left' }}>
                <Action
                    key={uuid()}
                    auth={auth}
                    action={(values, unlock, close) => {
                        Modal.confirm({
                            title: (!event?.ignorirovatVAbsolyutnomReitinge) ? "Запретить расчет рейтинга по мероприятию?" : "Разрешить по мероприятию расчет рейтинга?",
                            icon: <ExclamationCircleOutlined />,
                            content: (<div>
                                {(!event?.ignorirovatVAbsolyutnomReitinge) && <div>Результаты танцоров мероприятия не будут участвовать при расчете относительного рейтинга</div>}
                                {(!!event?.ignorirovatVAbsolyutnomReitinge) && <div>Результаты танцоров мероприятия будут участвовать при расчете относительного рейтинга</div>}
                            </div>),
                            okText: "Да",
                            okType: 'danger',
                            cancelText: "Нет",
                            onOk: () => {
                                setLoading(true);
                                auth.fetch(`/api/meropriyatiya/set-ignorirovat-v-absolyutnom-reitinge/${id}/${event?.ignorirovatVAbsolyutnomReitinge ? 0 : 1}`).then(function (res) {
                                    if (res && res.status === true) {
                                        if (res?.data) {
                                            setEvent(res.data)
                                        }
                                        message.success('Готово');
                                    } else if (res && res.status === false) {
                                        message.error(res.message)
                                    }
                                    setLoading(false);
                                })
                            },
                        });
                    }}
                    mode={"func"}
                    trigger={(click) => (
                        <div>
                            {(!event?.ignorirovatVAbsolyutnomReitinge) &&
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: "10px 15px" }}>
                                    <div style={{ color: '#077c76' }}>Мероприятие участвует при расчете абсолютного рейтинга</div>
                                    <Button loading={loading} danger type="default" onClick={click}>Исключить</Button>
                                </div>}
                            {(!!event?.ignorirovatVAbsolyutnomReitinge) &&
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: "10px 15px" }}>
                                    <div style={{ color: 'rgb(246, 33, 75)' }}>Мероприятие не участвует при расчете абсолютного рейтинга</div>
                                    <Button loading={loading} type="primary" ghost onClick={click}>Включить</Button>
                                </div>}
                        </div>
                    )}
                />
                <Action
                    auth={auth}
                    action={(values, unlock, close) => {
                        setLoading(true);
                        auth.fetch(`/api/rating-event/calc-by-meropriyatie/${id}`).then(function (res) {
                            if (res?.errorList?.length) {
                                setErrorList(res.errorList)
                            } else {
                                setErrorList([])
                            }
                            if (res && res.status === true) {
                                message.success('Готово');
                            } else if (res && res.status === false) {
                                message.error(res.message)
                            }
                            setLoading(false);
                        })
                        // GET(auth,`/api/rating-event/calc-by-meropriyatie/${id}`,({data, errorList, message, status})=>{
                        //     message.success('Готово');
                        // }, errorCatch)
                    }}
                    mode={"func"}
                    trigger={(click) => (
                        <div>
                            <Button loading={loading} style={{ paddingRight: "0px" }} type="link" onClick={click}>Рассчитать относительный рейтинг</Button>
                        </div>
                    )}
                />
                <Action
                    auth={auth}
                    action={(values, unlock, close) => {
                        Modal.confirm({
                            title: `Удалить относительный рейтинг`,
                            icon: <ExclamationCircleOutlined />,
                            content: (<div>
                                <div>Вы уверены что хотите удалить относительный рейтинг танцоров мероприятия?</div>
                            </div>),
                            okText: "Да",
                            okType: 'danger',
                            cancelText: "Нет",
                            onOk: () => {
                                setLoading(true);
                                auth.fetch(`/api/rating-event/drop-rating-by-meropriyatie/${id}`).then(function (res) {
                                    if (res?.errorList?.length) {
                                        setErrorList(res.errorList)
                                    } else {
                                        setErrorList([])
                                    }
                                    if (res && res.status === true) {
                                        message.success('Готово');
                                    } else if (res && res.status === false) {
                                        message.error(res.message)
                                    }
                                    setLoading(false);
                                })
                            },
                        });
                    }}
                    mode={"func"}
                    trigger={(click) => (
                        <div>
                            <Button loading={loading} style={{ paddingRight: "0px" }} type="link" onClick={click}>Удалить относительный рейтинг</Button>
                        </div>
                    )}
                />
                <Action
                    auth={auth}
                    action={(values, unlock, close) => {
                        setLoading(true);
                        auth.fetchFile(`/api/rating-event/report-by-meropriyatie/${id}`)
                            .then(async (res) => {
                                setLoading(false);
                                // close();
                            });
                    }}
                    mode={"func"}
                    trigger={(click) => (
                        <div>
                            <Button loading={loading} style={{ paddingRight: "0px" }} type="link" onClick={click}>Отчет по относительному рейтингу</Button>
                        </div>
                    )}
                />
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
                <Action
                    auth={auth}
                    action={(values, unlock, close) => {
                        setLoading(true);
                        auth.fetchFile(`/api/rezultati-final-rassilki/${id}`)
                            .then(async (res) => {
                                setLoading(false);
                                // close();
                            });
                    }}
                    mode={"func"}
                    trigger={(click) => (
                        <div>
                            <Button loading={loading} style={{ paddingRight: "0px" }} type="link" onClick={click}>Результаты финала для рассылок</Button>
                        </div>
                    )}
                />
                <FedTooltip title={"Результаты финала для рассылок"} />
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
                <Action
                    auth={auth}
                    action={(values, unlock, close) => {
                        setLoading(true);
                        GET(auth, `/api/rating-period/raschet-reitingovih-ochkov-polzovateley/${id}`, ({ msgList, haveBeenChanges, status }) => {
                            if (msgList?.length) {
                                setWarnings({
                                    title: (!haveBeenChanges) ? 'Выполнение процедуры не привело к изменениям данных!' : '',
                                    list: msgList
                                })
                            } else {
                                setWarnings(undefined)
                            }
                            if (!haveBeenChanges) {
                                message.warning('Ничего не изменилось');
                            } else {
                                message.success('Готово');
                            }

                            setLoading(false);
                        }, (err) => errorCatch(err, () => { setLoading(false); unlock(); }))
                    }}
                    mode={"func"}
                    trigger={(click) => (
                        <div>
                            <Button loading={loading} style={{ paddingRight: "0px" }} type="link" onClick={click}>Рассчитать очки для абсолютного рейтинга</Button>
                        </div>
                    )}
                />
                <FedTooltip title={"Рассчитать очки для абсолютного рейтинга"} />
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
                <Action
                    auth={auth}
                    action={(values, unlock, close) => {
                        setLoading(true);
                        auth.fetchFile(`/api/rating-period/report/raschet-reitingovih-ochkov-polzovateley/${id}`)
                            .then(async (res) => {
                                setLoading(false);
                                // close();
                            });
                    }}
                    mode={"func"}
                    trigger={(click) => (
                        <div>
                            <Button loading={loading} style={{ paddingRight: "0px" }} type="link" onClick={click}>Вывести очки для абсолютного рейтинга</Button>
                        </div>
                    )}
                />
                <FedTooltip title={"Вывести очки для абсолютного рейтинга"} />
            </div>
            {(warnings?.title || warnings?.list?.length > 0) &&
                <Alert
                    key="1"
                    message="Предупреждение"
                    description={<div style={{ fontSize: "13px", }}>
                        {(warnings?.title) && <div style={{ marginBottom: "10px", fontWeight: "bold", color: "#b16767" }}>{warnings?.title}</div>}

                        {(warnings?.list?.length > 0) && <div><div style={{ fontWeight: "bold" }}>Список предупреждений: </div>
                            <div style={{ marginLeft: "10px" }}>
                                {JSXMap(warnings?.list, (item, idx) => {
                                    return (<div key={idx}>
                                        [{idx + 1}] {item}
                                    </div>)
                                })}
                            </div>
                        </div>}</div>}
                    type="warning"
                    showIcon
                    closable
                    onClose={() => { setWarnings(undefined) }}
                />
            }
            {(errorList?.length > 0) && <Collapse style={{ marginBottom: "15px", backgroundColor: "#ffa2a2" }} items={[{
                key: '1',
                label: 'Ошибки',
                children: <div style={{ color: "red", fontSize: "13px", }}>
                    {JSXMap(errorList, (item, idx) => {
                        return (<div key={idx}>
                            [{idx + 1}] {item}
                        </div>)
                    })}</div>,
            }]} defaultActiveKey={['1']} />}
        </div>}
        <Collapse
            bordered={false}
            // defaultActiveKey={['1']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            style={{
                background: token.colorBgContainer,
            }}
            ghost items={[
                {
                    key: '1',
                    label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Журнал проведения трансляции</div>,
                    children: <div>
                        {(event?.ID) && <StreamLogBlock {...props}
                            sourceKey={sourceKey}
                            event={event}
                        />}
                    </div>,
                },
                {
                    key: '2',
                    label: <div className="bg bg-grey" style={{ textAlign: "left", padding: "3px 5px", marginBottom: "5px", fontWeight: "600", fontSize: "14px" }}>Отчет судейского комитета</div>,
                    children: <OtchetSudeiskogoKomiteta auth={auth} eventID={event?.ID} />,
                },
            ]} />
    </div>
}

const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
};
const beforeUpload = file => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
};

export default function EventsByIDBlock(props) {
    const { id, auth, sourceKey } = props;
    const [event, setEvent] = useState(undefined);
    useEffect(() => {
        GET(auth, `/api/meropriyatiya/list/${sourceKey}?detail=model&w-id=${id}`,
            ({ data }) => {
                if (data && data.length) {
                    setEvent(data[0]);
                }
            }, errorCatch);
    }, [])
    const syncEvent = useCallback(() => {
        confirmKey({
            pass: 'K9c107',
            title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Сихронизтровать мероприятие</span>,
            icon: undefined,
            content: <div>
                <div><span>Вы действительно хотите сихронизтровать мероприятие?</span></div>
                <div><span style={{ fontSize: "12px", fontWeight: "lighter" }}>Функция синхронизации устарела и мероприятие должно корректно работать без её вызова. Пожалуйста убедитесь, что вы полностью уверены в необходимости вызова синхронизации.</span></div>
            </div>,
            okText: 'Да',
            cancelText: 'Отмена',
            onOk() {
                return new Promise((resolve, reject) => {
                    GET(auth, '/api/meropriyatiya/sync/' + event.ID,
                        ({ data }) => {
                            message.success('Готово');
                            resolve(data);
                        }, (err) => errorCatch(err, reject));
                }).catch(() => { });
            },
            onCancel() {
            },
        })
    }, [event])
    const deleteEvent = useCallback(() => confirmKey({
        pass: '123',
        title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить мероприятие</span>,
        icon: undefined,
        content: <span>Вы действительно хотите удалить мероприятие?</span>,
        okText: 'Удалить',
        cancelText: 'Отмена',
        onOk() {
            return new Promise((resolve, reject) => {
                GET(auth, '/api/meropriyatiya/delete/' + event?.ID,
                    ({ data }) => {
                        // setCollection(deleteInArray(collection, item));
                        resolve(data);
                    }, (err) => errorCatch(err, reject));
            }).catch(() => { });
        },
        onCancel() {
        },
    }), [event])
    const finishEvent = useCallback(() => {
        Modal.confirm({
            title: 'Завершить мероприятие?',
            icon: <ExclamationCircleOutlined />,
            content: 'Будут выполнены поставки партнерам. Возвраты по билетам будут невозможны.',
            okText: "Да",
            cancelText: "Нет",
            onOk: () => {
                if (!event) return;
                GET(auth, '/api/meropriyatiya/close/' + event?.ID,
                    ({ data }) => {
                        setEvent(data)
                        // dispatch(REDUX_Meropriyatiya.actions.updateArrayByKey(sourceKey, [data]));
                    },
                    errorCatch
                );
            },
        });
    }, [event])
    const updateEvent = useCallback((values, unlock, close) => {
        POST(auth, '/api/meropriyatiya/updatemeropriyatie',
            {
                ...event,
                ...values,
                ID: (event) ? event.ID : undefined,
                // tipMeropriyatiyaID: (event) ? event.tipMeropriyatiyaID : undefined,
            },
            ({ data }) => {
                setEvent(data);
                if (unlock) {
                    unlock();
                }
            },
            (err) => errorCatch(err, unlock)
        );
    }, [event])
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);
    const eventPoster = (event) => {
        if (event?.ssilkiNaFailiMeropriyatie) {
            const img = event?.ssilkiNaFailiMeropriyatie?.find(x => x.tipSsilkiID === 7);
            if (img) {
                return {
                    imageUrl: ycStorage(auth) + ycBucket(auth) + "/" + img.ssilka,
                    image: img,
                };
            }
        }
        return { imageUrl: undefined, image: null };
    }

    const deleteFile = (file) => {
        if (!file?.ID) return;
        setLoading(true);
        GET(auth, "/api/meropriyatiya/file/delete/" + file?.ID,
            () => {
                updateEvent({
                    ...event,
                    ssilkiNaFailiMeropriyatie: deleteInArray(event.ssilkiNaFailiMeropriyatie, file)
                }, () => { setLoading(false) })
            },
            (err) => errorCatch(err, () => { setLoading(false) }));
    };
    const createFile = (values) => {
        //отправить новый файл
        setLoading(true);
        POSTFormData(auth, "/api/meropriyatiya/upload", makeFormData(values),
            ({ data }) => {
                if (data) {
                    var kat = (event.ssilkiNaFailiMeropriyatie) ? [...event.ssilkiNaFailiMeropriyatie] : [];
                    var ok = false;
                    if (kat) {
                        for (let i = 0; i < kat.length; i++) {
                            const k = kat[i];
                            if (k.ID === data.ID) {
                                kat[i] = data;
                                ok = true;
                            }
                        }
                    }
                    if (!ok) {
                        kat.push(data);
                    }
                    updateEvent({
                        ...event,
                        ssilkiNaFailiMeropriyatie: kat
                    }, () => { setLoading(false) });
                }
            }, (err) => errorCatch(err, () => { setLoading(false) }));
    };
    const { imageUrl, image } = eventPoster(event);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const handleRemove = async file => {
        Modal.confirm({
            title: `Вы уверены что хотите удалить главную афишу?`,
            icon: <ExclamationCircleOutlined />,
            // content: <span>{item.opisanie}</span>,
            okText: "Да",
            okType: 'danger',
            cancelText: "Нет",
            onOk: () => {
                deleteFile(image);
            },
        });

        return false;
    }
    const handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };
    const handleBeforeUpload = (file) => {
        createFile({
            "meropriyatieID": event?.ID,
            "nazvanie": "Главная афиша",
            "tipSsilkiID": 7,
            "file": [file]
        })
        // }
        return false;
    }
    return (
        <div style={{ backgroundColor: "white", padding: "0 15px", borderRadius: "4px" }}>
            <div style={{ textAlign: "center", padding: "26px" }}>
                <div style={{ fontSize: "18px", fontWeight: "100" }}>Мероприятие</div>
                <div style={{ fontSize: "29px", fontWeight: "600", lineHeight: "36px" }}>{event?.nazvanieMeropriyatiya}</div>
                <div style={{ fontSize: "25px", fontWeight: "600", lineHeight: "30px" }}>г. {event?.mestoProvedeniya?.name}</div>
            </div>
            <div style={{ padding: "15px 0px", display: "flex", gap: "15px" }}>
                <div style={{ flex: "0 0 210px", maxWidth: "210px" }}>
                    <div className='event-poster210' style={{ width: "210px", height: "210px", overflow: "hidden", borderRadius: "6px" }}>
                        {(loading) && <Spin style={{
                            width: "210px", height: "210px", display: "flex", justifyContent: "center", alignItems: "center",
                            backgroundColor: "rgba(0, 0, 0, 0.02)", border: "1px dashed #d9d9d9", borderRadius: "8px"
                        }}
                            indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />}
                        {(!loading) && <div><Upload
                            name='file'
                            maxCount={1}
                            listType="picture-card"
                            fileList={(imageUrl) ? [{
                                uid: '-1',
                                ID: image?.ID,
                                status: 'done',
                                // status: 'uploading',
                                url: imageUrl,
                            }] : undefined}
                            multiple={false}
                            onRemove={handleRemove}
                            onPreview={handlePreview}
                            // onChange={handleChange}
                            beforeUpload={handleBeforeUpload}
                        >
                            {imageUrl ? null : <button style={{ border: 0, background: 'none', width: '100%' }} type="button">
                                {loading ? <LoadingOutlined /> : <PlusOutlined />}
                                <div style={{ marginTop: 8 }}>Загрузить главную афишу</div>
                            </button>}
                        </Upload>
                            {(previewImage) && (
                                <Image
                                    wrapperStyle={{ display: 'none' }}
                                    preview={{
                                        visible: previewOpen,
                                        onVisibleChange: visible => setPreviewOpen(visible),
                                        afterOpenChange: visible => !visible && setPreviewImage(''),
                                    }}
                                    src={previewImage}
                                />
                            )}
                        </div>}
                    </div>
                    {/* <div style={{ width: "210px", height: "210px", overflow: "hidden", borderRadius: "6px" }}>
                        <YImage item={event} width={210} />
                    </div> */}
                    <div style={{ marginTop: "7px" }}>
                        <div style={{
                            backgroundColor: "#eaeaea",
                            fontSize: "16px",
                            fontWeight: "400",
                            color: "black",
                            borderRadius: "6px",
                            textAlign: "center",
                            padding: "0 7px",
                            textAlign: "center",
                        }}>
                            <div style={{
                                borderRadius: "5px",
                                backgroundColor: "#f6214b",
                                fontSize: "12px",
                                fontWeight: "600",
                                color: "white",
                                margin: "0 -7px",
                                boxShadow: "0px 6px 5px -5px rgb(34 60 80 / 60%",
                                padding: "3px 7px"
                            }}>
                                {dayjs(event?.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}
                            </div>
                            <div style={{
                                fontSize: "10px",
                                fontWeight: "400",
                                padding: "0px"
                            }}>
                                {dayjs(event?.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
                            </div>
                        </div>
                    </div>

                    <div>
                        {/* <div>
                            <div style={{ fontWeight: "600", fontSize: "14px" }}>Серии: </div>
                            {(event?.meropriyatieVSeriiMeropriyatie?.length > 0) && <ul className="dotted">
                                {JSXMap(event?.meropriyatieVSeriiMeropriyatie, (meropriyatieVSerii, idx) => (<li>
                                    <a href={`/${sourceKey}/serie/${meropriyatieVSerii?.seriya?.ID}`}>{meropriyatieVSerii?.seriya?.nazvanie}, сезон {meropriyatieVSerii?.seriya?.sezon?.nazvanie}, этап {meropriyatieVSerii?.etap}</a>
                                </li>))}
                            </ul>}
                        </div> */}

                        {(dayjs().isBetween(event?.nachaloRegistratsii, event?.okonchanieSorevnovaniya, 'minute', '[]')) && <div style={{ marginTop: "5px" }}>
                            <a
                                style={{ width: "100%", minWidth: "92px", fontSize: "14px" }}
                                className={`btn btn-primary btn-sm`}
                                href={`/app/pay/${event?.ID}`}
                                target="_blank"
                                rel="noreferrer noopener">Купить билет</a>
                        </div>}
                        <div style={{ marginTop: "5px" }}>
                            <a
                                style={{ marginTop: "5px", width: "100%", fontSize: "14px" }} className="btn btn-success btn-sm"
                                href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch/${event?.ID}`} target="_blank" rel="noreferrer noopener">
                                Войти в мероприятие
                            </a>
                        </div>

                        {eventRoleControler(event) &&
                            <div style={{ marginTop: "5px" }}>
                                <a
                                    style={{ marginTop: "5px", width: "100%", fontSize: "14px" }} className="btn btn-soft-secondary btn-sm"
                                    href={`/app/checkticket/${event?.ID}`} target="_blank" rel="noreferrer noopener">
                                    Проверка билетов
                                </a>
                            </div>}

                        <div style={{ marginTop: "5px" }}>
                            <a
                                style={{ marginTop: "5px", width: "100%", fontSize: "14px" }} className="btn btn-outline-secondary btn-sm"
                                href={"/app/common/events/" + ((event) ? event.ID : undefined) + "/avatartemplate"} rel="noreferrer noopener">
                                Шаблон аватарки
                            </a>
                        </div>
                        {IfElse((event?.avatarTemplateMeropriyatie && event?.avatarTemplateMeropriyatie?.length),
                            (<div style={{ marginTop: "5px" }}>
                                <a
                                    style={{ marginTop: "5px", width: "100%", fontSize: "14px" }} className="btn btn-outline-secondary btn-sm"
                                    href={`/app/common/events/${event?.ID}/avatar`} rel="noreferrer noopener">
                                    Аватарка "по-быстрому"
                                </a>
                            </div>), <></>)}

                        {IfElse(dayjs(event?.nachaloSorevnovaniya).isBefore(dayjs()),
                            (<div style={{ marginTop: "5px" }}>
                                <a
                                    style={{ marginTop: "5px", width: "100%", fontSize: "14px" }} className="btn btn-outline-secondary btn-sm"
                                    href={`/app/event/${event?.ID}/myresult`} rel="noreferrer noopener">
                                    Мои оценки
                                </a>
                            </div>), <></>)}
                        <div style={{ marginTop: "5px" }}>
                            <div
                                onClick={syncEvent}
                                style={{ marginTop: "5px", width: "100%", fontSize: "14px" }} className="btn btn-outline-warning btn-sm">
                                Синхронизировать
                            </div>
                        </div>
                        {IfElse((dayjs().isAfter(event?.okonchanieSorevnovaniya) && event?.tekushchiiStatusMeropriyatiyaID != 5),
                            <div style={{ marginTop: "5px" }}>
                                <div
                                    onClick={finishEvent}
                                    style={{ marginTop: "5px", width: "100%", fontSize: "14px" }} className="btn btn-soft-danger btn-sm">
                                    Завершить мероприятие
                                </div>
                            </div>, <></>)}

                        <div style={{ marginTop: "5px" }}>
                            <div
                                onClick={deleteEvent}
                                style={{ marginTop: "5px", width: "100%", fontSize: "14px" }} className="btn btn-danger btn-sm">
                                Удалить мероприятие
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ flex: "1 1 auto", overflowX: "auto" }}>
                    <Tabs defaultActiveKey="1" style={{ width: "100%" }}
                        items={[
                            {
                                key: '1',
                                label: `Параметры`,
                                children: <EventParameters auth={auth} sourceKey={sourceKey} form={form} event={event} updateEvent={updateEvent} id={id} />,
                            },
                            {
                                key: '2',
                                label: `Позиции`,
                                children: <Yacheiki auth={auth} sourceKey={sourceKey} form={form} event={event} updateEvent={updateEvent} id={id} />,
                            },
                            {
                                key: '3',
                                label: `Услуги/Тарифы`,
                                children: <EventServices auth={auth} sourceKey={sourceKey} form={form} event={event} updateEvent={updateEvent} id={id} />,
                            },
                            {
                                key: '4',
                                label: `Персонал`,
                                children: <EventActors auth={auth} sourceKey={sourceKey} form={form} event={event} updateEvent={updateEvent} id={id} />,
                            },
                            {
                                key: "5",
                                label: "Тексты",
                                children: <EventTexts auth={auth} sourceKey={sourceKey} form={form} event={event} updateEvent={updateEvent} id={id} />,
                            },
                            {
                                key: '6',
                                label: `Реклама`,
                                children: <EventAd auth={auth} sourceKey={sourceKey} form={form} event={event} updateEvent={updateEvent} id={id} />,
                            },
                            // {
                            //     key: "7",
                            //     label: "Гонорары/агентские",
                            //     children: <EventGonorar auth={auth} sourceKey={sourceKey} form={form} event={event} updateEvent={updateEvent} id={id} />,
                            // },
                            {
                                key: '8',
                                label: `Промокоды`,
                                children: <Promokodi auth={auth} sourceKey={sourceKey} form={form} event={event} updateEvent={updateEvent} id={id} />,
                            },
                            // {
                            //     key: '9',
                            //     label: `Комиссии партнерам`,
                            //     children: <Comission auth={auth} sourceKey={sourceKey} form={form} event={event} updateEvent={updateEvent} id={id} />,
                            // },
                            {
                                key: '10',
                                label: `Отчеты`,
                                children: <EventReports auth={auth} sourceKey={sourceKey} form={form} event={event} updateEvent={updateEvent} setEvent={setEvent} id={id} />,
                            },
                            // {
                            //     key: '11',
                            //     label: "Покупки",//`Оплаты/Поставки`,
                            //     children: <div>
                            //         <EventOrders auth={auth} sourceKey={sourceKey} form={form} event={event} updateEvent={updateEvent} id={id} />
                            //     </div>,
                            // },
                            {
                                key: '12',
                                label: `Гонорары`,
                                children: <Gonorar auth={auth} sourceKey={sourceKey} form={form} event={event} updateEvent={updateEvent} id={id} />,
                            },
                            {
                                key: '13',
                                label: `Настройка агентских `,
                                children: <PromoterParameters auth={auth} sourceKey={sourceKey} form={form} event={event} updateEvent={updateEvent} id={id} />,
                            },
                        ]}
                        onChange={(key) => {
                            // console.log(key);
                        }}
                    />
                </div>
            </div>
            {/* {event && <EventOrders auth={auth} sourceKey={sourceKey} form={form} event={event} id={id} />} */}
        </div >
    );
}
